import "./luna-vue-ui.css";
import { inject as Fe, defineComponent as re, useAttrs as Zt, computed as w, openBlock as l, createBlock as _, resolveDynamicComponent as pt, mergeProps as We, createCommentVNode as k, useSlots as Gt, createElementBlock as s, normalizeClass as E, renderSlot as K, toDisplayString as I, ref as A, onBeforeUnmount as ct, Transition as $e, withCtx as ie, createVNode as U, createElementVNode as i, createTextVNode as Be, watch as be, nextTick as we, onUnmounted as Ie, Teleport as De, normalizeStyle as oe, withModifiers as ve, Fragment as le, renderList as de, createSlots as At, useId as Jt, unref as te, withDirectives as xt, vModelText as Rt, onMounted as wt, toValue as Ye, toRef as ft, provide as st, TransitionGroup as Je, vShow as Qt, withKeys as Ct, resolveComponent as _t, shallowRef as ea } from "vue";
import { X as ta, RotateCcw as aa, Trash2 as la, Star as na, Search as ra, Save as sa, Plus as oa, Pencil as ia, Minimize2 as ua, Maximize2 as da, Loader2 as ca, List as fa, Lightbulb as ma, Inbox as va, Info as ba, HelpCircle as ga, FolderTree as ha, Database as ya, ChevronsRight as pa, ChevronsLeft as xa, ChevronRight as wa, ChevronLeft as ka, ChevronDown as $a, CheckCircle2 as Ca, Check as La, ArrowLeft as Sa, Archive as za, AlertTriangle as Ba, AlertCircle as Ta, RotateCw as Ht, LoaderCircle as Ma, EyeOff as Ea, Eye as Ia } from "lucide-vue-next";
const Wt = /* @__PURE__ */ Symbol.for("lunagoai.vue-ui.iconRegistry"), Va = {
  AlertCircle: Ta,
  AlertTriangle: Ba,
  Archive: za,
  ArrowLeft: Sa,
  Check: La,
  CheckCircle2: Ca,
  ChevronDown: $a,
  ChevronLeft: ka,
  ChevronRight: wa,
  ChevronsLeft: xa,
  ChevronsRight: pa,
  Database: ya,
  FolderTree: ha,
  HelpCircle: ga,
  Info: ba,
  Inbox: va,
  Lightbulb: ma,
  List: fa,
  Loader2: ca,
  Maximize2: da,
  Minimize2: ua,
  Pencil: ia,
  Plus: oa,
  Save: sa,
  Search: ra,
  Star: na,
  Trash2: la,
  RotateCcw: aa,
  X: ta
};
function dt(e) {
  return e.split(/[-_\s]+/).filter(Boolean).map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join("");
}
function Ot(e = {}) {
  const n = {
    custom: /* @__PURE__ */ new Map(),
    defaults: /* @__PURE__ */ new Map()
  };
  for (const [a, t] of Object.entries(Va))
    n.defaults.set(a, t), n.defaults.set(dt(a), t);
  return Pa(e, n), n;
}
const rt = Ot();
function Da(e, n, a = rt) {
  a.custom.set(e, n), a.custom.set(dt(e), n);
}
function Pa(e, n = rt) {
  for (const [a, t] of Object.entries(e))
    Da(a, t, n);
}
function Aa(e, n = rt) {
  return n.custom.get(e) ?? n.custom.get(dt(e)) ?? n.defaults.get(e) ?? n.defaults.get(dt(e)) ?? null;
}
function gi() {
  rt.custom.clear();
}
function Ra() {
  return Fe(Wt, rt);
}
const Ha = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BaseIcon",
  props: {
    name: {},
    size: { default: 16 },
    color: {},
    strokeWidth: { default: 2 },
    label: {},
    decorative: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const n = e, a = Zt(), t = Ra(), r = w(() => {
      if (!n.name) return null;
      if (typeof n.name != "string") return n.name;
      const c = n.name.split(/[-_\s]+/).filter(Boolean).map((f) => f.charAt(0).toUpperCase() + f.slice(1)).join("");
      return Aa(c, t);
    }), o = w(() => {
      const c = !!(n.label || a["aria-label"]);
      return {
        ...a,
        "aria-label": n.label ?? a["aria-label"],
        "aria-hidden": n.decorative === !0 || !c && a["aria-hidden"] === void 0 ? "true" : a["aria-hidden"],
        role: c ? a.role ?? "img" : a.role
      };
    });
    return (c, f) => r.value ? (l(), _(pt(r.value), We({
      key: 0,
      size: e.size,
      color: e.color,
      "stroke-width": e.strokeWidth
    }, o.value, { class: "luna-icon" }), null, 16, ["size", "color", "stroke-width"])) : k("", !0);
  }
}), ge = (e, n) => {
  const a = e.__vccOpts || e;
  for (const [t, r] of n)
    a[t] = r;
  return a;
}, X = /* @__PURE__ */ ge(Ha, [["__scopeId", "data-v-7dcfc498"]]), Wa = ["type", "data-variant", "disabled", "aria-busy", "aria-label"], Oa = { key: 3 }, ja = /* @__PURE__ */ re({
  __name: "BaseButton",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = Gt(), o = w(() => (a.icon || a.loading) && !a.label && !r.default), c = w(() => a.display === "grid" ? "grid" : a.display === "flex" ? "flex items-center" : "inline-flex items-center"), f = w(
      () => [
        "font-semibold transition-all duration-200 outline-none cursor-pointer",
        "focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-60 disabled:cursor-not-allowed",
        "active:scale-95 whitespace-nowrap",
        a.rounded ? "rounded-full" : "rounded-lg"
      ].join(" ")
    ), u = w(() => a.display === "grid" ? a.align === "start" ? "place-items-start" : a.align === "end" ? "place-items-end" : "place-items-center" : a.align === "start" ? "justify-start" : a.align === "end" ? "justify-end" : "justify-center"), b = w(() => {
      switch (a.variant) {
        case "primary":
          return "bg-primary text-white hover:bg-primary-hover shadow-md shadow-primary/20 focus:ring-primary/50 border border-transparent";
        case "primary-glass":
          return "bg-primary/10 text-primary-400 hover:bg-primary/20 hover:text-primary-300 ring-1 ring-inset ring-primary-400/10 border-transparent focus:ring-primary-500/50";
        case "secondary":
          return "bg-surface-muted text-ui-muted hover:bg-surface-elevated border border-ui focus:ring-ui-focus";
        case "danger":
          return "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/40 border border-red-100 dark:border-red-900/30 focus:ring-red-200 dark:focus:ring-red-800";
        case "danger-solid":
          return "bg-red-600 text-white hover:bg-red-700 shadow-sm shadow-red-900/20 focus:ring-red-500 border border-transparent";
        case "danger-glass":
          return "bg-red-500/15 text-red-400 hover:bg-red-500/25 hover:text-red-300 ring-1 ring-inset ring-red-400/10 border-transparent focus:ring-red-500/50";
        case "success":
          return "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 border border-emerald-100 dark:border-emerald-900/30 focus:ring-emerald-200 dark:focus:ring-emerald-800";
        case "success-solid":
          return "bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm shadow-emerald-900/20 focus:ring-emerald-500 border border-transparent";
        case "info":
          return "bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-100 dark:border-blue-900/30 focus:ring-blue-200 dark:focus:ring-blue-800";
        case "info-solid":
          return "bg-blue-600 text-white hover:bg-blue-700 shadow-sm shadow-blue-900/20 focus:ring-blue-500 border border-transparent";
        case "warning":
          return "bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/40 border border-amber-100 dark:border-amber-900/30 focus:ring-amber-200 dark:focus:ring-amber-800";
        case "outline":
          return "bg-transparent border border-primary text-primary hover:bg-primary/5 focus:ring-primary/30 dark:border-dark-200 dark:text-dark-text-muted dark:hover:bg-dark-100";
        case "ghost":
          return "bg-transparent text-ui-muted hover:bg-surface-muted hover:text-ui border border-transparent focus:ring-ui-focus";
        case "accent-ghost":
          return "bg-transparent text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-transparent focus:ring-primary/40";
        case "accent-outline":
          return "bg-surface-muted text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-ui focus:ring-primary/40";
        case "transparent":
          return "focus:ring-0";
        default:
          return "bg-primary text-white hover:bg-primary-hover";
      }
    }), h = w(() => o.value ? a.size === "sm" ? "w-8 h-8 p-0" : a.size === "lg" ? "w-12 h-12 p-0" : "w-10 h-10 p-0" : a.size === "sm" ? "px-4 py-1.5 text-xs gap-1" : a.size === "lg" ? "px-8 py-3 text-base gap-2.5" : "px-6 py-2 text-sm gap-1.5");
    function v($) {
      !a.disabled && !a.loading && t("click", $);
    }
    return ($, m) => (l(), s("button", {
      type: e.type,
      "data-variant": e.variant,
      disabled: e.disabled || e.loading,
      "aria-busy": e.loading || void 0,
      "aria-label": e.loading && !e.label && !$.$slots.default ? e.loadingLabel : void 0,
      class: E([c.value, f.value, u.value, b.value, h.value, e.block ? "w-full" : "", $.$attrs.class]),
      onClick: v
    }, [
      e.loading ? (l(), _(X, {
        key: 0,
        name: "Loader2",
        class: "animate-spin",
        decorative: ""
      })) : k("", !0),
      e.icon && !e.loading ? (l(), _(X, {
        key: 1,
        name: e.icon,
        size: e.size === "sm" ? 16 : 18
      }, null, 8, ["name", "size"])) : k("", !0),
      !e.loading && $.$slots.start && !e.icon ? K($.$slots, "start", {}, void 0, !0, 2) : k("", !0),
      e.label ? (l(), s("span", Oa, I(e.label), 1)) : K($.$slots, "default", {}, void 0, !0, 4),
      K($.$slots, "end", {}, void 0, !0)
    ], 10, Wa));
  }
}), ze = /* @__PURE__ */ ge(ja, [["__scopeId", "data-v-af109c7a"]]), Fa = ["role", "aria-live"], Ka = { class: "min-w-0 flex-1" }, Re = 200, hi = /* @__PURE__ */ re({
  __name: "BaseAlert",
  props: {
    severity: { default: "info" },
    dismissible: { type: Boolean, default: !0 },
    closeLabel: { default: "Close" }
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = w(() => {
      switch (a.severity) {
        case "success":
          return "CheckCircle2";
        case "error":
          return "AlertCircle";
        case "warning":
          return "AlertTriangle";
        case "info":
          return "Info";
      }
    }), o = w(() => a.severity === "error" ? "alert" : "status"), c = A(!1), f = /* @__PURE__ */ new WeakMap();
    let u, b;
    const h = w(() => {
      switch (a.severity) {
        case "success":
          return "bg-success/10 text-success border-success/30";
        case "error":
          return "bg-danger/10 text-danger border-danger/30";
        case "warning":
          return "bg-warning/10 text-warning border-warning/30";
        case "info":
          return "bg-info/10 text-info border-info/30";
      }
    });
    function v(S) {
      const T = window.getComputedStyle(S);
      return {
        maxHeight: "",
        opacity: "1",
        paddingTop: T.paddingTop,
        paddingBottom: T.paddingBottom,
        marginBottom: T.marginBottom,
        borderColor: T.borderColor
      };
    }
    function $(S) {
      S.style.overflow = "hidden", S.style.transition = [
        `opacity ${Re}ms ease-out`,
        `max-height ${Re}ms ease-out`,
        `padding-top ${Re}ms ease-out`,
        `padding-bottom ${Re}ms ease-out`,
        `margin-bottom ${Re}ms ease-out`,
        `border-color ${Re}ms ease-out`
      ].join(", ");
    }
    function m(S) {
      S.style.overflow = "", S.style.transition = "", S.style.maxHeight = "", S.style.opacity = "", S.style.paddingTop = "", S.style.paddingBottom = "", S.style.marginBottom = "", S.style.borderColor = "";
    }
    function g(S) {
      const T = S;
      f.set(T, v(T)), $(T), T.style.maxHeight = "0px", T.style.opacity = "0", T.style.paddingTop = "0px", T.style.paddingBottom = "0px", T.style.marginBottom = "0px", T.style.borderColor = "transparent";
    }
    function d(S, T) {
      const j = S, N = {
        ...f.get(j) ?? v(j),
        maxHeight: `${j.scrollHeight}px`
      };
      u = requestAnimationFrame(() => {
        Object.assign(j.style, N), b = setTimeout(() => {
          m(j), f.delete(j), T();
        }, Re);
      });
    }
    function y(S) {
      const T = S, j = {
        ...v(T),
        maxHeight: `${T.scrollHeight}px`
      };
      f.set(T, j), $(T), Object.assign(T.style, j);
    }
    function x(S, T) {
      const j = S;
      u = requestAnimationFrame(() => {
        j.style.maxHeight = "0px", j.style.opacity = "0", j.style.paddingTop = "0px", j.style.paddingBottom = "0px", j.style.marginBottom = "0px", j.style.borderColor = "transparent", b = setTimeout(() => {
          m(j), f.delete(j), T(), t("close");
        }, Re);
      });
    }
    function L() {
      c.value || (c.value = !0);
    }
    return ct(() => {
      u !== void 0 && cancelAnimationFrame(u), b && clearTimeout(b);
    }), (S, T) => (l(), _($e, {
      appear: "",
      css: !1,
      onBeforeEnter: g,
      onEnter: d,
      onBeforeLeave: y,
      onLeave: x
    }, {
      default: ie(() => [
        c.value ? k("", !0) : (l(), s("div", {
          key: 0,
          class: E(["flex min-w-0 items-center gap-3 overflow-hidden rounded-[9px] border px-3.5 py-3 leading-[1.45]", h.value]),
          role: o.value,
          "aria-live": o.value === "alert" ? "assertive" : "polite"
        }, [
          U(X, {
            name: r.value,
            size: 18,
            class: "shrink-0",
            "aria-hidden": "true"
          }, null, 8, ["name"]),
          i("div", Ka, [
            K(S.$slots, "default")
          ]),
          e.dismissible ? (l(), _(ze, {
            key: 0,
            size: "sm",
            variant: "ghost",
            icon: "X",
            "aria-label": e.closeLabel,
            class: "!h-7 !w-7 !shrink-0 !p-0",
            onClick: L
          }, null, 8, ["aria-label"])) : k("", !0)
        ], 10, Fa))
      ]),
      _: 3
    }));
  }
}), Na = { class: "flex flex-col gap-1 w-full relative" }, Ua = ["for"], qa = {
  key: 0,
  class: "font-bold"
}, Xa = ["id", "placeholder", "disabled", "readonly", "required", "rows", "autocomplete", "value"], Ya = ["id", "type", "placeholder", "disabled", "readonly", "required", "autocomplete", "value"], Za = {
  key: 0,
  class: "font-bold"
}, Ga = {
  key: 1,
  class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1"
}, Ja = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BaseInput",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    rows: { default: 3 },
    hideZero: { type: Boolean },
    inputClass: {},
    textAlign: { default: "left" },
    prefix: {},
    suffix: {},
    color: { default: "primary" },
    autocomplete: {},
    autoSave: {}
  },
  emits: ["update:modelValue", "blur", "focus", "click", "keyup", "enter"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(null);
    function c(y) {
      const x = y.target;
      r("update:modelValue", x.value), t.autoSave?.();
    }
    function f(y) {
      y.key === "Enter" && r("enter", y), r("keyup", y);
    }
    n({
      focus: () => o.value?.focus(),
      blur: () => o.value?.blur(),
      select: () => o.value?.select(),
      ref: o
    });
    const u = w(() => t.error === !0 || typeof t.error == "string" && t.error.trim() !== ""), b = w(() => typeof t.error == "string" ? t.error : ""), h = w(() => ({
      primary: "focus:border-primary focus:ring-primary/20",
      teal: "focus:border-teal-500 focus:ring-teal-500/20",
      indigo: "focus:border-indigo-500 focus:ring-indigo-500/20",
      orange: "focus:border-orange-500 focus:ring-orange-500/20",
      red: "focus:border-red-500 focus:ring-red-500/20"
    })[t.color]), v = w(() => ({
      primary: "focus:border-primary dark:focus:border-primary",
      teal: "focus:border-teal-500 dark:focus:border-teal-400",
      indigo: "focus:border-indigo-500 dark:focus:border-indigo-400",
      orange: "focus:border-orange-500 dark:focus:border-orange-400",
      red: "focus:border-red-500 dark:focus:border-red-400"
    })[t.color]), $ = w(() => {
      const y = "font-medium placeholder:text-gray-400 dark:placeholder:text-gray-600 outline-none w-full transition-all";
      if (u.value)
        return `${y} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 focus:ring-2 focus:ring-red-100 dark:focus:ring-red-900/30 focus:border-red-500 text-red-900 dark:text-red-400 placeholder:text-red-300 dark:placeholder:text-red-500/50`;
      switch (t.variant) {
        case "filled":
          return `${y} bg-surface-muted border border-transparent focus:bg-surface ${h.value} text-ui`;
        case "outlined":
          return `${y} bg-transparent border-2 border-ui-strong ${h.value} text-ui`;
        case "plain":
          return `${y} bg-transparent border-0 focus:ring-0 text-ui-muted p-0`;
        case "underlined":
          return `${y} bg-transparent border-0 border-b border-transparent ${v.value} focus:ring-0 text-gray-800 dark:text-dark-text rounded-none px-0`;
        case "underlined-gray":
          return `${y} bg-transparent border-0 border-b border-ui ${v.value} focus:ring-0 text-ui rounded-none px-0`;
        default:
          return `${y} bg-surface border border-ui ${h.value} text-ui-muted shadow-sm`;
      }
    }), m = w(() => t.hideZero && (t.modelValue === 0 || t.modelValue === "0") ? "" : t.modelValue), g = w(() => {
      const y = t.variant === "underlined" || t.variant === "underlined-gray";
      return t.size === "xs" ? t.type === "textarea" ? "px-2 py-1 text-[10px] rounded" : `${y ? "px-0" : "px-2"} h-6 text-[10px] rounded` : t.size === "sm" ? t.type === "textarea" ? "px-2.5 py-1.5 text-xs rounded-lg" : `${y ? "px-0" : "px-2.5"} h-7.5 text-xs rounded-lg` : t.size === "lg" ? `${y ? "px-0" : "px-5"} py-3 text-base rounded-xl` : `${y ? "px-0" : "px-4"} py-2 text-sm rounded-lg`;
    }), d = w(() => t.textAlign === "center" ? "text-center" : t.textAlign === "right" ? "text-right" : "text-left");
    return (y, x) => (l(), s("div", Na, [
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "block text-[11px] font-bold text-gray-500 dark:text-dark-text-dim uppercase tracking-tight"
      }, I(e.label), 9, Ua)) : k("", !0),
      i("div", {
        class: E(["relative flex", e.type === "textarea" ? "items-start" : "items-center"])
      }, [
        y.$slots.start || e.prefix ? (l(), s("div", {
          key: 0,
          class: E(["absolute left-2.5 text-gray-400 flex items-center", [e.size === "xs" ? "text-[9px]" : "text-xs", e.type === "textarea" ? "mt-2.5" : ""]])
        }, [
          K(y.$slots, "start", {}, void 0, !0),
          e.prefix ? (l(), s("span", qa, I(e.prefix), 1)) : k("", !0)
        ], 2)) : k("", !0),
        e.type === "textarea" ? (l(), s("textarea", We({
          key: 1,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          rows: e.rows,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60 resize-none", [$.value, g.value, d.value, y.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-7" : "pl-10" : "", y.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-7" : "pr-10" : "", e.inputClass]],
          value: m.value
        }, y.$attrs, {
          onInput: c,
          onBlur: x[0] || (x[0] = (L) => r("blur", L)),
          onFocus: x[1] || (x[1] = (L) => r("focus", L)),
          onClick: x[2] || (x[2] = (L) => r("click", L)),
          onKeyup: f
        }), null, 16, Xa)) : (l(), s("input", We({
          key: 2,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          type: e.type,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60", [$.value, g.value, d.value, y.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-8" : "pl-10" : "", y.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-8" : "pr-10" : "", e.inputClass]],
          value: m.value
        }, y.$attrs, {
          onInput: c,
          onBlur: x[3] || (x[3] = (L) => r("blur", L)),
          onFocus: x[4] || (x[4] = (L) => r("focus", L)),
          onClick: x[5] || (x[5] = (L) => r("click", L)),
          onKeyup: f
        }), null, 16, Ya)),
        y.$slots.end || e.suffix ? (l(), s("div", {
          key: 3,
          class: E(["absolute right-3 text-gray-400 flex items-center", e.size === "xs" ? "text-[9px]" : "text-xs"])
        }, [
          e.suffix ? (l(), s("span", Za, I(e.suffix), 1)) : k("", !0),
          K(y.$slots, "end", {}, void 0, !0)
        ], 2)) : k("", !0)
      ], 2),
      b.value ? (l(), s("p", Ga, [
        U(X, {
          name: "AlertCircle",
          size: 11
        }),
        Be(" " + I(b.value), 1)
      ])) : k("", !0)
    ]));
  }
}), je = /* @__PURE__ */ ge(Ja, [["__scopeId", "data-v-0b2df0f8"]]), Qa = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BasePopover",
  props: {
    visible: { type: Boolean },
    triggerRef: {},
    width: { default: "w-56" },
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    className: { default: "" },
    padding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    arrow: { type: Boolean, default: !1 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 },
    positioning: { default: "anchor" }
  },
  emits: ["update:visible", "update:resolvedPlacement", "close", "popover-mouseenter", "popover-mouseleave"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = A(null), o = A({}), c = A(a.placement);
    let f = null;
    function u(g) {
      return g === "bottom" ? "top" : g === "bottom-start" ? "top-start" : g === "bottom-end" ? "top-end" : g === "top" ? "bottom" : g === "top-start" ? "bottom-start" : g === "top-end" ? "bottom-end" : g;
    }
    function b(g, d, y, x) {
      const L = d.left + d.width / 2, S = d.top + d.height / 2;
      switch (g) {
        case "bottom":
          return { top: d.bottom + a.offset, left: L - y / 2 };
        case "bottom-start":
          return { top: d.bottom + a.offset, left: d.left };
        case "bottom-end":
          return { top: d.bottom + a.offset, left: d.right - y };
        case "top":
          return { top: d.top - x - a.offset, left: L - y / 2 };
        case "top-start":
          return { top: d.top - x - a.offset, left: d.left };
        case "top-end":
          return { top: d.top - x - a.offset, left: d.right - y };
        case "right":
          return { top: S - x / 2, left: d.right + a.offset };
        case "right-start":
          return { top: d.top, left: d.right + a.offset };
        case "right-end":
          return { top: d.bottom - x, left: d.right + a.offset };
        case "left":
          return { top: S - x / 2, left: d.left - y - a.offset };
        case "left-start":
          return { top: d.top, left: d.left - y - a.offset };
        case "left-end":
          return { top: d.bottom - x, left: d.left - y - a.offset };
      }
    }
    function h() {
      if (!a.triggerRef || !a.visible) return;
      const g = a.triggerRef.getBoundingClientRect(), d = a.matchTriggerWidth ? g.width : 0, y = Math.max(r.value?.offsetWidth || 224, d), x = r.value?.offsetHeight || 0, L = 8, S = window.innerWidth, T = window.innerHeight;
      let j = a.placement;
      if (a.flip) {
        if (j.startsWith("bottom")) {
          const R = T - g.bottom - a.offset - L, Z = g.top - a.offset - L;
          x > R && Z > R && (j = u(j));
        } else if (j.startsWith("top")) {
          const R = g.top - a.offset - L, Z = T - g.bottom - a.offset - L;
          x > R && Z > R && (j = u(j));
        }
      }
      c.value = j, t("update:resolvedPlacement", j);
      const N = b(j, g, y, x);
      let z;
      a.constrainHeight && (j.startsWith("top") ? z = g.top - a.offset - L : j.startsWith("bottom") ? z = T - g.bottom - a.offset - L : z = T - L * 2, z = Math.max(z, 80));
      const P = a.matchTriggerWidth ? d : a.minWidthPx ?? 0;
      if (a.positioning === "center") {
        o.value = {
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: "9999",
          ...P > 0 ? { minWidth: `${P}px` } : {},
          ...z !== void 0 ? { maxHeight: `${z}px` } : {}
        };
        return;
      }
      o.value = {
        position: "fixed",
        top: `${Math.max(L, Math.min(N.top, T - x - L))}px`,
        left: `${Math.max(L, Math.min(N.left, S - y - L))}px`,
        zIndex: "9999",
        ...P > 0 ? { minWidth: `${P}px` } : {},
        ...z !== void 0 ? { maxHeight: `${z}px` } : {}
      };
    }
    function v(g) {
      if (!a.visible) return;
      const d = g.target, y = !!d && !!a.triggerRef?.contains(d), x = !!d && !!r.value?.contains(d);
      !y && !x && (t("update:visible", !1), t("close"));
    }
    function $() {
      const g = document.activeElement;
      g instanceof HTMLIFrameElement && (a.triggerRef?.contains(g) || r.value?.contains(g) || (t("update:visible", !1), t("close")));
    }
    function m(g) {
      if (a.visible && !(r.value && g.composedPath().includes(r.value))) {
        if (a.closeOnScroll) {
          t("update:visible", !1), t("close");
          return;
        }
        h();
      }
    }
    return be(() => a.visible, async (g) => {
      g ? (await we(), h(), a.closeOnClickOutside && window.addEventListener("pointerdown", v, !0), a.closeOnClickOutside && window.addEventListener("blur", $), window.addEventListener("resize", h), window.addEventListener("scroll", m, !0), r.value && (f = new ResizeObserver(h), f.observe(r.value))) : (window.removeEventListener("pointerdown", v, !0), window.removeEventListener("blur", $), window.removeEventListener("resize", h), window.removeEventListener("scroll", m, !0), f?.disconnect(), f = null);
    }), Ie(() => {
      window.removeEventListener("pointerdown", v, !0), window.removeEventListener("blur", $), window.removeEventListener("resize", h), window.removeEventListener("scroll", m, !0), f?.disconnect();
    }), (g, d) => (l(), _(De, {
      to: "body",
      disabled: !e.teleport
    }, [
      U($e, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": `transform scale-95 opacity-0 ${c.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`,
        "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-to-class": `transform scale-95 opacity-0 ${c.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`
      }, {
        default: ie(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            ref_key: "popoverRef",
            ref: r,
            style: oe(e.teleport ? o.value : {}),
            class: E(["base-popover-surface rounded-xl shadow-2xl border z-50", [e.width, e.className, e.padding, e.arrow ? "overflow-visible" : "overflow-hidden", e.teleport ? "fixed" : "absolute mt-2", e.constrainHeight ? "flex flex-col" : ""]]),
            onMouseenter: d[0] || (d[0] = (y) => t("popover-mouseenter")),
            onMouseleave: d[1] || (d[1] = (y) => t("popover-mouseleave"))
          }, [
            K(g.$slots, "default", {}, void 0, !0)
          ], 38)) : k("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ], 8, ["disabled"]));
  }
}), kt = /* @__PURE__ */ ge(Qa, [["__scopeId", "data-v-113389ff"]]), _a = ["aria-label"], el = { class: "flex items-center justify-between gap-3" }, tl = {
  class: "min-w-20 flex-1 text-center text-2xl font-semibold tabular-nums text-ui",
  "aria-live": "polite"
}, al = {
  key: 0,
  class: "border-t border-ui pt-3"
}, ll = {
  key: 0,
  class: "grid grid-cols-3 gap-2"
}, nl = {
  key: 1,
  class: "grid grid-cols-3 gap-2"
}, rl = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BaseNumberInput",
  props: {
    modelValue: { default: null },
    min: {},
    max: {},
    step: { default: 1 },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    hideZero: { type: Boolean, default: !1 },
    inputClass: {},
    textAlign: { default: "left" },
    prefix: {},
    suffix: {},
    color: { default: "primary" },
    autocomplete: {},
    autoSave: {},
    picker: { type: Boolean, default: !1 },
    presets: { default: () => [] },
    popupPlacement: { default: "auto" },
    popupLabel: { default: "" },
    keypad: { type: Boolean, default: !1 },
    keypadLabel: { default: "Custom" },
    presetsLabel: { default: "Presets" },
    backspaceLabel: { default: "Backspace" },
    clearLabel: { default: "Clear value" },
    decreaseLabel: { default: "Decrease value" },
    increaseLabel: { default: "Increase value" }
  },
  emits: ["update:modelValue", "blur", "focus", "click", "keyup", "enter"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(null), c = A(null), f = A(!1), u = A(!1), b = A(""), h = A("bottom"), v = A(!1);
    let $ = 0, m = null, g = null;
    const d = w(() => !t.disabled && !t.readonly), y = w(() => typeof t.step == "number" && t.step > 0 ? t.step : 1), x = w(() => t.modelValue ?? t.min ?? 0), L = w(() => t.modelValue == null ? "—" : String(t.modelValue)), S = w(() => !d.value || t.min !== void 0 && x.value <= t.min), T = w(() => !d.value || t.max !== void 0 && x.value >= t.max), j = w(() => t.popupPlacement === "top" ? "top" : "bottom"), N = w(() => t.popupPlacement === "auto"), z = w(() => `number-input-picker number-input-picker--${h.value}`), P = w(() => typeof t.step == "number" && !Number.isInteger(t.step)), R = w(() => [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ...P.value ? ["."] : ["⌫"],
      "0",
      ...P.value ? ["⌫"] : []
    ]);
    function Z(J) {
      const Y = String(y.value), ae = Y.includes(".") && Y.split(".")[1]?.length || 0;
      return Number(J.toFixed(Math.min(ae, 12)));
    }
    function C(J) {
      if (!d.value) return !1;
      const Y = x.value;
      let ae = Z(Y + J * y.value);
      return t.min !== void 0 && (ae = Math.max(t.min, ae)), t.max !== void 0 && (ae = Math.min(t.max, ae)), ae === Y && t.modelValue !== null ? !1 : (r("update:modelValue", ae), u.value && (b.value = String(ae)), !0);
    }
    function D() {
      m !== null && window.clearTimeout(m), g !== null && window.clearTimeout(g), m = null, g = null;
    }
    function B(J = 0) {
      if (!C($)) {
        D();
        return;
      }
      const Y = J < 4 ? 140 : J < 12 ? 90 : 55;
      g = window.setTimeout(() => B(J + 1), Y);
    }
    function F(J) {
      d.value && (D(), $ = J, v.value = !0, C(J), m = window.setTimeout(() => B(), 420));
    }
    function me() {
      D();
    }
    function ue() {
      D(), v.value = !1;
    }
    function ce(J) {
      if (v.value) {
        v.value = !1;
        return;
      }
      C(J);
    }
    function pe(J) {
      if (!d.value) return;
      let Y = J;
      t.min !== void 0 && (Y = Math.max(t.min, Y)), t.max !== void 0 && (Y = Math.min(t.max, Y)), r("update:modelValue", Y), b.value = String(Y);
    }
    function q(J) {
      if (b.value = J, !J || J === ".") {
        r("update:modelValue", null);
        return;
      }
      const Y = Number(J);
      Number.isFinite(Y) && (t.min !== void 0 && Y < t.min || t.max !== void 0 && Y > t.max || r("update:modelValue", Y));
    }
    function G(J) {
      if (!d.value) return;
      if (J === "⌫") {
        q(b.value.slice(0, -1));
        return;
      }
      if (J === ".") {
        b.value.includes(".") || q(b.value ? `${b.value}.` : "0.");
        return;
      }
      const Y = b.value === "0" ? J : `${b.value}${J}`;
      q(Y);
    }
    function ee() {
      !t.keypad || !d.value || (u.value = !u.value, u.value && (b.value = t.modelValue == null ? "" : String(t.modelValue)));
    }
    function he() {
      !d.value || t.modelValue == null || (r("update:modelValue", null), b.value = "", o.value?.focus());
    }
    function Oe() {
      t.picker && d.value && (f.value = !f.value);
    }
    function Ke(J) {
      (J === "top" || J === "bottom") && (h.value = J);
    }
    function _e(J) {
      const Y = String(J).trim();
      if (b.value = Y, !Y) {
        r("update:modelValue", null);
        return;
      }
      const ae = Number(Y);
      r("update:modelValue", Number.isFinite(ae) ? ae : null);
    }
    return be(() => t.picker, (J) => {
      J || (f.value = !1, u.value = !1);
    }), be(() => t.modelValue, (J) => {
      u.value || (b.value = J == null ? "" : String(J));
    }), be(f, (J) => {
      J || (D(), v.value = !1, u.value = !1);
    }), Ie(D), n({
      focus: () => o.value?.focus(),
      blur: () => o.value?.blur(),
      select: () => o.value?.select(),
      ref: o
    }), (J, Y) => (l(), s("div", {
      ref_key: "triggerRef",
      ref: c,
      class: "relative w-full"
    }, [
      U(je, We({
        ref_key: "inputRef",
        ref: o
      }, J.$attrs, {
        "model-value": e.modelValue ?? "",
        type: "number",
        min: e.min,
        max: e.max,
        step: e.step,
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        error: e.error,
        required: e.required,
        id: e.id,
        label: e.label,
        size: e.size,
        variant: e.variant,
        "hide-zero": e.hideZero,
        "input-class": e.inputClass,
        "text-align": e.textAlign,
        prefix: e.prefix,
        suffix: e.suffix,
        color: e.color,
        autocomplete: e.autocomplete,
        "auto-save": e.autoSave,
        "aria-haspopup": e.picker ? "dialog" : void 0,
        "aria-expanded": e.picker ? f.value : void 0,
        "onUpdate:modelValue": _e,
        onBlur: Y[0] || (Y[0] = (ae) => r("blur", ae)),
        onFocus: Y[1] || (Y[1] = (ae) => r("focus", ae)),
        onClick: Y[2] || (Y[2] = (ae) => {
          r("click", ae), Oe();
        }),
        onKeyup: Y[3] || (Y[3] = (ae) => r("keyup", ae)),
        onEnter: Y[4] || (Y[4] = (ae) => r("enter", ae))
      }), {
        end: ie(() => [
          e.picker ? (l(), _(ze, {
            key: 0,
            icon: "X",
            variant: "ghost",
            size: "sm",
            class: "h-7 w-7 px-0 text-ui-muted",
            disabled: e.disabled || e.readonly || e.modelValue == null,
            "aria-label": e.clearLabel,
            onClick: ve(he, ["stop"])
          }, null, 8, ["disabled", "aria-label"])) : k("", !0),
          K(J.$slots, "end", {}, void 0, !0)
        ]),
        _: 3
      }, 16, ["model-value", "min", "max", "step", "placeholder", "disabled", "readonly", "error", "required", "id", "label", "size", "variant", "hide-zero", "input-class", "text-align", "prefix", "suffix", "color", "autocomplete", "auto-save", "aria-haspopup", "aria-expanded"]),
      e.picker ? (l(), _(kt, {
        key: 0,
        visible: f.value,
        "trigger-ref": c.value,
        width: "w-64",
        padding: "p-3",
        placement: j.value,
        flip: N.value,
        arrow: !0,
        "class-name": z.value,
        "onUpdate:resolvedPlacement": Ke,
        onClose: Y[9] || (Y[9] = (ae) => f.value = !1)
      }, {
        default: ie(() => [
          i("div", {
            class: "flex flex-col gap-3",
            role: "dialog",
            "aria-label": e.popupLabel || void 0
          }, [
            i("div", el, [
              U(ze, {
                label: "−",
                variant: "secondary",
                size: "sm",
                class: "h-10 w-10 px-0 text-xl",
                disabled: S.value,
                "aria-label": e.decreaseLabel,
                onPointerdown: Y[5] || (Y[5] = (ae) => F(-1)),
                onPointerup: me,
                onPointercancel: ue,
                onPointerleave: ue,
                onClick: Y[6] || (Y[6] = (ae) => ce(-1))
              }, null, 8, ["disabled", "aria-label"]),
              i("output", tl, I(L.value), 1),
              U(ze, {
                label: "+",
                variant: "secondary",
                size: "sm",
                class: "h-10 w-10 px-0 text-xl",
                disabled: T.value,
                "aria-label": e.increaseLabel,
                onPointerdown: Y[7] || (Y[7] = (ae) => F(1)),
                onPointerup: me,
                onPointercancel: ue,
                onPointerleave: ue,
                onClick: Y[8] || (Y[8] = (ae) => ce(1))
              }, null, 8, ["disabled", "aria-label"])
            ]),
            e.presets.length || e.keypad ? (l(), s("div", al, [
              !u.value && e.presets.length ? (l(), s("div", ll, [
                (l(!0), s(le, null, de(e.presets, (ae) => (l(), _(ze, {
                  key: `${ae.value}-${ae.label}`,
                  label: ae.label,
                  variant: "ghost",
                  size: "sm",
                  class: E(["w-full px-2", { "bg-primary/15 text-primary-light": e.modelValue === ae.value }]),
                  disabled: !d.value,
                  onClick: (Ce) => pe(ae.value)
                }, null, 8, ["label", "class", "disabled", "onClick"]))), 128))
              ])) : u.value ? (l(), s("div", nl, [
                (l(!0), s(le, null, de(R.value, (ae) => (l(), _(ze, {
                  key: ae,
                  label: ae,
                  variant: "secondary",
                  size: "sm",
                  class: "h-10 w-full px-2 text-base",
                  "aria-label": ae === "⌫" ? e.backspaceLabel : ae,
                  onClick: (Ce) => G(ae)
                }, null, 8, ["label", "aria-label", "onClick"]))), 128))
              ])) : k("", !0),
              e.keypad ? (l(), _(ze, {
                key: 2,
                label: u.value ? e.presetsLabel : e.keypadLabel,
                variant: "ghost",
                size: "sm",
                class: "mt-2 w-full",
                onClick: ee
              }, null, 8, ["label"])) : k("", !0)
            ])) : k("", !0)
          ], 8, _a)
        ]),
        _: 1
      }, 8, ["visible", "trigger-ref", "placement", "flip", "class-name"])) : k("", !0)
    ], 512));
  }
}), yi = /* @__PURE__ */ ge(rl, [["__scopeId", "data-v-ae770e64"]]), sl = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BasePopoverButton",
  props: {
    visible: { type: Boolean },
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" },
    showChevron: { type: Boolean, default: !0 },
    chevronIcon: { default: "ChevronDown" },
    chevronSize: { default: 15 },
    chevronRotateOn: { default: "open" },
    hasPopup: {},
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    popoverWidth: { default: "w-56" },
    popoverClassName: { default: "" },
    popoverPadding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "click", "open", "close"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(null), c = w(() => {
      const m = o.value?.$el;
      return m instanceof HTMLElement ? m : null;
    }), f = A(t.placement), u = w(() => t.visible ? f.value : t.placement), b = w(() => ({
      "rotate-180": u.value.startsWith("top") ? t.chevronRotateOn === "open" ? !t.visible : t.visible : t.chevronRotateOn === "open" ? t.visible : !t.visible
    }));
    function h(m) {
      m !== t.visible && (r("update:visible", m), r(m ? "open" : "close"));
    }
    function v(m) {
      r("click", m), h(!t.visible);
    }
    function $() {
      h(!1);
    }
    return n({ close: $, triggerRef: c }), (m, g) => (l(), s(le, null, [
      U(ze, We({
        ref_key: "triggerComponent",
        ref: o
      }, m.$attrs, {
        variant: e.variant,
        size: e.size,
        type: e.type,
        disabled: e.disabled,
        loading: e.loading,
        icon: e.icon,
        label: e.label,
        "loading-label": e.loadingLabel,
        block: e.block,
        rounded: e.rounded,
        align: e.align,
        display: e.display,
        "aria-haspopup": e.hasPopup,
        "aria-expanded": e.visible,
        onClick: v
      }), At({
        end: ie(() => [
          K(m.$slots, "end"),
          e.showChevron ? (l(), _(X, {
            key: 0,
            name: e.chevronIcon,
            size: e.chevronSize,
            class: E(["ml-auto transition-transform duration-200", b.value]),
            decorative: ""
          }, null, 8, ["name", "size", "class"])) : k("", !0)
        ]),
        _: 2
      }, [
        m.$slots.default ? {
          name: "default",
          fn: ie(() => [
            K(m.$slots, "default")
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["variant", "size", "type", "disabled", "loading", "icon", "label", "loading-label", "block", "rounded", "align", "display", "aria-haspopup", "aria-expanded"]),
      U(kt, {
        visible: e.visible,
        "onUpdate:visible": h,
        "onUpdate:resolvedPlacement": g[0] || (g[0] = (d) => f.value = d),
        "trigger-ref": c.value,
        placement: e.placement,
        offset: e.offset,
        teleport: e.teleport,
        width: e.popoverWidth,
        "class-name": e.popoverClassName,
        padding: e.popoverPadding,
        "close-on-click-outside": e.closeOnClickOutside,
        "close-on-scroll": e.closeOnScroll,
        flip: e.flip,
        "match-trigger-width": e.matchTriggerWidth,
        "min-width-px": e.minWidthPx,
        "constrain-height": e.constrainHeight
      }, {
        default: ie(() => [
          K(m.$slots, "popover")
        ]),
        _: 3
      }, 8, ["visible", "trigger-ref", "placement", "offset", "teleport", "width", "class-name", "padding", "close-on-click-outside", "close-on-scroll", "flip", "match-trigger-width", "min-width-px", "constrain-height"])
    ], 64));
  }
}), jt = A(typeof window < "u" ? window.innerWidth : 1024);
typeof window < "u" && window.addEventListener("resize", () => {
  jt.value = window.innerWidth;
}, { passive: !0 });
function Ft(e = 640) {
  return w(() => jt.value < e);
}
const at = /* @__PURE__ */ new Set();
let gt = null;
function ol(e) {
  typeof document > "u" || at.has(e) || (at.size === 0 && (gt = document.body.style.overflow), at.add(e), document.body.style.overflow = "hidden");
}
function il(e) {
  typeof document > "u" || !at.delete(e) || at.size === 0 && (document.body.style.overflow = gt ?? "", gt = null);
}
const ul = ["for"], dl = ["id", "disabled", "aria-expanded", "aria-busy", "aria-label", "aria-invalid", "aria-controls", "aria-activedescendant", "aria-describedby"], cl = {
  key: 0,
  class: "px-3 py-2 border-b border-gray-100 dark:border-dark-200"
}, fl = ["placeholder"], ml = ["id", "aria-multiselectable"], vl = ["data-selected", "aria-selected"], bl = { class: "truncate" }, gl = {
  key: 0,
  class: "base-select-radio-dot"
}, hl = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 text-center"
}, yl = {
  key: 0,
  class: "base-select-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400",
  role: "presentation",
  "aria-hidden": "true"
}, pl = ["data-selected", "id", "aria-selected", "onClick"], xl = { class: "flex items-center gap-2 min-w-0" }, wl = { class: "truncate" }, kl = {
  key: 0,
  class: "base-select-radio-dot"
}, $l = {
  key: 2,
  class: "px-4 py-8 text-center text-xs text-gray-400 dark:text-gray-500 italic font-medium"
}, Cl = ["id"], Ll = /* @__PURE__ */ re({
  __name: "BaseSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    error: { type: [Boolean, String] },
    id: {},
    ariaLabel: {},
    size: { default: "md" },
    variant: { default: "default" },
    dropdownClass: {},
    showFocusRing: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    hideChevron: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search..." },
    emptySearchText: { default: "No matching options" },
    emptyOptionsText: { default: "No options" },
    scrollSelectedIntoView: { type: Boolean, default: !0 },
    autoSave: {},
    dropdownPlacement: { default: "bottom-start" }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(!1), c = Jt(), f = w(() => t.id ?? `${c}-trigger`), u = w(() => `${f.value}-listbox`), b = A(-1), h = A(null), v = A(""), $ = A(null), m = A(null), g = Ft(), d = /* @__PURE__ */ Symbol("BaseSelectMobileScrollLock"), y = w(() => {
      if (t.multiple && Array.isArray(t.modelValue)) {
        const G = t.modelValue;
        return t.options.filter((ee) => G.includes(ee.value));
      }
      const q = t.options.find((G) => G.value === t.modelValue);
      return q ? [q] : [];
    }), x = w(() => {
      if (!t.searchable || !v.value) return t.options;
      const q = v.value.toLowerCase();
      return t.options.filter((G) => G.label.toLowerCase().includes(q) || String(G.value).toLowerCase().includes(q));
    }), L = w(() => t.multiple ? y.value.map((q) => q.label).join(", ") : y.value[0]?.label ?? "");
    function S() {
      t.disabled || t.loading || (o.value = !o.value, o.value && r("focus"));
    }
    function T() {
      o.value = !1;
    }
    function j() {
      t.disabled || t.loading || (o.value = !0, r("focus"));
    }
    function N(q) {
      return `${u.value}-option-${q}`;
    }
    function z() {
      const q = x.value.findIndex((G) => C(G));
      b.value = q >= 0 ? q : -1;
    }
    function P() {
      b.value < 0 || document.getElementById(N(b.value))?.scrollIntoView({ block: "nearest" });
    }
    function R(q) {
      if (!(t.disabled || t.loading))
        if (q.key === "ArrowDown" || q.key === "ArrowUp") {
          if (q.preventDefault(), !o.value) {
            j(), we(() => {
              const he = x.value.length;
              b.value = he ? q.key === "ArrowDown" ? 0 : he - 1 : -1;
            });
            return;
          }
          const G = x.value.length;
          if (!G) return;
          const ee = q.key === "ArrowDown" ? 1 : -1;
          b.value = b.value < 0 ? ee > 0 ? 0 : G - 1 : (b.value + ee + G) % G, we(P);
        } else if ((q.key === "Enter" || q.key === " ") && o.value) {
          q.preventDefault();
          const G = x.value[b.value];
          G && Z(G);
        } else q.key === "Escape" && o.value && (q.preventDefault(), T());
    }
    n({
      close: T,
      open: j,
      toggle: S
    }), be(o, (q) => {
      if (!q) {
        r("blur");
        return;
      }
      t.searchable && (v.value = "", we(() => $.value?.focus())), z(), t.scrollSelectedIntoView && we(() => {
        m.value?.querySelector('[data-selected="true"]')?.scrollIntoView({ block: "nearest" });
      });
    }), be(x, () => {
      o.value && z();
    });
    function Z(q) {
      b.value = x.value.findIndex((ee) => ee.value === q.value);
      let G;
      if (t.multiple) {
        const ee = Array.isArray(t.modelValue) ? [...t.modelValue] : [], he = ee.indexOf(q.value);
        he > -1 ? ee.splice(he, 1) : ee.push(q.value), G = ee;
      } else
        G = q.value, o.value = !1;
      r("update:modelValue", G), r("change", G), t.autoSave?.();
    }
    function C(q) {
      return t.multiple && Array.isArray(t.modelValue) ? t.modelValue.includes(q.value) : t.modelValue === q.value;
    }
    const D = w(() => ({ label: t.placeholder ?? "", value: "" })), B = w(() => t.error === !0 || typeof t.error == "string" && t.error.trim() !== ""), F = w(() => typeof t.error == "string" ? t.error : ""), me = w(() => [
      "base-select-dropdown",
      g.value ? "base-select-mobile-modal" : "",
      t.dropdownClass
    ].filter(Boolean).join(" "));
    function ue(q, G) {
      typeof document > "u" || (q && G ? ol(d) : il(d));
    }
    be([o, g], ([q, G]) => {
      ue(q, G);
    }), Ie(() => {
      ue(!1, !1);
    });
    const ce = w(() => {
      const q = "font-medium outline-none w-full cursor-pointer transition-all duration-200 flex items-center justify-between text-left";
      if (B.value)
        return `${q} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 ring-2 ring-red-100 dark:ring-red-900/30 text-red-900 dark:text-red-400 rounded-lg`;
      switch (t.variant) {
        case "filled":
          return `${q} bg-surface-muted border border-transparent focus:bg-surface focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "outlined":
          return `${q} bg-transparent border-2 border-ui-strong focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "plain":
          return `${q} bg-transparent border-0 focus:ring-0 text-ui-muted p-0 h-full w-auto min-w-0 flex-shrink-0`;
        default:
          return `${q} bg-surface border border-ui focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui-muted shadow-sm rounded-lg`;
      }
    }), pe = w(() => t.size === "sm" ? t.variant === "plain" ? "text-xs" : "h-8 px-3 text-xs" : t.size === "lg" ? "h-12 px-5 text-base rounded-xl" : t.variant === "plain" ? "text-sm" : "h-10 px-4 text-sm");
    return (q, G) => (l(), s("div", {
      class: E(["w-full", { "flex flex-col gap-1.5": e.label }])
    }, [
      e.label ? (l(), s("label", {
        key: 0,
        for: f.value,
        class: "block text-[11px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-widest px-0.5"
      }, I(e.label), 9, ul)) : k("", !0),
      i("div", {
        ref_key: "triggerRef",
        ref: h,
        class: "relative group h-full"
      }, [
        i("button", {
          id: f.value,
          type: "button",
          disabled: e.disabled || e.loading,
          "aria-haspopup": "listbox",
          "aria-expanded": o.value,
          "aria-busy": e.loading || void 0,
          "aria-label": e.ariaLabel || e.label,
          "aria-invalid": B.value || void 0,
          "aria-controls": u.value,
          "aria-activedescendant": o.value && b.value >= 0 ? N(b.value) : void 0,
          "aria-describedby": B.value ? `${f.value}-error` : void 0,
          class: E(["disabled:bg-surface-muted disabled:text-ui-dim disabled:cursor-not-allowed disabled:opacity-60", ["group flex items-center justify-between transition-all duration-200 overflow-hidden min-w-0", ce.value, pe.value, o.value && e.showFocusRing ? "ring-2 ring-primary/20 border-primary" : ""]]),
          onClick: S,
          onKeydown: R
        }, [
          K(q.$slots, "selected", { selectedOptions: y.value }, () => [
            i("span", {
              class: E(["min-w-0 truncate grow", { "text-gray-400 dark:text-gray-500": !L.value }])
            }, I(L.value || e.placeholder), 3)
          ], !0),
          e.loading ? (l(), _(X, {
            key: 0,
            name: "Loader2",
            size: 16,
            class: "ml-2 shrink-0 animate-spin text-primary"
          })) : e.hideChevron ? k("", !0) : (l(), _(X, {
            key: 1,
            name: "ChevronDown",
            size: 16,
            class: E(["ml-2 shrink-0 transition-transform duration-200", { "rotate-180": o.value }])
          }, null, 8, ["class"]))
        ], 42, dl),
        (l(), _(De, { to: "body" }, [
          U($e, {
            "enter-active-class": "transition-opacity duration-200",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity duration-150",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: ie(() => [
              o.value && te(g) ? (l(), s("div", {
                key: 0,
                class: "base-select-mobile-backdrop",
                "aria-hidden": "true",
                onClick: T
              })) : k("", !0)
            ]),
            _: 1
          })
        ])),
        U(kt, {
          visible: o.value,
          "onUpdate:visible": G[4] || (G[4] = (ee) => o.value = ee),
          "trigger-ref": h.value,
          placement: e.dropdownPlacement,
          flip: !0,
          positioning: te(g) ? "center" : "anchor",
          "match-trigger-width": e.variant !== "plain" && !te(g),
          "min-width-px": e.variant === "plain" && !te(g) ? 120 : void 0,
          width: te(g) ? "" : "w-56",
          padding: te(g) ? "" : "py-1.5",
          "class-name": me.value
        }, {
          default: ie(() => [
            e.searchable ? (l(), s("div", cl, [
              xt(i("input", {
                ref_key: "searchInputRef",
                ref: $,
                "onUpdate:modelValue": G[0] || (G[0] = (ee) => v.value = ee),
                type: "text",
                placeholder: e.searchPlaceholder,
                class: "w-full bg-gray-50 dark:bg-dark-50 border border-gray-200 dark:border-dark-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 dark:text-dark-text",
                onClick: G[1] || (G[1] = ve(() => {
                }, ["stop"])),
                onKeydown: G[2] || (G[2] = ve(() => {
                }, ["stop"]))
              }, null, 40, fl), [
                [Rt, v.value]
              ])
            ])) : k("", !0),
            i("div", {
              id: u.value,
              ref_key: "optionsScrollRef",
              ref: m,
              class: "base-select-options overflow-y-auto custom-scrollbar max-h-60",
              role: "listbox",
              "aria-multiselectable": e.multiple || void 0
            }, [
              e.placeholder && !e.multiple ? (l(), s("div", {
                key: 0,
                "data-selected": C(D.value) ? "true" : void 0,
                class: E(["base-select-option base-select-placeholder-option px-4 py-2 text-xs font-bold uppercase tracking-tight cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-50/50 transition-colors", [C(D.value) ? "font-bold" : "text-gray-400 dark:text-dark-text-dim"]]),
                role: "option",
                "aria-selected": C(D.value),
                onClick: G[3] || (G[3] = (ee) => Z(D.value))
              }, [
                i("span", bl, I(e.placeholder), 1),
                te(g) && !e.multiple ? (l(), s("span", {
                  key: 0,
                  class: E(["base-select-radio", { "base-select-radio-selected": C(D.value) }]),
                  "aria-hidden": "true"
                }, [
                  C(D.value) ? (l(), s("span", gl)) : k("", !0)
                ], 2)) : C(D.value) ? (l(), _(X, {
                  key: 1,
                  name: "Check",
                  size: 16,
                  class: "base-select-option-check text-primary shrink-0 ml-2"
                })) : k("", !0)
              ], 10, vl)) : k("", !0),
              x.value.length === 0 ? (l(), s("div", hl, I(e.emptySearchText), 1)) : k("", !0),
              (l(!0), s(le, null, de(x.value, (ee) => (l(), s("div", {
                key: ee.value,
                class: "contents"
              }, [
                ee.group && x.value[x.value.indexOf(ee) - 1]?.group !== ee.group ? (l(), s("div", yl, I(ee.group), 1)) : k("", !0),
                i("div", {
                  "data-selected": C(ee) ? "true" : void 0,
                  id: N(x.value.indexOf(ee)),
                  class: E(["base-select-option px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer flex items-center justify-between gap-4 flex-nowrap", [C(ee) ? "font-bold" : "", b.value === x.value.indexOf(ee) ? "ring-1 ring-inset ring-primary/40" : ""]]),
                  role: "option",
                  "aria-selected": C(ee),
                  onClick: (he) => Z(ee)
                }, [
                  i("div", xl, [
                    K(q.$slots, "option", {
                      option: ee,
                      isSelected: C(ee)
                    }, () => [
                      ee.icon ? (l(), _(X, {
                        key: 0,
                        name: ee.icon,
                        size: 14
                      }, null, 8, ["name"])) : k("", !0),
                      i("span", wl, I(ee.label), 1)
                    ], !0)
                  ]),
                  te(g) && !e.multiple ? (l(), s("span", {
                    key: 0,
                    class: E(["base-select-radio", { "base-select-radio-selected": C(ee) }]),
                    "aria-hidden": "true"
                  }, [
                    C(ee) ? (l(), s("span", kl)) : k("", !0)
                  ], 2)) : C(ee) ? (l(), _(X, {
                    key: 1,
                    name: "Check",
                    size: 16,
                    class: "base-select-option-check text-primary shrink-0 ml-2"
                  })) : k("", !0)
                ], 10, pl)
              ]))), 128)),
              e.options.length === 0 ? (l(), s("div", $l, I(e.emptyOptionsText), 1)) : k("", !0)
            ], 8, ml)
          ]),
          _: 3
        }, 8, ["visible", "trigger-ref", "placement", "positioning", "match-trigger-width", "min-width-px", "width", "padding", "class-name"])
      ], 512),
      B.value && F.value ? (l(), s("p", {
        key: 1,
        id: B.value ? `${f.value}-error` : void 0,
        class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1 px-1"
      }, [
        U(X, {
          name: "AlertCircle",
          size: 11
        }),
        Be(" " + I(F.value), 1)
      ], 8, Cl)) : k("", !0)
    ], 2));
  }
}), ht = /* @__PURE__ */ ge(Ll, [["__scopeId", "data-v-7db5a8f8"]]), Sl = { key: 0 }, pi = /* @__PURE__ */ re({
  __name: "BaseTag",
  props: {
    label: {},
    severity: { default: "secondary" },
    icon: {},
    rounded: { type: Boolean, default: !1 },
    variant: { default: "subtle" },
    size: { default: "md" },
    class: {}
  },
  setup(e) {
    const n = e, a = w(() => {
      const o = n.variant === "outline", c = n.variant === "filled";
      switch (n.severity) {
        case "success":
          return c ? "bg-success text-surface-inverse border-success" : o ? "bg-transparent text-success border-success" : "bg-success/10 text-success border-success/30";
        case "info":
          return c ? "bg-info text-surface-inverse border-info" : o ? "bg-transparent text-info border-info" : "bg-info/10 text-info border-info/30";
        case "warning":
          return c ? "bg-warning text-surface-inverse border-warning" : o ? "bg-transparent text-warning border-warning" : "bg-warning/10 text-warning border-warning/30";
        case "danger":
          return c ? "bg-danger text-surface-inverse border-danger" : o ? "bg-transparent text-danger border-danger" : "bg-danger/10 text-danger border-danger/30";
        case "primary":
          return c ? "bg-primary text-surface-inverse border-primary" : o ? "bg-transparent text-primary border-primary" : "bg-primary/10 dark:bg-primary/20 text-primary border-primary/20 dark:border-primary/30";
        default:
          return c ? "bg-surface-inverse text-surface border-surface-inverse" : o ? "bg-transparent text-ui-muted border-ui-strong" : "bg-surface-muted text-ui-muted border-ui";
      }
    }), t = w(() => n.size === "sm" ? "px-2 py-0.5 text-[0.65rem] gap-1" : n.size === "lg" ? "px-4 py-1.5 text-base gap-2" : "px-2.5 py-1 text-xs gap-1.5"), r = w(() => n.size === "sm" ? 12 : n.size === "lg" ? 18 : 14);
    return (o, c) => (l(), s("div", {
      class: E(["inline-flex items-center font-medium border transition-colors duration-200", [a.value, t.value, e.rounded ? "rounded-full" : "rounded-md", n.class]])
    }, [
      e.icon ? (l(), _(X, {
        key: 0,
        name: e.icon,
        size: r.value
      }, null, 8, ["name", "size"])) : k("", !0),
      K(o.$slots, "default", {}, () => [
        e.label ? (l(), s("span", Sl, I(e.label), 1)) : k("", !0)
      ])
    ], 2));
  }
});
let Xe = null;
function zl(e) {
  Xe && Xe !== e && Xe(), Xe = e;
}
function Lt(e) {
  Xe === e && (Xe = null);
}
const Bl = { class: "cursor-help text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400 transition-colors" }, Tl = /* @__PURE__ */ re({
  __name: "BaseTooltip",
  props: {
    text: {},
    widthClass: {},
    placement: { default: "top" },
    theme: { default: "dark" },
    fontSize: { default: "xs" },
    paddingClass: { default: "px-4 py-3" },
    maxWidth: { default: "320px" },
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, a = A(!1), t = A(!1);
    let r = null;
    const o = A(null), c = A(null), f = A({ top: "0px", left: "0px" }), u = A({ left: "50%" }), b = A(n.placement);
    function h() {
      r && (clearTimeout(r), r = null);
    }
    function v() {
      h(), t.value = !1, a.value = !1, Lt(v);
    }
    function $() {
      zl(v);
    }
    const m = w(
      () => n.theme === "dark" ? "border-white/10 bg-dark-200 text-dark-text" : "border-gray-100 bg-white text-gray-700"
    ), g = w(() => b.value === "top" ? n.theme === "dark" ? "top-full border-t-dark-200" : "top-full border-t-white" : n.theme === "dark" ? "bottom-full border-b-dark-200" : "bottom-full border-b-white");
    function d() {
      if (!o.value || !c.value) return;
      const z = o.value.getBoundingClientRect(), P = document.documentElement.clientWidth || window.innerWidth, R = document.documentElement.clientHeight || window.innerHeight, Z = c.value.offsetWidth, C = c.value.offsetHeight, D = 24, B = 16, F = z.left + z.width / 2 - Z / 2, me = Math.min(Math.max(D, F), P - D - Z);
      let ue = n.placement, ce = 0;
      n.placement === "top" ? z.top < C + B + 10 ? (ue = "bottom", ce = z.bottom + B) : ce = z.top - B : R - z.bottom < C + B + 10 ? (ue = "top", ce = z.top - B) : ce = z.bottom + B, b.value = ue, f.value = { left: `${me}px`, top: `${ce}px` }, u.value = { left: `${z.left + z.width / 2 - me}px` };
    }
    async function y() {
      t.value || (h(), $(), a.value = !0, await we(), d(), setTimeout(d, 50));
    }
    function x() {
      t.value || (n.interactive ? r = setTimeout(() => {
        v();
      }, 150) : v());
    }
    async function L(z) {
      z.stopPropagation(), $(), t.value = !t.value, a.value = t.value, t.value || v(), a.value && (await we(), d(), setTimeout(d, 50));
    }
    function S() {
      t.value && v();
    }
    let T = null;
    const j = () => {
      a.value && d();
    }, N = () => {
      a.value && d();
    };
    return wt(() => {
      window.addEventListener("scroll", j, !0), window.addEventListener("resize", N), T = new ResizeObserver(() => {
        a.value && d();
      }), document.addEventListener("click", S);
    }), Ie(() => {
      Lt(v), window.removeEventListener("scroll", j, !0), window.removeEventListener("resize", N), T?.disconnect(), document.removeEventListener("click", S);
    }), be(c, (z) => {
      z && T ? T.observe(z) : T?.disconnect();
    }), (z, P) => (l(), s("div", {
      ref_key: "iconRef",
      ref: o,
      class: "relative inline-block w-max",
      onMouseenter: y,
      onMouseleave: x,
      onClick: L
    }, [
      K(z.$slots, "trigger", {}, () => [
        i("div", Bl, [
          U(X, {
            name: "HelpCircle",
            size: 16
          })
        ])
      ], !0),
      (l(), _(De, { to: "body" }, [
        U($e, { name: "tooltip-fade" }, {
          default: ie(() => [
            a.value ? (l(), s("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: c,
              class: E(["fixed rounded-xl border shadow-2xl z-10000 pointer-events-auto whitespace-pre-wrap wrap-break-word text-left leading-relaxed min-w-30", [m.value, e.paddingClass, e.fontSize === "sm" ? "text-sm" : e.fontSize === "base" ? "text-base" : "text-xs", e.widthClass || "w-max", b.value === "top" ? "-translate-y-full" : ""]]),
              style: oe({
                ...f.value,
                maxWidth: e.maxWidth
              }),
              onMouseenter: y,
              onMouseleave: x
            }, [
              K(z.$slots, "default", {
                hide: () => a.value = !1
              }, () => [
                Be(I(e.text), 1)
              ], !0),
              i("div", {
                class: E(["absolute -translate-x-1/2 border-4 border-transparent", g.value]),
                style: oe(u.value)
              }, null, 6)
            ], 38)) : k("", !0)
          ]),
          _: 3
        })
      ]))
    ], 544));
  }
}), xi = /* @__PURE__ */ ge(Tl, [["__scopeId", "data-v-bde2cca5"]]);
let yt = 0, lt = null;
function Ml() {
  lt && (clearTimeout(lt), lt = null);
}
function Kt(e) {
  const n = Math.max(0, e);
  yt = Date.now() + n, Ml(), lt = setTimeout(() => {
    yt = 0, lt = null;
  }, n);
}
function Nt() {
  return yt > Date.now();
}
const El = /* @__PURE__ */ re({
  __name: "BaseHoverLabel",
  props: {
    text: {},
    triggerClass: {},
    delay: { default: 450 },
    recentWindow: { default: 1500 },
    placement: { default: "bottom" },
    maxWidth: { default: "240px" }
  },
  setup(e) {
    const n = e, a = A(null), t = A(null), r = A(!1), o = A(!1), c = A({ top: "0px", left: "0px" });
    let f = null;
    function u() {
      f && (clearTimeout(f), f = null);
    }
    function b() {
      if (!a.value || !t.value || !r.value) return;
      const m = a.value.getBoundingClientRect(), g = t.value.getBoundingClientRect(), d = 6, y = 8, x = document.documentElement.clientWidth || window.innerWidth, L = document.documentElement.clientHeight || window.innerHeight, S = Math.max(y, x - g.width - y), T = Math.max(y, L - g.height - y), j = Math.min(
        Math.max(y, m.left + m.width / 2 - g.width / 2),
        S
      ), N = Math.min(Math.max(y, m.top + m.height / 2 - g.height / 2), T), z = m.bottom + d, P = m.top - g.height - d, R = z + g.height <= L - y, Z = P >= y, C = () => R ? z : Z ? P : N, D = m.right + d, B = m.left - g.width - d, F = D + g.width <= x - y, me = B >= y;
      let ue = j, ce = C();
      n.placement === "right" ? F ? (ue = D, ce = N) : me && (ue = B, ce = N) : n.placement === "left" ? me ? (ue = B, ce = N) : F && (ue = D, ce = N) : n.placement === "top" && Z ? ce = P : (n.placement === "bottom" && R || n.placement === "top" && R) && (ce = z), c.value = {
        top: `${Math.max(y, Math.min(ce, T))}px`,
        left: `${Math.max(y, Math.min(ue, S))}px`
      };
    }
    async function h() {
      if (u(), !!n.text) {
        if (Nt()) {
          r.value = !0, o.value = !0, await we(), b();
          return;
        }
        f = setTimeout(async () => {
          r.value = !0, o.value = !0, await we(), b();
        }, Math.max(0, n.delay));
      }
    }
    function v() {
      u(), r.value = !1, o.value && (o.value = !1, Kt(n.recentWindow));
    }
    function $() {
      r.value && b();
    }
    return be(r, (m) => {
      m ? (window.addEventListener("scroll", $, !0), window.addEventListener("resize", $)) : (window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $));
    }), Ie(() => {
      u(), window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $);
    }), (m, g) => (l(), s(le, null, [
      i("span", {
        ref_key: "triggerRef",
        ref: a,
        class: E(["inline-flex", n.triggerClass]),
        onMouseenter: h,
        onMouseleave: v,
        onClick: v
      }, [
        K(m.$slots, "trigger", {}, void 0, !0)
      ], 34),
      (l(), _(De, { to: "body" }, [
        U($e, { name: "base-hover-label-fade" }, {
          default: ie(() => [
            r.value && n.text ? (l(), s("span", {
              key: 0,
              ref_key: "labelRef",
              ref: t,
              role: "tooltip",
              class: "pointer-events-none fixed z-10000 w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words",
              style: oe({ ...c.value, backgroundColor: "var(--color-tooltip-surface)", borderColor: "var(--color-tooltip-border)", color: "var(--color-tooltip-text)", width: "max-content", maxWidth: `min(${n.maxWidth}, calc(100vw - 16px))` })
            }, I(n.text), 5)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), wi = /* @__PURE__ */ ge(El, [["__scopeId", "data-v-c0139823"]]), ot = {
  delay: 450,
  recentWindow: 1500,
  placement: "bottom",
  maxWidth: "240px"
};
function Ut(e) {
  const n = typeof e == "string" ? { text: e } : e ?? {};
  return {
    text: n.text,
    delay: n.delay ?? ot.delay,
    recentWindow: n.recentWindow ?? ot.recentWindow,
    placement: n.placement ?? ot.placement,
    maxWidth: n.maxWidth ?? ot.maxWidth
  };
}
function qt(e) {
  e.showTimer && (clearTimeout(e.showTimer), e.showTimer = null);
}
function $t(e, n) {
  if (!n.label || !n.visible) return;
  const a = e.getBoundingClientRect(), t = n.label.getBoundingClientRect(), r = 6, o = 8, c = document.documentElement.clientWidth || window.innerWidth, f = document.documentElement.clientHeight || window.innerHeight, u = Math.max(o, c - t.width - o), b = Math.max(o, f - t.height - o), h = Math.min(
    Math.max(o, a.left + a.width / 2 - t.width / 2),
    u
  ), v = Math.min(Math.max(o, a.top + a.height / 2 - t.height / 2), b), $ = a.bottom + r, m = a.top - t.height - r, g = $ + t.height <= f - o, d = m >= o, y = () => g ? $ : d ? m : v, x = a.right + r, L = a.left - t.width - r, S = x + t.width <= c - o, T = L >= o;
  let j = h, N = y();
  n.options.placement === "right" ? S ? (j = x, N = v) : T && (j = L, N = v) : n.options.placement === "left" ? T ? (j = L, N = v) : S && (j = x, N = v) : n.options.placement === "top" && d ? N = m : (n.options.placement === "bottom" && g || n.options.placement === "top" && g) && (N = $), n.label.style.top = `${Math.max(o, Math.min(N, b))}px`, n.label.style.left = `${Math.max(o, Math.min(j, u))}px`;
}
function nt(e, n) {
  if (qt(n), n.visible = !1, n.label) {
    const a = n.label;
    a.style.opacity = "0", a.style.transform = "translateY(-2px)", window.setTimeout(() => {
      !n.visible && n.label === a && (a.remove(), n.label = null);
    }, 120);
  }
  n.hasShown && (n.hasShown = !1, Kt(n.options.recentWindow)), window.removeEventListener("scroll", n.refreshPosition, !0), window.removeEventListener("resize", n.refreshPosition);
}
function St(e, n) {
  if (qt(n), !n.options.text) return;
  const a = () => {
    if (!n.options.text || n.visible) return;
    n.label && (n.label.remove(), n.label = null);
    const t = document.createElement("span");
    t.dataset.baseHoverLabel = "true", t.setAttribute("role", "tooltip"), t.className = "pointer-events-none fixed z-[10000] w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words", t.style.backgroundColor = "var(--color-tooltip-surface)", t.style.borderColor = "var(--color-tooltip-border)", t.style.color = "var(--color-tooltip-text)", t.style.boxShadow = "0 10px 24px var(--color-shadow, rgb(15 23 42 / 18%))", t.style.width = "max-content", t.style.maxWidth = `min(${n.options.maxWidth}, calc(100vw - 16px))`, t.style.opacity = "0", t.style.transform = "translateY(-2px)", t.style.transition = "opacity 120ms ease, transform 120ms ease", t.textContent = n.options.text, document.body.appendChild(t), n.label = t, n.visible = !0, n.hasShown = !0, $t(e, n), requestAnimationFrame(() => {
      n.label === t && n.visible && (t.style.opacity = "1", t.style.transform = "translateY(0)");
    }), window.addEventListener("scroll", n.refreshPosition, !0), window.addEventListener("resize", n.refreshPosition);
  };
  if (Nt()) {
    a();
    return;
  }
  n.showTimer = window.setTimeout(a, Math.max(0, n.options.delay));
}
function Il(e, n, a) {
  n.options = Ut(a), n.options.text || nt(e, n), n.label && (n.label.textContent = n.options.text ?? "", n.label.style.maxWidth = `min(${n.options.maxWidth}, calc(100vw - 16px))`, $t(e, n));
}
function Vl(e, n) {
  const a = {
    options: Ut(n),
    label: null,
    showTimer: null,
    hasShown: !1,
    visible: !1,
    onMouseEnter: () => St(e, a),
    onMouseLeave: () => nt(e, a),
    onFocusIn: () => St(e, a),
    onFocusOut: (t) => {
      t.relatedTarget instanceof Node && e.contains(t.relatedTarget) || nt(e, a);
    },
    onClick: () => nt(e, a),
    refreshPosition: () => $t(e, a)
  };
  return e.addEventListener("mouseenter", a.onMouseEnter), e.addEventListener("mouseleave", a.onMouseLeave), e.addEventListener("focusin", a.onFocusIn), e.addEventListener("focusout", a.onFocusOut), e.addEventListener("click", a.onClick), a;
}
function Dl(e, n) {
  nt(e, n), e.removeEventListener("mouseenter", n.onMouseEnter), e.removeEventListener("mouseleave", n.onMouseLeave), e.removeEventListener("focusin", n.onFocusIn), e.removeEventListener("focusout", n.onFocusOut), e.removeEventListener("click", n.onClick);
}
const it = {
  mounted(e, n) {
    e.__baseHoverLabel = Vl(e, n.value);
  },
  updated(e, n) {
    const a = e.__baseHoverLabel;
    a && Il(e, a, n.value);
  },
  unmounted(e) {
    const n = e.__baseHoverLabel;
    n && Dl(e, n), delete e.__baseHoverLabel;
  }
}, Pl = { class: "w-full" }, Al = {
  key: 0,
  class: "flex justify-between mb-1"
}, ki = /* @__PURE__ */ re({
  __name: "BaseProgressBar",
  props: {
    value: { default: 0 },
    showValue: { type: Boolean, default: !0 },
    variant: { default: "primary" },
    size: { default: "md" },
    height: {}
  },
  setup(e) {
    const n = e, a = w(() => {
      if (n.height) return n.height;
      switch (n.size) {
        case "sm":
          return "h-1.5";
        case "lg":
          return "h-4";
        default:
          return "h-2.5";
      }
    }), t = w(() => {
      switch (n.variant) {
        case "success":
          return "bg-green-500";
        case "warning":
          return "bg-yellow-500";
        case "danger":
          return "bg-red-600";
        default:
          return "bg-primary";
      }
    }), r = w(() => Math.min(Math.max(n.value, 0), 100));
    return (o, c) => (l(), s("div", Pl, [
      e.showValue ? (l(), s("div", Al, [
        i("span", {
          class: E(["text-xs font-medium", {
            "text-primary": e.variant === "primary",
            "text-green-500": e.variant === "success",
            "text-yellow-500": e.variant === "warning",
            "text-red-600": e.variant === "danger"
          }])
        }, I(r.value) + "% ", 3)
      ])) : k("", !0),
      i("div", {
        class: E(["w-full bg-gray-200 rounded-full dark:bg-dark-200 overflow-hidden", [e.height && !e.height.startsWith("h-") ? "" : a.value]]),
        style: oe(e.height && !e.height.startsWith("h-") ? { height: e.height } : {})
      }, [
        i("div", {
          class: E(["rounded-full transition-all duration-500 ease-out", [t.value, a.value]]),
          style: oe({ width: `${r.value}%`, ...e.height && !e.height.startsWith("h-") ? { height: e.height } : {} })
        }, null, 6)
      ], 6)
    ]));
  }
});
function Rl({
  scrollElement: e,
  refresh: n,
  enabled: a = !0,
  threshold: t = 64,
  maxDistance: r = 140,
  loadingDistance: o = 56,
  visibleDistance: c = 16,
  topTolerance: f = 0.5,
  interactiveSelector: u = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: b
}) {
  const h = A(0), v = A(!1), $ = A(!1), m = w(() => h.value >= t), g = w(() => $.value || h.value >= c), d = w(() => Math.min(h.value / t, 1));
  let y = null, x = null;
  function L() {
    y = null, v.value = !1, $.value || (h.value = 0);
  }
  function S(z) {
    const P = e.value;
    if ($.value || !Ye(a) || !P || P.scrollTop > f || z.touches.length !== 1 || z.target instanceof Element && z.target.closest(u)) return;
    const R = z.touches[0];
    y = { x: R.clientX, y: R.clientY };
  }
  function T(z) {
    const P = e.value;
    if (!y || !P || z.touches.length !== 1) return;
    if (!Ye(a) || P.scrollTop > f) {
      L();
      return;
    }
    const R = z.touches[0], Z = R.clientX - y.x, C = R.clientY - y.y;
    if (C <= 0 || Math.abs(Z) > Math.abs(C)) {
      L();
      return;
    }
    z.preventDefault(), v.value = !0, h.value = Math.min(C, r);
  }
  async function j() {
    if (!y) return;
    const z = m.value;
    if (y = null, v.value = !1, !z) {
      h.value = 0;
      return;
    }
    $.value = !0, h.value = o;
    try {
      await n();
    } catch (P) {
      b?.(P);
    } finally {
      $.value = !1, h.value = 0;
    }
  }
  function N(z) {
    x?.(), x = null, z && (z.addEventListener("touchstart", S, { passive: !0 }), z.addEventListener("touchmove", T, { passive: !1 }), z.addEventListener("touchend", j, { passive: !0 }), z.addEventListener("touchcancel", L, { passive: !0 }), x = () => {
      z.removeEventListener("touchstart", S), z.removeEventListener("touchmove", T), z.removeEventListener("touchend", j), z.removeEventListener("touchcancel", L);
    });
  }
  return be(e, N, { flush: "post", immediate: !0 }), be(() => Ye(a), (z) => {
    z || L();
  }), Ie(() => x?.()), {
    pullDistance: h,
    pullDragging: v,
    pullProgress: d,
    pullReady: m,
    pullRefreshing: $,
    pullVisible: g,
    resetGesture: L
  };
}
const Hl = ["aria-label", "aria-busy", "data-refreshing"], Wl = /* @__PURE__ */ re({
  __name: "BasePullToRefresh",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    topTolerance: { default: 0.5 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(null), c = w(() => t.enabled);
    async function f() {
      r("refreshStart");
      try {
        await t.refresh();
      } catch (y) {
        throw r("refreshError", y), y;
      } finally {
        r("refreshEnd");
      }
    }
    const {
      pullDistance: u,
      pullDragging: b,
      pullProgress: h,
      pullReady: v,
      pullRefreshing: $,
      pullVisible: m
    } = Rl({
      scrollElement: o,
      refresh: f,
      enabled: c,
      threshold: t.threshold,
      maxDistance: t.maxDistance,
      loadingDistance: t.loadingDistance,
      visibleDistance: t.visibleDistance,
      topTolerance: t.topTolerance,
      interactiveSelector: t.interactiveSelector
    }), g = w(() => ({ height: `${u.value}px` })), d = w(() => $.value ? void 0 : { transform: `rotate(${u.value * 4.5}deg)` });
    return n({
      scrollElement: o,
      pullDistance: u,
      pullDragging: b,
      pullProgress: h,
      pullReady: v,
      pullRefreshing: $,
      pullVisible: m
    }), (y, x) => (l(), s("div", {
      ref_key: "scrollElement",
      ref: o,
      class: E(["base-pull-to-refresh", [`base-pull-to-refresh--${e.theme}`, { "base-pull-to-refresh--dragging": te(b) }]]),
      "data-pull-to-refresh-part": "scroll"
    }, [
      i("div", {
        class: "base-pull-to-refresh__gap",
        style: oe(g.value),
        "data-pull-to-refresh-part": "gap"
      }, [
        te(m) ? K(y.$slots, "indicator", {
          distance: te(u),
          progress: te(h),
          ready: te(v),
          refreshing: te($)
        }, () => [
          i("div", {
            class: E(["base-pull-to-refresh__indicator", { "base-pull-to-refresh__indicator--ready": te(v) || te($) }]),
            "aria-label": e.indicatorLabel,
            "aria-busy": te($),
            "data-refreshing": te($) ? "true" : "false",
            "data-pull-to-refresh-part": "indicator",
            role: "status"
          }, [
            U(te(Ht), {
              class: E(["base-pull-to-refresh__icon", { "base-pull-to-refresh__icon--refreshing": te($) }]),
              style: oe(d.value),
              "data-pull-to-refresh-part": "icon"
            }, null, 8, ["class", "style"])
          ], 10, Hl)
        ], !0, 0) : k("", !0)
      ], 4),
      K(y.$slots, "default", {
        distance: te(u),
        dragging: te(b),
        progress: te(h),
        ready: te(v),
        refreshing: te($)
      }, void 0, !0)
    ], 2));
  }
}), $i = /* @__PURE__ */ ge(Wl, [["__scopeId", "data-v-8a58d4fc"]]);
function Ol({
  gestureElement: e,
  refresh: n,
  enabled: a = !0,
  threshold: t = 64,
  maxDistance: r = 140,
  loadingDistance: o = 56,
  visibleDistance: c = 16,
  interactiveSelector: f = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: u
}) {
  const b = A(0), h = A(!1), v = A(!1), $ = w(() => b.value >= t), m = w(() => v.value || b.value >= c), g = w(() => Math.min(b.value / t, 1));
  let d = null, y = null;
  function x() {
    d = null, h.value = !1, v.value || (b.value = 0);
  }
  function L(N) {
    const z = e.value;
    if (v.value || !Ye(a) || !z || N.touches.length !== 1 || N.target instanceof Element && N.target.closest(f)) return;
    const P = N.touches[0];
    d = { x: P.clientX, y: P.clientY };
  }
  function S(N) {
    const z = e.value;
    if (!d || !z || N.touches.length !== 1) return;
    if (!Ye(a)) {
      x();
      return;
    }
    const P = N.touches[0], R = P.clientX - d.x, Z = P.clientY - d.y;
    if (Z <= 0 || Math.abs(R) > Math.abs(Z)) {
      x();
      return;
    }
    N.preventDefault(), h.value = !0, b.value = Math.min(Z, r);
  }
  async function T() {
    if (!d) return;
    const N = $.value;
    if (d = null, h.value = !1, !N) {
      b.value = 0;
      return;
    }
    v.value = !0, b.value = o;
    try {
      await n();
    } catch (z) {
      u?.(z);
    } finally {
      v.value = !1, b.value = 0;
    }
  }
  function j(N) {
    y?.(), y = null, N && (N.addEventListener("touchstart", L, { passive: !0 }), N.addEventListener("touchmove", S, { passive: !1 }), N.addEventListener("touchend", T, { passive: !0 }), N.addEventListener("touchcancel", x, { passive: !0 }), y = () => {
      N.removeEventListener("touchstart", L), N.removeEventListener("touchmove", S), N.removeEventListener("touchend", T), N.removeEventListener("touchcancel", x);
    });
  }
  return be(e, j, { flush: "post", immediate: !0 }), be(() => Ye(a), (N) => {
    N || x();
  }), Ie(() => y?.()), {
    pullDistance: b,
    pullDragging: h,
    pullProgress: g,
    pullReady: $,
    pullRefreshing: v,
    pullVisible: m,
    resetGesture: x
  };
}
const jl = ["aria-label", "aria-busy", "data-refreshing"], Fl = /* @__PURE__ */ re({
  __name: "BasePullToRefreshTrigger",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(null);
    async function c() {
      r("refreshStart");
      try {
        await t.refresh();
      } catch (d) {
        throw r("refreshError", d), d;
      } finally {
        r("refreshEnd");
      }
    }
    const {
      pullDistance: f,
      pullDragging: u,
      pullProgress: b,
      pullReady: h,
      pullRefreshing: v,
      pullVisible: $
    } = Ol({
      gestureElement: o,
      refresh: c,
      enabled: () => t.enabled,
      threshold: t.threshold,
      maxDistance: t.maxDistance,
      loadingDistance: t.loadingDistance,
      visibleDistance: t.visibleDistance,
      interactiveSelector: t.interactiveSelector
    }), m = w(() => ({
      transform: `translate(-50%, calc(-100% + ${f.value}px))`
    })), g = w(() => v.value ? void 0 : { transform: `rotate(${f.value * 4.5}deg)` });
    return n({
      gestureElement: o,
      pullDistance: f,
      pullDragging: u,
      pullProgress: b,
      pullReady: h,
      pullRefreshing: v,
      pullVisible: $
    }), (d, y) => (l(), s("div", {
      ref_key: "gestureElement",
      ref: o,
      class: E(["base-pull-to-refresh-trigger", [`base-pull-to-refresh-trigger--${e.theme}`, { "base-pull-to-refresh-trigger--dragging": te(u) }]]),
      "data-pull-to-refresh-part": "trigger"
    }, [
      te($) ? (l(), s("div", {
        key: 0,
        class: E(["base-pull-to-refresh-trigger__indicator", { "base-pull-to-refresh-trigger__indicator--ready": te(h) || te(v) }]),
        style: oe(m.value),
        "aria-label": e.indicatorLabel,
        "aria-busy": te(v),
        "data-refreshing": te(v) ? "true" : "false",
        "data-pull-to-refresh-part": "indicator",
        role: "status"
      }, [
        K(d.$slots, "indicator", {
          distance: te(f),
          progress: te(b),
          ready: te(h),
          refreshing: te(v)
        }, () => [
          U(te(Ht), {
            class: E(["base-pull-to-refresh-trigger__icon", { "base-pull-to-refresh-trigger__icon--refreshing": te(v) }]),
            style: oe(g.value),
            "data-pull-to-refresh-part": "icon"
          }, null, 8, ["class", "style"])
        ], !0)
      ], 14, jl)) : k("", !0),
      K(d.$slots, "default", {
        distance: te(f),
        dragging: te(u),
        progress: te(b),
        ready: te(h),
        refreshing: te(v)
      }, void 0, !0)
    ], 2));
  }
}), Ci = /* @__PURE__ */ ge(Fl, [["__scopeId", "data-v-61214d6f"]]), Kl = { class: "flex items-center gap-3" }, Nl = ["id", "disabled"], Ul = ["for"], Li = /* @__PURE__ */ re({
  __name: "BaseSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    disabled: { type: Boolean, default: !1 },
    id: { default: () => `switch-${Math.random().toString(36).slice(2, 11)}` }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const a = e, t = n;
    function r() {
      a.disabled || t("update:modelValue", !a.modelValue);
    }
    return (o, c) => (l(), s("div", Kl, [
      i("button", {
        type: "button",
        id: e.id,
        disabled: e.disabled,
        class: E([
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-dark-50",
          e.modelValue ? "bg-primary" : "bg-gray-200 dark:bg-dark-200",
          e.disabled ? "cursor-not-allowed opacity-50" : ""
        ]),
        onClick: r
      }, [
        i("span", {
          "aria-hidden": "true",
          class: E([
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
            e.modelValue ? "translate-x-5" : "translate-x-0"
          ])
        }, null, 2)
      ], 10, Nl),
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "text-sm font-medium text-gray-700 dark:text-dark-text-muted cursor-pointer",
        onClick: r
      }, I(e.label), 9, Ul)) : k("", !0)
    ]));
  }
}), ql = { class: "overflow-hidden rounded-xl border border-ui bg-surface" }, Xl = { class: "flex items-center gap-2 p-3" }, Yl = ["aria-expanded", "disabled"], Zl = { class: "min-w-0 truncate" }, Gl = {
  key: 0,
  class: "base-accordion-content grid border-t border-ui bg-surface-muted"
}, Jl = { class: "min-h-0 p-3" }, Ql = /* @__PURE__ */ re({
  __name: "BaseAccordion",
  props: {
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const a = e, t = n;
    function r() {
      a.disabled || t("update:modelValue", !a.modelValue);
    }
    return (o, c) => (l(), s("article", ql, [
      i("div", Xl, [
        i("button", {
          type: "button",
          class: "flex min-w-0 flex-1 items-center gap-2 text-left font-semibold text-ui transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50",
          "aria-expanded": e.modelValue,
          disabled: e.disabled,
          onClick: r
        }, [
          U(X, {
            name: "ChevronDown",
            size: 16,
            class: E(["shrink-0 transition-transform duration-200", e.modelValue ? "rotate-180" : ""]),
            decorative: ""
          }, null, 8, ["class"]),
          i("span", Zl, [
            K(o.$slots, "title", {}, void 0, !0)
          ])
        ], 8, Yl),
        i("div", {
          class: "shrink-0",
          onClick: c[0] || (c[0] = ve(() => {
          }, ["stop"]))
        }, [
          K(o.$slots, "actions", {}, void 0, !0)
        ])
      ]),
      U($e, { name: "base-accordion" }, {
        default: ie(() => [
          e.modelValue ? (l(), s("div", Gl, [
            i("div", Jl, [
              K(o.$slots, "default", {}, void 0, !0)
            ])
          ])) : k("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Si = /* @__PURE__ */ ge(Ql, [["__scopeId", "data-v-45ead6df"]]), _l = ["aria-label"], en = {
  key: 0,
  class: "base-breadcrumb__separator",
  "aria-hidden": "true"
}, tn = { class: "base-breadcrumb__entry" }, an = ["disabled", "aria-current", "onClick"], ln = /* @__PURE__ */ re({
  __name: "BaseBreadcrumb",
  props: {
    items: {},
    size: { default: "md" },
    density: { default: "comfortable" },
    separator: { default: "chevron" },
    ariaLabel: { default: "Breadcrumb" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = w(() => [
      "base-breadcrumb__list",
      `base-breadcrumb__list--${a.density}`
    ]), o = w(() => [
      "base-breadcrumb__item",
      `base-breadcrumb__item--${a.size}`
    ]);
    function c(u, b) {
      return u.current === !0 || b === a.items.length - 1;
    }
    function f(u, b) {
      !c(u, b) && !u.disabled && t("click", u, b);
    }
    return (u, b) => (l(), s("nav", {
      class: "base-breadcrumb",
      "aria-label": e.ariaLabel
    }, [
      i("ol", {
        class: E(r.value)
      }, [
        (l(!0), s(le, null, de(e.items, (h, v) => (l(), s(le, { key: v }, [
          v > 0 ? (l(), s("li", en, [
            U(X, {
              name: e.separator === "chevron" ? "ChevronRight" : "Slash",
              size: e.size === "sm" ? 13 : 14,
              decorative: ""
            }, null, 8, ["name", "size"])
          ])) : k("", !0),
          i("li", tn, [
            i("button", {
              type: "button",
              class: E([
                o.value,
                { "base-breadcrumb__item--current": c(h, v) },
                { "base-breadcrumb__item--disabled": h.disabled }
              ]),
              disabled: c(h, v) || h.disabled,
              "aria-current": c(h, v) ? "page" : void 0,
              onClick: ($) => f(h, v)
            }, [
              h.icon ? (l(), _(X, {
                key: 0,
                name: h.icon,
                size: e.size === "sm" ? 14 : 16,
                class: "base-breadcrumb__icon",
                decorative: ""
              }, null, 8, ["name", "size"])) : k("", !0),
              i("span", null, I(h.label), 1)
            ], 10, an)
          ])
        ], 64))), 128))
      ], 2)
    ], 8, _l));
  }
}), zi = /* @__PURE__ */ ge(ln, [["__scopeId", "data-v-20268304"]]), nn = ["aria-label", "aria-busy"], rn = {
  key: 0,
  class: "base-pagination-total items-center gap-1.5 text-[11px] text-ui-muted font-medium whitespace-nowrap px-3 py-1.5 bg-surface-muted rounded-lg border border-ui"
}, sn = { class: "text-ui font-bold px-1 bg-surface border border-ui rounded min-w-5 text-center" }, on = {
  key: 1,
  class: "base-pagination-dense-total flex items-center gap-1 text-[10px] text-ui-dim font-mono px-2 py-1 bg-surface-muted rounded-lg border border-ui"
}, un = { class: "font-bold text-ui-muted" }, dn = { class: "flex items-center gap-1.5" }, cn = ["disabled", "title", "aria-label", "aria-busy"], fn = ["disabled", "title", "aria-label", "aria-busy"], mn = { class: "flex items-center gap-1 mx-1" }, vn = ["aria-current", "aria-busy", "aria-label", "disabled", "onClick"], bn = {
  key: 1,
  class: "base-pagination-page-ellipsis min-w-8 h-8 items-center justify-center text-ui-dim font-medium",
  "aria-hidden": "true"
}, gn = ["disabled", "title", "aria-label", "aria-busy"], hn = ["disabled", "title", "aria-label", "aria-busy"], yn = {
  key: 2,
  class: "base-pagination-page-size items-center gap-2"
}, pn = { class: "text-[10px] uppercase text-ui-dim font-bold tracking-wider whitespace-nowrap" }, xn = { class: "flex min-w-0 items-center gap-1.5" }, wn = { class: "truncate" }, kn = /* @__PURE__ */ re({
  __name: "BasePagination",
  props: {
    modelValue: {},
    total: {},
    pageSize: {},
    pageSizes: { default: () => [10, 20, 50, 100] },
    dense: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    totalLabel: { default: "Total" },
    recordsLabel: { default: "records" },
    perPageLabel: { default: "Per page" },
    rowsLabel: { default: "rows" },
    pageLabel: { default: "Page" },
    paginationLabel: { default: "Pagination" },
    showTotal: { type: Boolean, default: !0 },
    showPageSize: { type: Boolean, default: !0 },
    firstPageLabel: { default: "First page" },
    previousPageLabel: { default: "Previous page" },
    nextPageLabel: { default: "Next page" },
    lastPageLabel: { default: "Last page" }
  },
  emits: ["update:modelValue", "update:pageSize", "change"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = w(() => Math.ceil(a.total / a.pageSize) || 1), o = A(null), c = (g) => {
      const d = o.value;
      return !!(a.loading && d && d.kind === g.kind && d.value === g.value);
    }, f = (g) => c({ kind: "page", value: g }), u = (g) => c({ kind: "control", value: g }), b = () => c({ kind: "pageSize", value: a.pageSize });
    be(() => a.loading, (g) => {
      g || (o.value = null);
    });
    const h = (g, d = { kind: "page", value: g }) => {
      g < 1 || g > r.value || g === a.modelValue || (o.value = d, t("update:modelValue", g), t("change", { page: g, pageSize: a.pageSize, reason: "page" }));
    }, v = (g) => {
      if (Array.isArray(g)) return;
      const d = typeof g == "number" ? g : parseInt(g, 10);
      !Number.isFinite(d) || d <= 0 || d === a.pageSize || (o.value = { kind: "pageSize", value: d }, t("update:pageSize", d), t("update:modelValue", 1), t("change", { page: 1, pageSize: d, reason: "pageSize" }));
    }, $ = w(() => a.pageSizes.map((g) => ({
      label: `${g} ${a.rowsLabel}`,
      value: g
    }))), m = w(() => {
      const g = r.value, d = a.modelValue;
      if (g <= 7)
        return Array.from({ length: g }, (L, S) => S + 1);
      const x = [];
      if (d <= 4) {
        for (let L = 1; L <= 5; L++) x.push(L);
        x.push("..."), x.push(g);
      } else if (d >= g - 3) {
        x.push(1), x.push("...");
        for (let L = g - 4; L <= g; L++) x.push(L);
      } else
        x.push(1), x.push("..."), x.push(d - 1), x.push(d), x.push(d + 1), x.push("..."), x.push(g);
      return x;
    });
    return (g, d) => (l(), s("nav", {
      class: E(["base-pagination flex items-center px-0 sm:px-1", [e.compact ? "justify-center gap-2" : "justify-between gap-4", e.dense ? "h-10" : "py-3"]]),
      "aria-label": e.paginationLabel,
      "aria-busy": e.loading || void 0
    }, [
      !e.compact && e.showTotal ? (l(), s("div", rn, [
        U(X, {
          name: "Database",
          size: 10,
          class: "text-ui-dim"
        }),
        i("span", null, I(e.totalLabel), 1),
        i("span", sn, I(e.total), 1),
        i("span", null, I(e.recordsLabel), 1)
      ])) : k("", !0),
      e.dense && !e.compact ? (l(), s("div", on, [
        i("span", un, I(e.total), 1)
      ])) : k("", !0),
      i("div", dn, [
        e.compact ? k("", !0) : (l(), s("button", {
          key: 0,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || u("first"),
          title: e.firstPageLabel,
          "aria-label": e.firstPageLabel,
          "aria-busy": u("first") || void 0,
          onClick: d[0] || (d[0] = (y) => h(1, { kind: "control", value: "first" }))
        }, [
          U(X, {
            name: u("first") ? "Loader2" : "ChevronsLeft",
            size: 14,
            class: E(u("first") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, cn)),
        i("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || u("previous"),
          title: e.previousPageLabel,
          "aria-label": e.previousPageLabel,
          "aria-busy": u("previous") || void 0,
          onClick: d[1] || (d[1] = (y) => h(e.modelValue - 1, { kind: "control", value: "previous" }))
        }, [
          U(X, {
            name: u("previous") ? "Loader2" : "ChevronLeft",
            size: 14,
            class: E(u("previous") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, fn),
        i("div", mn, [
          (l(!0), s(le, null, de(m.value, (y, x) => (l(), s(le, { key: x }, [
            typeof y == "number" ? (l(), s("button", {
              key: 0,
              class: E(["min-w-8 h-8 rounded-lg text-[10px] font-bold transition-all border flex items-center justify-center active:scale-95", [
                e.modelValue === y ? e.compact ? "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10 ring-1 ring-primary/20" : "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10" : "bg-surface text-ui-muted border-ui hover:border-ui-strong hover:text-ui shadow-xs",
                Math.abs(y - e.modelValue) > 1 && y !== 1 && y !== r.value ? "base-pagination-page-hidden" : ""
              ]]),
              "aria-current": e.modelValue === y ? "page" : void 0,
              "aria-busy": f(y) || void 0,
              "aria-label": `${e.pageLabel} ${y}`,
              disabled: f(y),
              onClick: (L) => h(y)
            }, [
              f(y) ? (l(), _(X, {
                key: 0,
                name: "Loader2",
                size: 13,
                class: "animate-spin"
              })) : (l(), s(le, { key: 1 }, [
                Be(I(y), 1)
              ], 64))
            ], 10, vn)) : (l(), s("span", bn, " ... "))
          ], 64))), 128))
        ]),
        i("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= r.value || u("next"),
          title: e.nextPageLabel,
          "aria-label": e.nextPageLabel,
          "aria-busy": u("next") || void 0,
          onClick: d[2] || (d[2] = (y) => h(e.modelValue + 1, { kind: "control", value: "next" }))
        }, [
          U(X, {
            name: u("next") ? "Loader2" : "ChevronRight",
            size: 14,
            class: E(u("next") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, gn),
        e.compact ? k("", !0) : (l(), s("button", {
          key: 1,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= r.value || u("last"),
          title: e.lastPageLabel,
          "aria-label": e.lastPageLabel,
          "aria-busy": u("last") || void 0,
          onClick: d[3] || (d[3] = (y) => h(r.value, { kind: "control", value: "last" }))
        }, [
          U(X, {
            name: u("last") ? "Loader2" : "ChevronsRight",
            size: 14,
            class: E(u("last") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, hn))
      ]),
      !e.compact && e.showPageSize ? (l(), s("div", yn, [
        i("span", pn, I(e.perPageLabel), 1),
        U(ht, {
          class: "!w-[108px] shrink-0",
          "model-value": e.pageSize,
          options: $.value,
          "aria-label": e.perPageLabel,
          "hide-chevron": b(),
          size: "sm",
          "onUpdate:modelValue": v
        }, {
          selected: ie(({ selectedOptions: y }) => [
            i("span", xn, [
              b() ? (l(), _(X, {
                key: 0,
                name: "Loader2",
                size: 12,
                class: "shrink-0 animate-spin text-primary"
              })) : k("", !0),
              i("span", wn, I(y[0]?.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["model-value", "options", "aria-label", "hide-chevron"])
      ])) : k("", !0)
    ], 10, nn));
  }
}), Bi = /* @__PURE__ */ ge(kn, [["__scopeId", "data-v-dd7b486c"]]), $n = { class: "w-full" }, Cn = ["disabled", "aria-label", "aria-busy"], Ln = {
  key: 0,
  class: "mt-2"
}, Sn = { class: "flex items-center justify-between mb-1" }, zn = { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, Bn = { class: "h-1.5 w-full bg-gray-100 dark:bg-dark-100 rounded-full overflow-hidden" }, Tn = {
  key: 1,
  class: "mt-2"
}, Mn = { class: "text-xs text-gray-500 dark:text-gray-400 pl-4 list-disc space-y-1" }, Ti = /* @__PURE__ */ re({
  __name: "BasePasswordInput",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    placeholder: { default: "Enter password" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    showStrength: { type: Boolean, default: !1 },
    showRules: { type: Boolean, default: !1 },
    toggleMask: { type: Boolean, default: !0 },
    visible: { type: Boolean, default: !1 },
    externalVisibility: { type: Boolean, default: !1 },
    visibilityLoading: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: "default" },
    strengthLabel: { default: "Password strength:" },
    weakLabel: { default: "Weak" },
    mediumLabel: { default: "Medium" },
    strongLabel: { default: "Strong" },
    minLengthRuleLabel: { default: "At least 8 characters" },
    uppercaseRuleLabel: { default: "At least 1 uppercase letter" },
    lowercaseRuleLabel: { default: "At least 1 lowercase letter" },
    numberRuleLabel: { default: "At least 1 number" }
  },
  emits: ["update:modelValue", "blur", "toggle-visibility"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = A(!1), o = w(() => a.externalVisibility ? a.visible : r.value), c = () => {
      if (!(a.disabled || a.readonly || a.visibilityLoading)) {
        if (a.externalVisibility) {
          t("toggle-visibility", !a.visible);
          return;
        }
        r.value = !r.value;
      }
    }, f = w(() => {
      const h = a.modelValue || "";
      if (!h) return 0;
      let v = 0;
      return h.length >= 8 && (v += 1), /[A-Z]/.test(h) && (v += 1), /[a-z]/.test(h) && (v += 1), /[0-9]/.test(h) && (v += 1), /[^A-Za-z0-9]/.test(h) && (v += 1), v;
    }), u = w(() => a.modelValue ? f.value <= 1 ? a.weakLabel : f.value <= 3 ? a.mediumLabel : a.strongLabel : ""), b = w(() => a.modelValue ? f.value <= 1 ? "bg-red-500" : f.value <= 3 ? "bg-yellow-500" : "bg-green-500" : "bg-gray-200");
    return (h, v) => (l(), s("div", $n, [
      U(je, We(h.$attrs, {
        id: e.id,
        "model-value": e.modelValue,
        type: o.value ? "text" : "password",
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        error: e.error,
        required: e.required,
        size: e.size,
        variant: e.variant,
        label: e.label,
        "onUpdate:modelValue": v[0] || (v[0] = ($) => t("update:modelValue", $)),
        onBlur: v[1] || (v[1] = ($) => t("blur", $))
      }), At({ _: 2 }, [
        e.toggleMask ? {
          name: "end",
          fn: ie(() => [
            i("button", {
              type: "button",
              class: "focus:outline-none text-gray-400 dark:text-gray-500 hover:text-primary transition-all p-1.5 rounded-lg hover:bg-primary/5 dark:hover:bg-primary/20 active:bg-primary/10 dark:active:bg-primary/30",
              disabled: e.disabled || e.readonly || e.visibilityLoading,
              "aria-label": o.value ? "Hide password" : "Show password",
              "aria-busy": e.visibilityLoading,
              onClick: c
            }, [
              e.visibilityLoading ? (l(), _(te(Ma), {
                key: 0,
                class: "w-4.5 h-4.5 animate-spin"
              })) : (l(), _(pt(o.value ? te(Ea) : te(Ia)), {
                key: 1,
                class: "w-4.5 h-4.5"
              }))
            ], 8, Cn)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["id", "model-value", "type", "placeholder", "disabled", "readonly", "error", "required", "size", "variant", "label"]),
      e.showStrength && e.modelValue ? (l(), s("div", Ln, [
        i("div", Sn, [
          i("span", zn, I(e.strengthLabel), 1),
          i("span", {
            class: E(["text-xs font-bold", {
              "text-red-500 dark:text-red-400": f.value <= 1,
              "text-yellow-500 dark:text-yellow-400": f.value > 1 && f.value <= 3,
              "text-green-500 dark:text-green-400": f.value > 3
            }])
          }, I(u.value), 3)
        ]),
        i("div", Bn, [
          i("div", {
            class: E(["h-full transition-all duration-300 ease-out rounded-full", b.value]),
            style: oe({ width: `${f.value / 5 * 100}%` })
          }, null, 6)
        ])
      ])) : k("", !0),
      e.showRules ? (l(), s("div", Tn, [
        K(h.$slots, "rules", {}, () => [
          i("ul", Mn, [
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": e.modelValue.length >= 8 })
            }, I(e.minLengthRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[A-Z]/.test(e.modelValue) })
            }, I(e.uppercaseRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[a-z]/.test(e.modelValue) })
            }, I(e.lowercaseRuleLabel), 3),
            i("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[0-9]/.test(e.modelValue) })
            }, I(e.numberRuleLabel), 3)
          ])
        ])
      ])) : k("", !0)
    ]));
  }
}), En = ["onClick"], In = { class: "font-medium" }, Vn = /* @__PURE__ */ re({
  __name: "BaseSplitButton",
  props: {
    label: {},
    menuItems: { default: () => [] },
    menuLabel: { default: "More actions" },
    size: { default: "md" },
    variant: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    menuPlacement: { default: "bottom-start" },
    menuOffset: { default: 8 },
    menuWidth: { default: "w-48" },
    menuClassName: { default: "custom-scrollbar" },
    menuPadding: { default: "py-1" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = A(!1), o = (f) => {
      a.disabled || t("click", f);
    }, c = (f) => {
      a.disabled || (f.command(), r.value = !1);
    };
    return (f, u) => (l(), s("div", {
      class: E(["relative items-stretch split-action-button-container", e.block ? "flex w-full" : "inline-flex"])
    }, [
      U(ze, {
        label: e.label,
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        block: e.block,
        class: E(["z-10 min-w-0", [
          { "rounded-r-none": e.menuItems.length > 0 },
          e.block ? "flex-1" : ""
        ]]),
        onClick: o
      }, null, 8, ["label", "size", "variant", "disabled", "block", "class"]),
      e.menuItems.length > 0 ? (l(), _(sl, {
        key: 0,
        visible: r.value,
        "onUpdate:visible": u[0] || (u[0] = (b) => r.value = b),
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        "aria-label": e.menuLabel,
        "has-popup": "menu",
        "chevron-size": e.size === "sm" ? 8 : 10,
        placement: e.menuPlacement,
        offset: e.menuOffset,
        "popover-width": e.menuWidth,
        "popover-padding": e.menuPadding,
        "popover-class-name": e.menuClassName,
        class: "shrink-0 rounded-l-none border-l border-white/20 -ml-px min-w-8 px-2"
      }, {
        popover: ie(() => [
          i("div", null, [
            (l(!0), s(le, null, de(e.menuItems, (b, h) => (l(), s("button", {
              key: h,
              class: "flex w-full items-center gap-2.5 px-4 py-2.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-dark-200",
              type: "button",
              onClick: (v) => c(b)
            }, [
              b.icon ? (l(), _(X, {
                key: 0,
                name: b.icon,
                class: "text-gray-400 dark:text-gray-500",
                size: 12
              }, null, 8, ["name"])) : k("", !0),
              i("span", In, I(b.label), 1)
            ], 8, En))), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible", "size", "variant", "disabled", "aria-label", "chevron-size", "placement", "offset", "popover-width", "popover-padding", "popover-class-name"])) : k("", !0)
    ], 2));
  }
}), Mi = /* @__PURE__ */ ge(Vn, [["__scopeId", "data-v-c1fa8d54"]]), Dn = { class: "flex flex-col w-full" }, Pn = ["disabled", "onClick"], An = { key: 0 }, Rn = {
  key: 1,
  class: "flex-1 min-h-0 flex flex-col w-full relative"
}, Hn = {
  key: 0,
  class: "flex-1 min-h-0 flex flex-col"
}, Wn = {
  key: 1,
  class: "flex-1 min-h-0 flex flex-col w-full"
}, On = {
  key: 0,
  class: "flex-1 min-h-0 flex flex-col"
}, jn = /* @__PURE__ */ re({
  __name: "BaseTabs",
  props: {
    modelValue: {},
    tabs: { default: () => [] },
    variant: { default: "default" },
    transitionMode: { default: "none" },
    tabListClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = ft(a, "modelValue");
    st("activeTab", r), st("updateTab", (u) => {
      r.value !== u && (t("change", u, r.value), t("update:modelValue", u));
    }), st("variant", ft(a, "variant")), st("transitionMode", ft(a, "transitionMode"));
    const o = w(() => a.tabs.filter((u) => u.visible !== !1)), c = w(() => a.transitionMode === "none" ? "" : a.transitionMode === "slide" ? "tab-slide" : "tab-fade"), f = (u) => {
      r.value !== u && (t("change", u, r.value), t("update:modelValue", u));
    };
    return (u, b) => (l(), s("div", Dn, [
      e.tabs.length > 0 ? (l(), s("div", {
        key: 0,
        class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", e.tabListClass])
      }, [
        U(Je, {
          name: "tabs-list",
          tag: "div",
          class: "flex w-full"
        }, {
          default: ie(() => [
            (l(!0), s(le, null, de(o.value, (h) => (l(), s("button", {
              key: h.id,
              type: "button",
              disabled: h.disabled,
              class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
                r.value === h.id ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
                h.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
              ]]),
              onClick: (v) => f(h.id)
            }, [
              K(u.$slots, `tab-${h.id}`, {}, () => [
                h.emoji ? (l(), s("span", An, I(h.emoji), 1)) : k("", !0),
                h.icon ? (l(), _(X, {
                  key: 1,
                  name: h.icon,
                  size: 16
                }, null, 8, ["name"])) : k("", !0),
                i("span", null, I(h.label), 1)
              ], !0)
            ], 10, Pn))), 128))
          ]),
          _: 3
        })
      ], 2)) : k("", !0),
      e.tabs.length > 0 ? (l(), s("div", Rn, [
        c.value ? (l(), _($e, {
          key: 0,
          name: c.value,
          mode: "out-in"
        }, {
          default: ie(() => [
            (l(), s("div", {
              key: r.value,
              class: "flex-1 min-h-0 flex flex-col w-full"
            }, [
              (l(!0), s(le, null, de(o.value, (h) => (l(), s(le, {
                key: h.id
              }, [
                r.value === h.id ? (l(), s("div", Hn, [
                  K(u.$slots, h.id, {}, void 0, !0)
                ])) : k("", !0)
              ], 64))), 128))
            ]))
          ]),
          _: 3
        }, 8, ["name"])) : (l(), s("div", Wn, [
          (l(!0), s(le, null, de(o.value, (h) => (l(), s(le, {
            key: h.id
          }, [
            r.value === h.id ? (l(), s("div", On, [
              K(u.$slots, h.id, {}, void 0, !0)
            ])) : k("", !0)
          ], 64))), 128))
        ]))
      ])) : K(u.$slots, "default", {}, void 0, !0, 2)
    ]));
  }
}), Ei = /* @__PURE__ */ ge(jn, [["__scopeId", "data-v-67590026"]]), Fn = ["disabled"], Kn = { key: 0 }, Ii = /* @__PURE__ */ re({
  __name: "BaseTab",
  props: {
    value: {},
    icon: {},
    emoji: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const n = e, a = Fe("activeTab"), t = Fe("updateTab"), r = w(() => a?.value === n.value), o = () => {
      !n.disabled && t && t(n.value);
    };
    return (c, f) => (l(), s("button", {
      type: "button",
      disabled: e.disabled,
      class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
        r.value ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
        e.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
      ]]),
      onClick: o
    }, [
      e.emoji ? (l(), s("span", Kn, I(e.emoji), 1)) : k("", !0),
      e.icon ? (l(), _(X, {
        key: 1,
        name: e.icon,
        size: 16
      }, null, 8, ["name"])) : k("", !0),
      K(c.$slots, "default", {}, () => [
        i("span", null, [
          K(c.$slots, "label")
        ])
      ])
    ], 10, Fn));
  }
}), Vi = /* @__PURE__ */ re({
  __name: "BaseTabList",
  setup(e) {
    const n = Fe("variant");
    return (a, t) => (l(), s("div", {
      class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", { "gap-1 p-1": te(n) === "compact" }])
    }, [
      K(a.$slots, "default")
    ], 2));
  }
}), Nn = { class: "w-full relative" }, Un = /* @__PURE__ */ re({
  __name: "BaseTabPanels",
  setup(e) {
    const n = Fe("activeTab"), a = Fe("transitionMode"), t = w(() => a?.value === "none" ? "" : a?.value === "slide" ? "tab-slide" : "tab-fade");
    return (r, o) => (l(), s("div", Nn, [
      U($e, {
        name: t.value,
        mode: "out-in"
      }, {
        default: ie(() => [
          (l(), s("div", {
            key: te(n),
            class: "w-full"
          }, [
            K(r.$slots, "default", {}, void 0, !0)
          ]))
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), Di = /* @__PURE__ */ ge(Un, [["__scopeId", "data-v-24cf149f"]]), Pi = /* @__PURE__ */ re({
  __name: "BaseTabPanel",
  props: {
    value: {}
  },
  setup(e) {
    const n = Fe("activeTab");
    return (a, t) => xt((l(), s("div", null, [
      K(a.$slots, "default")
    ], 512)), [
      [Qt, te(n) === e.value]
    ]);
  }
}), qn = {
  key: 0,
  class: "my-1 border-t border-gray-100 dark:border-white/8"
}, Xn = ["disabled", "onClick"], Ai = /* @__PURE__ */ re({
  __name: "BaseContextMenu",
  props: {
    menu: {},
    teleportTo: { default: "#app" }
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = A(null);
    be(() => a.menu, async (f) => {
      if (!f) return;
      await we();
      const u = r.value;
      if (!u) return;
      const { innerWidth: b, innerHeight: h } = window, { offsetWidth: v, offsetHeight: $ } = u;
      f.x + v > b && (u.style.left = `${b - v - 8}px`), f.y + $ > h && (u.style.top = `${h - $ - 8}px`);
    });
    function o(f) {
      f.disabled || (f.action(), t("close"));
    }
    function c(f) {
      f.target.closest("[data-context-menu]") || t("close");
    }
    return be(() => a.menu, (f) => {
      f ? window.addEventListener("mousedown", c, !0) : window.removeEventListener("mousedown", c, !0);
    }, { immediate: !0 }), ct(() => window.removeEventListener("mousedown", c, !0)), (f, u) => (l(), _(De, { to: e.teleportTo }, [
      e.menu ? (l(), s("div", {
        key: 0,
        ref_key: "menuRef",
        ref: r,
        "data-context-menu": "",
        class: "fixed z-[9999] min-w-[160px] py-1 rounded-lg shadow-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-dark-100 text-sm",
        style: oe({ left: `${e.menu.x}px`, top: `${e.menu.y}px` })
      }, [
        (l(!0), s(le, null, de(e.menu.items, (b, h) => (l(), s(le, { key: h }, [
          b.label === "---" ? (l(), s("div", qn)) : (l(), s("button", {
            key: 1,
            class: E(["w-full flex items-center gap-2.5 px-3 py-1.5 transition-colors text-left", [
              b.disabled ? "text-gray-300 dark:text-gray-600 cursor-not-allowed" : b.danger ? "text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10" : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-200"
            ]]),
            disabled: b.disabled,
            onClick: (v) => o(b)
          }, [
            b.icon ? (l(), _(X, {
              key: 0,
              name: b.icon,
              size: 13,
              class: "shrink-0 opacity-70"
            }, null, 8, ["name"])) : k("", !0),
            i("span", null, I(b.label), 1)
          ], 10, Xn))
        ], 64))), 128))
      ], 4)) : k("", !0)
    ], 8, ["to"]));
  }
}), Yn = { class: "relative w-full" }, Zn = { class: "flex items-center relative" }, Gn = ["aria-label"], Jn = {
  key: 0,
  class: "px-3 py-4 text-center"
}, Qn = { class: "text-[10px] text-ui-muted mt-1" }, _n = {
  key: 0,
  class: "base-autocomplete-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-ui-muted",
  role: "presentation",
  "aria-hidden": "true"
}, er = ["onMousedown"], tr = { class: "truncate flex-1 text-ui-muted" }, ar = {
  key: 1,
  class: "px-3 py-6 text-center text-ui-muted"
}, lr = { class: "text-[10px] mb-1" }, nr = {
  key: 2,
  class: "border-t border-ui px-3 py-2.5 text-center text-ui-muted",
  role: "status"
}, rr = { class: "text-[10px]" }, sr = {
  key: 3,
  class: "border-t border-ui px-3 py-2 text-center text-[10px] text-ui-muted",
  role: "status"
}, Ri = /* @__PURE__ */ re({
  __name: "BaseAutocomplete",
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    itemKey: { default: "id" },
    displayKey: { default: "name" },
    searchKeys: { default: () => ["name"] },
    size: { default: "md" },
    variant: { default: "default" },
    loading: { type: Boolean, default: !1 },
    label: { default: "" },
    error: { type: [String, Boolean] },
    loadingLabel: { default: "Searching..." },
    loadingMore: { type: Boolean, default: !1 },
    loadingMoreLabel: { default: "Loading more..." },
    hasMore: { type: Boolean, default: void 0 },
    endLabel: { default: "End of list" },
    emptyLabel: { default: "No options available" },
    noMatchesLabel: { default: "No matching items" },
    clearable: { type: Boolean, default: !1 },
    clearLabel: { default: "Clear value" },
    teleportTo: { default: "body" }
  },
  emits: ["update:modelValue", "select", "toggle", "reach-end"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = A(!1), o = A(!1), c = A({}), f = A(null), u = A(!1), b = A(""), h = w(() => f.value?.$el?.querySelector("input")), v = w(() => {
      if (o.value || !b.value.trim())
        return a.options;
      const z = b.value.toLowerCase();
      return a.options.filter((P) => a.searchKeys.some((R) => {
        const Z = $(P, R);
        return Z && String(Z).toLowerCase().includes(z);
      }));
    });
    function $(z, P) {
      return z ? z[P] : void 0;
    }
    const m = (z) => {
      const P = z ? String(z) : "";
      t("update:modelValue", P), b.value = P, o.value = !1, r.value = !0, T();
    }, g = () => {
      u.value = !0, o.value = !0, b.value = "", r.value = !0, t("toggle", !0), T(), setTimeout(() => {
        h.value?.select();
      }, 0);
    }, d = () => {
      r.value || (o.value = !0, b.value = "", r.value = !0, t("toggle", !0), T()), setTimeout(() => {
        h.value?.select();
      }, 0);
    }, y = () => {
      setTimeout(() => {
        r.value = !1;
      }, 200);
    }, x = (z) => {
      t("update:modelValue", String($(z, a.displayKey) ?? "")), t("select", z), r.value = !1, o.value = !1;
    }, L = () => {
      t("update:modelValue", ""), b.value = "", o.value = !1, r.value = !1;
    }, S = (z) => {
      if (a.loadingMore || a.hasMore !== !0) return;
      const P = z.currentTarget;
      P && P.scrollHeight - P.scrollTop - P.clientHeight <= 24 && t("reach-end");
    };
    function T() {
      const z = h.value || f.value?.$el;
      if (!z) return;
      const P = z.getBoundingClientRect();
      c.value = {
        position: "fixed",
        top: `${P.bottom}px`,
        left: `${P.left}px`,
        width: `${P.width}px`
      };
    }
    const j = (z) => {
      a.disabled || (z && (z.preventDefault(), z.stopPropagation()), r.value = !r.value, t("toggle", r.value), r.value && (o.value = !0, T(), setTimeout(() => {
        h.value?.focus(), h.value?.select();
      }, 50)));
    };
    be(r, (z) => {
      z ? (window.addEventListener("resize", T), window.addEventListener("scroll", T, !0)) : (window.removeEventListener("resize", T), window.removeEventListener("scroll", T, !0));
    }), ct(() => {
      window.removeEventListener("resize", T), window.removeEventListener("scroll", T, !0);
    });
    const N = (z) => {
      const P = $(z, a.displayKey);
      return !P || !a.modelValue ? !1 : String(P).trim().toLowerCase() === String(a.modelValue).trim().toLowerCase();
    };
    return (z, P) => (l(), s("div", Yn, [
      i("div", Zn, [
        U(je, {
          ref_key: "baseInputRef",
          ref: f,
          "model-value": e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          size: e.size,
          variant: e.variant,
          "input-class": e.size === "sm" ? "h-8" : void 0,
          label: e.label,
          error: e.error,
          autocomplete: "off",
          "onUpdate:modelValue": m,
          onFocus: g,
          onClick: d,
          onBlur: y
        }, {
          end: ie(() => [
            e.clearable && e.modelValue && !e.disabled ? (l(), s("button", {
              key: 0,
              type: "button",
              class: "text-ui-muted hover:text-danger transition-all cursor-pointer focus:outline-none p-1 -mr-1",
              "aria-label": e.clearLabel,
              tabindex: "-1",
              onMousedown: P[0] || (P[0] = ve(() => {
              }, ["stop"])),
              onClick: ve(L, ["stop"])
            }, [
              U(X, {
                name: "X",
                size: e.size === "sm" ? 14 : 16
              }, null, 8, ["size"])
            ], 40, Gn)) : k("", !0),
            e.disabled ? k("", !0) : (l(), s("button", {
              key: 1,
              type: "button",
              class: "text-ui-muted hover:text-primary transition-all cursor-pointer focus:outline-none p-1 -mr-1",
              tabindex: "-1",
              onMousedown: ve(j, ["stop"])
            }, [
              i("div", {
                class: E(["transition-transform duration-200", { "rotate-180": r.value }])
              }, [
                U(X, {
                  name: "ChevronDown",
                  size: e.size === "sm" ? 16 : 18
                }, null, 8, ["size"])
              ], 2)
            ], 32))
          ]),
          _: 1
        }, 8, ["model-value", "placeholder", "disabled", "size", "variant", "input-class", "label", "error"])
      ]),
      (l(), _(De, { to: e.teleportTo }, [
        r.value ? (l(), s("div", {
          key: 0,
          class: "fixed z-9999 mt-1 bg-surface border border-ui text-ui shadow-xl max-h-60 overflow-y-auto min-w-30 custom-scrollbar",
          style: oe(c.value),
          onScroll: S
        }, [
          e.loading && e.options.length === 0 ? (l(), s("div", Jn, [
            U(X, {
              name: "Loader2",
              class: "animate-spin text-primary",
              size: 14
            }),
            i("div", Qn, I(e.loadingLabel), 1)
          ])) : (l(), s(le, { key: 1 }, [
            v.value.length > 0 ? (l(!0), s(le, { key: 0 }, de(v.value, (R) => (l(), s(le, {
              key: String($(R, e.itemKey))
            }, [
              $(R, "group") && $(v.value[v.value.indexOf(R) - 1], "group") !== $(R, "group") ? (l(), s("div", _n, I($(R, "group")), 1)) : k("", !0),
              i("div", {
                class: E(["px-3 py-2 text-xs cursor-pointer transition-colors hover:bg-primary/15 hover:text-primary-light flex items-center justify-between gap-2", { "bg-primary/15 text-primary-light font-bold": N(R) }]),
                onMousedown: ve((Z) => x(R), ["prevent"])
              }, [
                i("div", tr, [
                  K(z.$slots, "default", { item: R }, () => [
                    Be(I($(R, e.displayKey)), 1)
                  ])
                ]),
                N(R) ? (l(), _(X, {
                  key: 0,
                  name: "Check",
                  class: "text-primary",
                  size: 10
                })) : k("", !0)
              ], 42, er)
            ], 64))), 128)) : (l(), s("div", ar, [
              i("div", lr, I(e.options.length === 0 ? e.emptyLabel : e.noMatchesLabel), 1)
            ])),
            e.loadingMore ? (l(), s("div", nr, [
              U(X, {
                name: "Loader2",
                class: "mr-1 inline-block animate-spin text-primary",
                size: 13
              }),
              i("span", rr, I(e.loadingMoreLabel), 1)
            ])) : e.hasMore === !1 && e.options.length > 0 ? (l(), s("div", sr, I(e.endLabel), 1)) : k("", !0)
          ], 64))
        ], 36)) : k("", !0)
      ], 8, ["to"]))
    ]));
  }
}), or = { class: "flex items-center gap-3 rounded-lg bg-gray-800 px-4 py-3 select-none" }, ir = ["disabled"], ur = {
  key: 0,
  viewBox: "0 0 24 24",
  class: "ml-0.5 h-4 w-4",
  fill: "currentColor"
}, dr = {
  key: 1,
  viewBox: "0 0 24 24",
  class: "h-4 w-4",
  fill: "currentColor"
}, cr = { class: "w-10 flex-shrink-0 text-right text-xs text-gray-400 tabular-nums" }, fr = { class: "w-10 flex-shrink-0 text-xs text-gray-400 tabular-nums" }, Hi = /* @__PURE__ */ re({
  __name: "BaseAudioPlayer",
  props: {
    autoplay: { type: Boolean }
  },
  emits: ["ended", "error"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = A(!1), c = A(0), f = A(0), u = A(0);
    let b = null, h = null, v = null, $ = 0, m = 0, g = 0;
    function d() {
      return b || (b = new AudioContext()), b;
    }
    function y(C) {
      const D = d(), B = C.reduce((pe, q) => pe + q.length, 0), F = C[0], me = F.sampleRate, ue = F.numberOfChannels, ce = D.createBuffer(ue, B, me);
      for (let pe = 0; pe < ue; pe++) {
        const q = ce.getChannelData(pe);
        let G = 0;
        for (const ee of C)
          q.set(ee.getChannelData(pe), G), G += ee.length;
      }
      return ce;
    }
    async function x(C) {
      const D = d();
      try {
        const B = await D.decodeAudioData(C.slice(0));
        v = y(v ? [v, B] : [B]), f.value = v.duration, t.autoplay && !o.value && S();
      } catch (B) {
        r("error", B instanceof Error ? B : new Error(String(B)));
      }
    }
    async function L(C) {
      const D = d();
      try {
        const F = await (await fetch(C)).arrayBuffer();
        v = await D.decodeAudioData(F), f.value = v.duration, t.autoplay && S();
      } catch (B) {
        r("error", B instanceof Error ? B : new Error(String(B)));
      }
    }
    function S() {
      if (!v || o.value) return;
      const C = d();
      C.state === "suspended" && C.resume(), h = C.createBufferSource(), h.buffer = v, h.connect(C.destination), h.onended = () => {
        o.value && (o.value = !1, c.value = 100, u.value = f.value, cancelAnimationFrame(g), r("ended"));
      };
      const D = m;
      h.start(0, D), $ = C.currentTime - D, o.value = !0, z();
    }
    function T() {
      !o.value || !h || !b || (m = b.currentTime - $, h.onended = null, h.stop(), h = null, o.value = !1, cancelAnimationFrame(g));
    }
    function j() {
      o.value ? T() : S();
    }
    function N(C) {
      if (!v) return;
      const B = C.currentTarget.getBoundingClientRect(), F = Math.max(0, Math.min(1, (C.clientX - B.left) / B.width)), me = o.value;
      me && T(), m = F * f.value, u.value = m, c.value = F * 100, me && S();
    }
    function z() {
      if (!o.value || !b) return;
      const C = b.currentTime - $;
      u.value = Math.min(C, f.value), c.value = f.value > 0 ? u.value / f.value * 100 : 0, g = requestAnimationFrame(z);
    }
    function P() {
      T(), v = null, c.value = 0, f.value = 0, u.value = 0, m = 0, $ = 0;
    }
    function R(C) {
      const D = Math.floor(C / 60), B = Math.floor(C % 60);
      return `${D}:${B.toString().padStart(2, "0")}`;
    }
    const Z = w(() => !!v);
    return ct(() => {
      if (cancelAnimationFrame(g), h) {
        h.onended = null;
        try {
          h.stop();
        } catch {
        }
      }
      b && b.close();
    }), n({
      appendChunk: x,
      loadAudio: L,
      play: S,
      pause: T,
      reset: P
    }), (C, D) => (l(), s("div", or, [
      i("button", {
        disabled: !Z.value,
        class: E(["flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-colors", Z.value ? "bg-blue-600 text-white hover:bg-blue-500" : "cursor-not-allowed bg-gray-700 text-gray-500"]),
        onClick: j
      }, [
        o.value ? (l(), s("svg", dr, [...D[1] || (D[1] = [
          i("rect", {
            x: "6",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1),
          i("rect", {
            x: "14",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1)
        ])])) : (l(), s("svg", ur, [...D[0] || (D[0] = [
          i("polygon", { points: "6,4 20,12 6,20" }, null, -1)
        ])]))
      ], 10, ir),
      i("span", cr, I(R(u.value)), 1),
      i("div", {
        class: "relative h-2 flex-1 cursor-pointer overflow-hidden rounded-full bg-gray-700",
        onClick: N
      }, [
        i("div", {
          class: "h-full rounded-full bg-blue-500 transition-[width] duration-100",
          style: oe({ width: `${c.value}%` })
        }, null, 4)
      ]),
      i("span", fr, I(R(f.value)), 1)
    ]));
  }
}), Le = [], mt = "__lunaMobileHistoryEntry";
let mr = 0, Qe = null, He = null, Xt = !1, Ze = 0, zt = !1;
function Yt() {
  zt || (zt = !0, window.addEventListener("popstate", () => {
    if (Ze > 0) {
      Ze--, Ze === 0 && Le.length === 0 && (He = null);
      return;
    }
    Le.at(-1)?.();
  }));
}
function Bt() {
  Le.length > 0 || (Qe?.destroy?.(), Qe = null, He = null);
}
function vr() {
  if (Xt || typeof window > "u" || !("CloseWatcher" in window)) return !1;
  if (Qe) return !0;
  try {
    const e = globalThis.CloseWatcher;
    if (!e) return !1;
    const n = new e();
    return n.onclose = () => {
      Le.at(-1)?.();
    }, Qe = n, !0;
  } catch {
    return !1;
  }
}
function Wi() {
  Le.length > 0 || (Xt = !0, Qe?.destroy?.(), Qe = null, He = "history", Yt());
}
function Oi() {
  return Le;
}
function br() {
  const e = A(!1), n = [];
  let a, t = null;
  function r() {
    if (He !== "history" || typeof window > "u" || !t) return !1;
    const v = window.history.state;
    return !!v && typeof v == "object" && v[mt] === t;
  }
  function o() {
    if (n.length > 0) {
      n.pop()(), c();
      return;
    }
    const v = Le.lastIndexOf(o);
    v !== -1 && Le.splice(v, 1), e.value = !1, c(), t = null, Bt(), a?.();
  }
  function c() {
    r() && (Ze++, history.back());
  }
  function f(v) {
    if (!e.value) {
      if (a = v, Le.length === 0 && (He = "history", Yt(), vr()), Le.push(o), He === "history") {
        t = `mobile-${++mr}`;
        const $ = history.state && typeof history.state == "object" ? history.state : {};
        history.pushState({
          ...$,
          [mt]: t,
          mobileEntry: !0
        }, "");
      }
      e.value = !0;
    }
  }
  function u() {
    if (!e.value) return;
    const v = 1 + n.length;
    n.length = 0;
    const $ = Le.lastIndexOf(o);
    $ !== -1 && Le.splice($, 1), e.value = !1;
    const m = r();
    t = null, m && (Ze++, history.go(-v)), Bt();
  }
  function b(v) {
    if (e.value && (n.push(v), He === "history")) {
      const $ = history.state && typeof history.state == "object" ? history.state : {};
      history.pushState({
        ...$,
        [mt]: t,
        mobileStep: !0
      }, "");
    }
  }
  function h() {
    n.length !== 0 && (n.pop(), He === "history" && (Ze++, history.back()));
  }
  return Ie(() => {
    e.value && u();
  }), { push: f, consume: u, pushBackStep: b, popBackStep: h, pushed: e };
}
const gr = ["aria-label"], hr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, yr = { class: "flex-1 min-w-0 mr-4" }, pr = {
  key: 0,
  class: "text-base md:text-lg font-bold text-ui truncate"
}, xr = { class: "flex items-center gap-1 shrink-0" }, wr = {
  key: 0,
  class: "flex items-center"
}, kr = {
  key: 0,
  class: "w-px h-6 bg-ui-border mx-1.5 sm:mx-2.5"
}, $r = ["title"], Cr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, Lr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, Sr = { class: "flex items-center justify-end gap-2 w-full" }, zr = "body", Br = 100, qe = 300, ut = 200, Tr = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BaseDialog",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    dialogLabel: { default: "" },
    width: { default: "auto" },
    maxWidth: { default: "md" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !1 },
    blockScroll: { type: Boolean, default: !0 },
    contentClass: { default: "" },
    bodyClass: { default: "" },
    footerClass: { default: "" },
    blurBackground: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 },
    zIndex: { default: 2e3 },
    fullScreen: { type: Boolean, default: !1 },
    maximizable: { type: Boolean, default: !1 },
    mobileStyle: { default: "modal" },
    closeOnBrowserBack: { type: Boolean, default: !0 },
    customBack: { type: Boolean, default: !1 },
    height: {},
    minHeight: {},
    resizable: { type: Boolean, default: !1 },
    resizeStorageKey: {},
    hideHeaderMobile: { type: Boolean },
    bodyOverflow: { default: "auto" },
    keyboardAware: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "update:fullScreen", "show", "after-show", "hide", "close", "maximize", "back", "viewport-resize", "after-hide"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a, o = w(() => {
      const W = {
        sm: "max-w-sm w-full",
        md: "max-w-md w-full",
        lg: "max-w-lg w-full",
        xl: "max-w-xl w-full",
        "2xl": "max-w-2xl w-full",
        "3xl": "max-w-3xl w-full",
        "4xl": "max-w-4xl w-full",
        "5xl": "max-w-5xl w-full",
        "6xl": "max-w-6xl w-full",
        "7xl": "max-w-7xl w-full",
        "8xl": "max-w-8xl w-full",
        full: "max-w-full w-full",
        none: ""
      };
      return W[t.maxWidth] || W.md;
    }), c = w(() => t.mobileStyle === "sheet"), f = w(() => `w-full h-full max-w-full sm:w-full sm:h-auto sm:max-h-[90%] ${{
      sm: "sm:max-w-sm",
      md: "sm:max-w-md",
      lg: "sm:max-w-lg",
      xl: "sm:max-w-xl",
      "2xl": "sm:max-w-2xl",
      "3xl": "sm:max-w-3xl",
      "4xl": "sm:max-w-4xl",
      "5xl": "sm:max-w-5xl",
      "6xl": "sm:max-w-6xl",
      "7xl": "sm:max-w-7xl",
      "8xl": "sm:max-w-8xl",
      full: "sm:max-w-full",
      none: ""
    }[t.maxWidth] || "sm:max-w-md"}`), u = Ft(), b = w(() => c.value && u.value), h = A(null);
    let v = null, $ = 0;
    wt(() => {
      if (t.keyboardAware && window.visualViewport) {
        $ = window.visualViewport.height;
        let W = !1;
        v = () => {
          const Q = window.visualViewport.height, ne = $ - Q;
          ne > Br && !W ? (W = !0, h.value = Q, r("viewport-resize", Q)) : ne < 50 && W && (W = !1, h.value = null, r("viewport-resize", $));
        }, window.visualViewport.addEventListener("resize", v);
      }
    });
    const m = A({ x: 0, y: 0 }), g = A(!1), d = A({ x: 0, y: 0 }), y = w(() => {
      const W = {};
      if ((m.value.x !== 0 || m.value.y !== 0) && (W["--dialog-tx"] = `${m.value.x}px`, W["--dialog-ty"] = `${m.value.y}px`), !t.fullScreen)
        if (P.value ? (W.width = `${P.value}px`, W.maxWidth = `${P.value}px`) : t.width && t.width !== "auto" && (W.width = t.width, W.maxWidth = t.width), t.keyboardAware && h.value) {
          const ne = u.value ? h.value : Math.min(h.value - 48, 700);
          W.height = `${ne}px`, W.maxHeight = `${ne}px`;
        } else R.value && (W.height = `${R.value}px`, W.maxHeight = `${R.value}px`);
      return W;
    }), x = w(() => {
      const W = {};
      return !t.fullScreen && !b.value && !R.value && (t.height && (W.height = t.height), t.minHeight && (W.minHeight = t.minHeight)), W;
    }), L = (W) => {
      t.draggable && (W.target.closest("button, a, input, textarea") || (g.value = !0, d.value = { x: W.clientX - m.value.x, y: W.clientY - m.value.y }, document.addEventListener("mousemove", S), document.addEventListener("mouseup", T)));
    }, S = (W) => {
      if (g.value) {
        if (W.buttons === 0) {
          T();
          return;
        }
        m.value = { x: W.clientX - d.value.x, y: W.clientY - d.value.y };
      }
    }, T = () => {
      g.value = !1, document.removeEventListener("mousemove", S), document.removeEventListener("mouseup", T);
    }, j = () => {
      m.value = { x: 0, y: 0 };
    };
    function N() {
      if (!t.resizeStorageKey) return null;
      try {
        const W = localStorage.getItem(t.resizeStorageKey);
        if (W) {
          const { w: Q, h: ne } = JSON.parse(W);
          if (typeof Q == "number" && typeof ne == "number") return { w: Q, h: ne };
        }
      } catch {
      }
      return null;
    }
    const z = N(), P = A(z?.w ?? null), R = A(z?.h ?? null), Z = A(!1), C = A("se"), D = A({ mouseX: 0, mouseY: 0, width: 0, height: 0, tx: 0, ty: 0 });
    function B() {
      if (!(!t.resizeStorageKey || !P.value || !R.value))
        try {
          localStorage.setItem(t.resizeStorageKey, JSON.stringify({ w: P.value, h: R.value }));
        } catch {
        }
    }
    function F(W, Q) {
      if (!t.resizable) return;
      W.preventDefault(), W.stopPropagation();
      const ne = G.value;
      if (!ne) return;
      const fe = ne.getBoundingClientRect();
      Z.value = !0, C.value = Q, D.value = { mouseX: W.clientX, mouseY: W.clientY, width: fe.width, height: fe.height, tx: m.value.x, ty: m.value.y }, document.addEventListener("mousemove", me), document.addEventListener("mouseup", ue);
    }
    function me(W) {
      if (!Z.value) return;
      if (W.buttons === 0) {
        ue();
        return;
      }
      const { mouseX: Q, mouseY: ne, width: fe, height: ke, tx: xe, ty: Me } = D.value, Ee = W.clientX - Q, Ne = W.clientY - ne, Pe = window.innerWidth - 48, M = window.innerHeight - 48, V = C.value;
      if (V === "s") {
        const H = Math.min(M, Math.max(ut, ke + Ne));
        R.value = H, m.value = { x: xe, y: Me + (H - ke) / 2 };
        return;
      }
      if (V === "n") {
        const H = Math.min(M, Math.max(ut, ke - Ne));
        R.value = H, m.value = { x: xe, y: Me - (H - ke) / 2 };
        return;
      }
      if (V === "e") {
        const H = Math.min(Pe, Math.max(qe, fe + Ee));
        P.value = H, m.value = { x: xe + (H - fe) / 2, y: Me };
        return;
      }
      if (V === "w") {
        const H = Math.min(Pe, Math.max(qe, fe - Ee));
        P.value = H, m.value = { x: xe - (H - fe) / 2, y: Me };
        return;
      }
      if (V === "se" || V === "sw") {
        const H = Math.min(M, Math.max(ut, ke + Ne));
        R.value = H;
        const se = V === "se" ? Math.min(Pe, Math.max(qe, fe + Ee)) : Math.min(Pe, Math.max(qe, fe - Ee));
        P.value = se, m.value = { x: V === "se" ? xe + (se - fe) / 2 : xe - (se - fe) / 2, y: Me + (H - ke) / 2 };
        return;
      }
      const p = Math.min(M, Math.max(ut, ke - Ne));
      R.value = p;
      const O = V === "ne" ? Math.min(Pe, Math.max(qe, fe + Ee)) : Math.min(Pe, Math.max(qe, fe - Ee));
      P.value = O, m.value = { x: V === "ne" ? xe + (O - fe) / 2 : xe - (O - fe) / 2, y: Me - (p - ke) / 2 };
    }
    function ue() {
      Z.value = !1, B(), document.removeEventListener("mousemove", me), document.removeEventListener("mouseup", ue);
    }
    const ce = () => {
      r("after-show");
    }, pe = () => {
      j(), r("after-hide");
    }, q = () => {
      r("update:visible", !1), r("close");
    }, G = A(null), ee = () => {
      const W = G.value, Q = !t.fullScreen;
      if (!W) {
        r("update:fullScreen", Q), r("maximize", Q);
        return;
      }
      const ne = W.getBoundingClientRect();
      r("update:fullScreen", Q), r("maximize", Q), we(() => {
        const fe = W.getBoundingClientRect(), ke = ne.width / fe.width, xe = ne.height / fe.height, Me = ne.left + ne.width / 2 - (fe.left + fe.width / 2), Ee = ne.top + ne.height / 2 - (fe.top + fe.height / 2);
        W.animate([
          { transform: `translate(${Me}px, ${Ee}px) scale(${ke}, ${xe})`, borderRadius: Q ? "12px" : "0px" },
          { transform: "translate(0, 0) scale(1, 1)", borderRadius: Q ? "0px" : "12px" }
        ], { duration: 350, easing: "cubic-bezier(0.4, 0, 0.2, 1)" });
      });
    }, he = () => {
      t.dismissableMask && t.closable && q();
    };
    let Oe = null;
    function Ke() {
      return Array.from(G.value?.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ) ?? []).filter((W) => W.getClientRects().length > 0);
    }
    function _e() {
      const [W] = Ke();
      W?.focus();
    }
    const J = (W) => {
      if (!t.visible) return;
      if (t.closeOnEscape && W.key === "Escape") {
        W.preventDefault(), q();
        return;
      }
      if (W.key !== "Tab") return;
      const Q = Ke();
      if (!Q.length) return;
      const ne = Q[0], fe = Q[Q.length - 1];
      W.shiftKey && document.activeElement === ne ? (W.preventDefault(), fe.focus()) : !W.shiftKey && document.activeElement === fe && (W.preventDefault(), ne.focus());
    }, { push: Y, consume: ae, pushBackStep: Ce, popBackStep: Te } = br();
    return n({ pushBackStep: Ce, popBackStep: Te, wrapperRef: G }), be(() => [t.visible, t.closeOnBrowserBack, t.closable, u.value], ([W]) => {
      const Q = W && t.closeOnBrowserBack && t.closable && u.value;
      W ? (Oe = document.activeElement instanceof HTMLElement ? document.activeElement : null, r("show"), t.blockScroll && (document.body.style.overflow = "hidden"), window.addEventListener("keydown", J), we(_e), Q ? Y(q) : ae()) : (r("hide"), t.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", J), Oe?.focus(), Oe = null, ae());
    }, { immediate: !0 }), Ie(() => {
      t.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", J), document.removeEventListener("mousemove", S), document.removeEventListener("mouseup", T), document.removeEventListener("mousemove", me), document.removeEventListener("mouseup", ue), v && window.visualViewport?.removeEventListener("resize", v);
    }), (W, Q) => (l(), _(De, { to: zr }, [
      U($e, {
        name: b.value ? "dialog-slide" : "dialog",
        appear: "",
        onAfterEnter: ce,
        onAfterLeave: pe
      }, {
        default: ie(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: E(["fixed inset-0 flex justify-center", {
              "pointer-events-none": !e.modal,
              "p-4 sm:p-6": !e.fullScreen && !c.value,
              "sm:p-6": c.value && !e.fullScreen,
              "select-none": Z.value,
              "items-start": e.keyboardAware && !!h.value && b.value,
              "items-center": !(e.keyboardAware && h.value && b.value)
            }]),
            style: oe({ zIndex: e.zIndex }),
            onMousedown: Q[10] || (Q[10] = ve(() => {
            }, ["stop"]))
          }, [
            e.modal ? (l(), s("div", {
              key: 0,
              class: E(["fixed inset-0 bg-black/40 transition-opacity dialog-backdrop", { "backdrop-blur-[2px]": e.blurBackground }]),
              onClick: he
            }, null, 2)) : k("", !0),
            i("div", {
              ref_key: "wrapperRef",
              ref: G,
              class: E(["relative z-10 dialog-scale-wrapper flex flex-col pointer-events-auto origin-center", [e.fullScreen ? "w-full h-full max-w-full" : c.value ? f.value : `${o.value} max-h-[90%]`]]),
              style: oe(y.value)
            }, [
              i("div", {
                class: E(["base-dialog-panel relative shadow-2xl w-full h-full flex flex-col overflow-hidden border bg-surface text-ui border-ui", [e.contentClass, e.fullScreen ? "max-h-full rounded-none" : c.value ? "max-h-full rounded-none sm:rounded-xl" : "rounded-xl"]]),
                style: oe(x.value),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": e.dialogLabel || e.header || void 0
              }, [
                W.$slots.header || e.header || e.closable ? (l(), s("div", {
                  key: 0,
                  class: E(["base-dialog-header border-b border-ui flex items-center min-h-12 md:min-h-14 shrink-0 transition-all duration-500", [
                    e.fullScreen ? "px-4 py-2" : b.value ? "px-3 py-3" : "px-6 py-3",
                    { "cursor-move select-none": e.draggable },
                    { "max-sm:hidden": e.hideHeaderMobile }
                  ]]),
                  onMousedown: L,
                  onDblclick: Q[1] || (Q[1] = (ne) => {
                    e.maximizable && !b.value && !ne.target.closest("button, a, input") && ee();
                  })
                }, [
                  e.closable && b.value ? (l(), s("button", {
                    key: 0,
                    type: "button",
                    title: "返回",
                    "aria-label": "返回",
                    "data-testid": "base-dialog-mobile-back",
                    onClick: Q[0] || (Q[0] = (ne) => e.customBack ? r("back") : q()),
                    class: "flex items-center justify-center mr-2 shrink-0 transition-colors"
                  }, [
                    i("div", hr, [
                      U(X, {
                        name: "ArrowLeft",
                        size: 18
                      })
                    ])
                  ])) : k("", !0),
                  i("div", yr, [
                    K(W.$slots, "header", {}, () => [
                      e.header ? (l(), s("h3", pr, I(e.header), 1)) : k("", !0)
                    ], !0)
                  ]),
                  i("div", xr, [
                    W.$slots.actions ? (l(), s("div", wr, [
                      K(W.$slots, "actions", {}, void 0, !0),
                      b.value ? k("", !0) : (l(), s("div", kr))
                    ])) : k("", !0),
                    e.maximizable && e.closable && !b.value ? (l(), s("button", {
                      key: 1,
                      onClick: ee,
                      class: "flex items-center justify-center transition-colors group/max",
                      title: e.fullScreen ? "還原視窗" : "全螢幕顯示"
                    }, [
                      i("div", Cr, [
                        U(X, {
                          name: e.fullScreen ? "minimize-2" : "maximize-2",
                          size: 14
                        }, null, 8, ["name"])
                      ])
                    ], 8, $r)) : k("", !0),
                    e.closable && !b.value ? (l(), s("button", {
                      key: 2,
                      onClick: q,
                      class: "flex items-center justify-center transition-colors group/close",
                      title: "關閉對話框"
                    }, [
                      i("div", Lr, [
                        U(X, {
                          name: "X",
                          size: 14
                        })
                      ])
                    ])) : k("", !0)
                  ])
                ], 34)) : k("", !0),
                W.$slots["body-top"] ? (l(), s("div", {
                  key: 1,
                  class: E(["base-dialog-body-top shrink-0 border-b border-ui", e.fullScreen ? "px-3 py-2 md:px-6" : "px-6 py-4"])
                }, [
                  K(W.$slots, "body-top", {}, void 0, !0)
                ], 2)) : k("", !0),
                i("div", {
                  class: E(["base-dialog-body flex-1", [e.bodyClass, e.bodyOverflow === "hidden" ? "overflow-hidden" : "overflow-y-auto custom-scrollbar", e.fullScreen ? "px-3 py-2 md:px-6 md:py-4" : "px-6 py-4"]])
                }, [
                  K(W.$slots, "default", {}, void 0, !0)
                ], 2),
                W.$slots.footer ? (l(), s("div", {
                  key: 2,
                  class: E(["border-t border-ui bg-surface-muted rounded-b-xl shrink-0", [e.fullScreen ? "px-4 py-3" : "px-6 py-4", e.footerClass]])
                }, [
                  i("div", Sr, [
                    K(W.$slots, "footer", {}, void 0, !0)
                  ])
                ], 2)) : k("", !0)
              ], 14, gr),
              e.resizable && !e.fullScreen && !b.value ? (l(), s(le, { key: 0 }, [
                i("div", {
                  class: "absolute right-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: Q[2] || (Q[2] = ve((ne) => F(ne, "e"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute left-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: Q[3] || (Q[3] = ve((ne) => F(ne, "w"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: Q[4] || (Q[4] = ve((ne) => F(ne, "n"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute bottom-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: Q[5] || (Q[5] = ve((ne) => F(ne, "s"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 right-0 w-5 h-5 cursor-nesw-resize z-30",
                  onMousedown: Q[6] || (Q[6] = ve((ne) => F(ne, "ne"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute top-0 left-0 w-5 h-5 cursor-nwse-resize z-30",
                  onMousedown: Q[7] || (Q[7] = ve((ne) => F(ne, "nw"), ["stop"]))
                }, null, 32),
                i("div", {
                  class: "absolute bottom-0 right-0 w-5 h-5 cursor-nwse-resize z-30 group/rs",
                  onMousedown: Q[8] || (Q[8] = ve((ne) => F(ne, "se"), ["stop"]))
                }, [...Q[11] || (Q[11] = [
                  i("svg", {
                    class: "absolute bottom-0.5 right-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    i("path", {
                      d: "M9 1L1 9M9 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32),
                i("div", {
                  class: "absolute bottom-0 left-0 w-5 h-5 cursor-nesw-resize z-30 group/rs",
                  onMousedown: Q[9] || (Q[9] = ve((ne) => F(ne, "sw"), ["stop"]))
                }, [...Q[12] || (Q[12] = [
                  i("svg", {
                    class: "absolute bottom-0.5 left-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    i("path", {
                      d: "M1 1L9 9M1 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32)
              ], 64)) : k("", !0)
            ], 6)
          ], 38)) : k("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), Mr = /* @__PURE__ */ ge(Tr, [["__scopeId", "data-v-21a4b8f6"]]), Er = {
  key: 0,
  class: "flex flex-shrink-0 justify-center pt-3"
}, Ir = {
  key: 1,
  class: "flex flex-shrink-0 items-center justify-between gap-3 px-4 py-3"
}, Vr = { class: "min-w-0" }, Dr = "body", Tt = "Close drawer", Pr = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "BaseDrawer",
  props: {
    visible: { type: Boolean, default: !1 },
    title: {},
    subtitle: {},
    position: { default: "bottom" },
    theme: { default: "light" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !0 },
    zIndex: { default: 2200 },
    maxHeight: { default: "72vh" },
    width: { default: "24rem" },
    showHandle: { type: Boolean, default: !0 },
    panelClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["update:visible", "close", "after-hide"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = w(() => a.position === "left" ? "base-drawer-left" : a.position === "right" ? "base-drawer-right" : "base-drawer-bottom"), o = w(() => a.position === "right" ? "right-0 top-0 h-full rounded-l-2xl" : a.position === "left" ? "left-0 top-0 h-full rounded-r-2xl" : "inset-x-0 bottom-0 rounded-t-3xl"), c = w(() => a.position === "bottom" ? "w-full" : "max-w-[92vw]"), f = w(() => a.position === "bottom" ? { maxHeight: a.maxHeight } : { width: a.width }), u = w(() => a.theme === "dark" ? "border-white/10 bg-[#0b1320] text-white shadow-black/50" : "border-slate-200 bg-white text-slate-950 shadow-slate-900/20"), b = w(() => a.theme === "dark" ? "bg-black/45" : "bg-slate-950/35"), h = w(() => a.theme === "dark" ? "bg-white/20" : "bg-slate-300"), v = w(() => a.theme === "dark" ? "text-white" : "text-slate-950"), $ = w(() => a.theme === "dark" ? "text-slate-400" : "text-slate-500"), m = w(() => a.theme === "dark" ? "bg-white/8 text-slate-200 hover:bg-white/12" : "bg-slate-100 text-slate-700 hover:bg-slate-200"), g = w(() => a.theme === "dark" ? "border-white/10" : "border-slate-200");
    function d() {
      t("update:visible", !1), t("close");
    }
    function y() {
      t("after-hide");
    }
    function x() {
      a.dismissableMask && d();
    }
    function L(S) {
      S.key === "Escape" && a.closeOnEscape && a.visible && d();
    }
    return be(() => a.visible, (S) => {
      document.body.style.overflow = S ? "hidden" : "";
    }), wt(() => document.addEventListener("keydown", L)), Ie(() => {
      document.removeEventListener("keydown", L), document.body.style.overflow = "";
    }), (S, T) => (l(), _(De, { to: Dr }, [
      U($e, {
        name: r.value,
        appear: "",
        onAfterLeave: y
      }, {
        default: ie(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: "fixed inset-0",
            style: oe({ zIndex: e.zIndex })
          }, [
            e.modal ? (l(), s("button", {
              key: 0,
              type: "button",
              class: E(["absolute inset-0 transition-colors", b.value]),
              "aria-label": Tt,
              onClick: x
            }, null, 2)) : k("", !0),
            i("section", {
              class: E(["absolute flex flex-col overflow-hidden border shadow-2xl", [o.value, c.value, e.panelClass, u.value]]),
              style: oe(f.value),
              role: "dialog",
              "aria-modal": "true"
            }, [
              e.showHandle && e.position === "bottom" ? (l(), s("div", Er, [
                i("span", {
                  class: E(["h-1.5 w-11 rounded-full", h.value])
                }, null, 2)
              ])) : k("", !0),
              S.$slots.header || e.title || e.closable ? (l(), s("header", Ir, [
                i("div", Vr, [
                  K(S.$slots, "header", {}, () => [
                    e.title ? (l(), s("p", {
                      key: 0,
                      class: E(["truncate text-sm font-semibold", v.value])
                    }, I(e.title), 3)) : k("", !0),
                    e.subtitle ? (l(), s("p", {
                      key: 1,
                      class: E(["mt-0.5 truncate text-xs", $.value])
                    }, I(e.subtitle), 3)) : k("", !0)
                  ], !0)
                ]),
                e.closable ? (l(), s("button", {
                  key: 0,
                  type: "button",
                  class: E(["flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-colors", m.value]),
                  "aria-label": Tt,
                  onClick: d
                }, [
                  U(X, {
                    name: "X",
                    size: 16
                  })
                ], 2)) : k("", !0)
              ])) : k("", !0),
              i("div", {
                class: E(["base-drawer-body custom-scrollbar min-h-0 flex-1 overflow-y-auto px-4 pb-4", e.bodyClass])
              }, [
                K(S.$slots, "default", {}, void 0, !0)
              ], 2),
              S.$slots.footer ? (l(), s("footer", {
                key: 2,
                class: E(["flex flex-shrink-0 items-center justify-end gap-2 border-t px-4 py-3", g.value])
              }, [
                K(S.$slots, "footer", {}, void 0, !0)
              ], 2)) : k("", !0)
            ], 6)
          ], 4)) : k("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), ji = /* @__PURE__ */ ge(Pr, [["__scopeId", "data-v-daaade83"]]), Ar = { class: "overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-xs custom-scrollbar dark:border-dark-200 dark:bg-dark-50" }, Rr = { class: "w-full min-w-250 border-collapse text-left" }, Hr = { class: "border-b border-gray-200 bg-gray-50 dark:border-dark-200 dark:bg-dark-100" }, Wr = {
  key: 0,
  class: "w-24 px-3 py-2.5 text-center text-[11px] font-bold uppercase tracking-wider text-gray-700 dark:text-gray-300"
}, Or = { class: "divide-y divide-gray-200 dark:divide-gray-700" }, jr = {
  key: 3,
  class: "text-gray-900 dark:text-gray-200"
}, Fr = {
  key: 0,
  class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200"
}, Kr = { class: "flex items-center justify-center gap-2" }, Nr = ["title", "aria-label"], Ur = ["title", "aria-label"], qr = ["title", "aria-label", "onClick"], Xr = ["title", "aria-label", "onClick"], Yr = {
  key: 0,
  class: "bg-primary/5 transition-colors hover:bg-primary/10 dark:bg-primary/10 dark:hover:bg-primary/15"
}, Zr = {
  key: 3,
  class: "text-gray-400 italic dark:text-gray-500"
}, Gr = { class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200" }, Jr = ["title", "aria-label"], Qr = {
  key: 1,
  class: "border-t-2 border-gray-200 bg-gray-50/80 font-bold dark:border-dark-200 dark:bg-dark-100/80"
}, _r = ["colspan"], es = { class: "flex w-full items-center justify-between" }, ts = { class: "text-left text-gray-700 dark:text-gray-300" }, as = { class: "text-right text-gray-700 dark:text-gray-300" }, ls = { class: "px-3 py-3 text-right text-sm whitespace-nowrap text-primary" }, Fi = /* @__PURE__ */ re({
  __name: "BaseEditableTable",
  props: {
    data: {},
    columns: {},
    editingIndex: {},
    editingRow: {},
    newItem: {},
    totalLabel: {},
    totalValue: {},
    readonly: { type: Boolean, default: !1 },
    actionsLabel: { default: "Actions" },
    saveLabel: { default: "Save" },
    cancelLabel: { default: "Cancel" },
    editLabel: { default: "Edit" },
    deleteLabel: { default: "Delete" },
    addLabel: { default: "Add" },
    autoLabel: { default: "Auto" }
  },
  emits: ["start-edit", "save-edit", "cancel-edit", "remove-row", "add-item"],
  setup(e, { emit: n }) {
    const a = n, t = (r) => r === "center" ? "text-center" : r === "right" ? "text-right" : "text-left";
    return (r, o) => (l(), s("div", Ar, [
      i("table", Rr, [
        i("thead", null, [
          i("tr", Hr, [
            (l(!0), s(le, null, de(e.columns, (c) => (l(), s("th", {
              key: c.key,
              style: oe({ width: c.width }),
              class: E(["border-r border-gray-200 px-3 py-2.5 text-[11px] font-bold uppercase tracking-wider whitespace-pre-line text-gray-700 last:border-r-0 dark:border-dark-200 dark:text-gray-300", t(c.align)])
            }, I(c.label), 7))), 128)),
            e.readonly ? k("", !0) : (l(), s("th", Wr, I(e.actionsLabel), 1))
          ])
        ]),
        i("tbody", Or, [
          (l(!0), s(le, null, de(e.data, (c, f) => (l(), s("tr", {
            key: f,
            class: E([f % 2 === 1 ? "bg-gray-50/50 dark:bg-dark-100/30" : "bg-white dark:bg-dark-50/40", "transition-colors hover:bg-primary/5 dark:hover:bg-primary/10"])
          }, [
            (l(!0), s(le, null, de(e.columns, (u) => (l(), s("td", {
              key: u.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", t(u.align)])
            }, [
              e.editingIndex === f && e.editingRow ? K(r.$slots, `edit-${u.key}`, {
                row: e.editingRow,
                index: f
              }, () => [
                u.type === "text" ? (l(), _(je, {
                  key: 0,
                  modelValue: e.editingRow[u.key],
                  "onUpdate:modelValue": (b) => e.editingRow[u.key] = b,
                  placeholder: u.placeholder,
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : u.type === "number" ? (l(), _(je, {
                  key: 1,
                  modelValue: e.editingRow[u.key],
                  "onUpdate:modelValue": (b) => e.editingRow[u.key] = b,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: u.placeholder,
                  size: "sm",
                  class: E({ "text-right": u.align === "right" })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : u.type === "select" ? (l(), _(ht, {
                  key: 2,
                  modelValue: e.editingRow[u.key],
                  "onUpdate:modelValue": (b) => e.editingRow[u.key] = b,
                  options: u.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", jr, I(c[u.key]), 1))
              ], void 0, 0) : K(r.$slots, `cell-${u.key}`, {
                row: c,
                index: f
              }, () => [
                i("span", {
                  class: E(u.type === "readonly" ? "text-gray-500 dark:text-gray-400" : "text-gray-900 dark:text-gray-200")
                }, I(c[u.key]), 3)
              ], void 0, 1)
            ], 2))), 128)),
            e.readonly ? k("", !0) : (l(), s("td", Fr, [
              i("div", Kr, [
                e.editingIndex === f ? (l(), s(le, { key: 0 }, [
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-green-600 transition-colors hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20",
                    title: e.saveLabel,
                    "aria-label": e.saveLabel,
                    onClick: o[0] || (o[0] = (u) => a("save-edit"))
                  }, [
                    U(X, {
                      name: "Save",
                      size: 14
                    })
                  ], 8, Nr),
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 dark:text-gray-500 dark:hover:bg-dark-200",
                    title: e.cancelLabel,
                    "aria-label": e.cancelLabel,
                    onClick: o[1] || (o[1] = (u) => a("cancel-edit"))
                  }, [
                    U(X, {
                      name: "X",
                      size: 14
                    })
                  ], 8, Ur)
                ], 64)) : (l(), s(le, { key: 1 }, [
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                    title: e.editLabel,
                    "aria-label": e.editLabel,
                    onClick: (u) => a("start-edit", f)
                  }, [
                    U(X, {
                      name: "Pencil",
                      size: 14
                    })
                  ], 8, qr),
                  i("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20",
                    title: e.deleteLabel,
                    "aria-label": e.deleteLabel,
                    onClick: (u) => a("remove-row", f)
                  }, [
                    U(X, {
                      name: "Trash2",
                      size: 14
                    })
                  ], 8, Xr)
                ], 64))
              ])
            ]))
          ], 2))), 128)),
          e.readonly ? k("", !0) : (l(), s("tr", Yr, [
            (l(!0), s(le, null, de(e.columns, (c) => (l(), s("td", {
              key: c.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", t(c.align)])
            }, [
              K(r.$slots, `new-${c.key}`, { row: e.newItem }, () => [
                c.type === "text" ? (l(), _(je, {
                  key: 0,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (f) => e.newItem[c.key] = f,
                  placeholder: c.placeholder,
                  size: "sm",
                  onKeyup: o[2] || (o[2] = Ct((f) => a("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : c.type === "number" ? (l(), _(je, {
                  key: 1,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (f) => e.newItem[c.key] = f,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: c.placeholder,
                  size: "sm",
                  class: E({ "text-right": c.align === "right" }),
                  onKeyup: o[3] || (o[3] = Ct((f) => a("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : c.type === "select" ? (l(), _(ht, {
                  key: 2,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (f) => e.newItem[c.key] = f,
                  options: c.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", Zr, I(e.autoLabel), 1))
              ])
            ], 2))), 128)),
            i("td", Gr, [
              i("button", {
                type: "button",
                class: "mx-auto flex items-center justify-center rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                title: e.addLabel,
                "aria-label": e.addLabel,
                onClick: o[4] || (o[4] = (c) => a("add-item"))
              }, [
                U(X, {
                  name: "Plus",
                  size: 16
                })
              ], 8, Jr)
            ])
          ])),
          e.totalLabel ? (l(), s("tr", Qr, [
            i("td", {
              colspan: e.readonly ? e.columns.length - 1 : e.columns.length,
              class: "px-3 py-3 text-sm"
            }, [
              i("div", es, [
                i("span", ts, [
                  K(r.$slots, "footer-left")
                ]),
                i("span", as, I(e.totalLabel) + ": ", 1)
              ])
            ], 8, _r),
            i("td", ls, I(e.totalValue), 1)
          ])) : k("", !0)
        ])
      ])
    ]));
  }
}), ns = ["aria-busy"], rs = {
  key: 0,
  class: "base-table-header-cell px-4 py-3.5 w-10 text-center sticky top-0 z-10 backdrop-blur-md"
}, ss = ["checked", "indeterminate"], os = ["onClick"], is = {
  key: 0,
  class: "text-[10px] text-primary animate-in fade-in zoom-in duration-300"
}, us = ["data-table-row-kind", "data-table-row-key", "onClick"], ds = ["checked", "onChange"], cs = {
  key: 0,
  class: "flex items-center gap-2"
}, fs = ["colspan"], ms = {
  key: 0,
  class: "base-table-skeleton-table w-full border-collapse text-left text-xs",
  "aria-hidden": "true"
}, vs = {
  key: 0,
  class: "base-table-cell px-4 py-3 w-10"
}, bs = {
  key: 1,
  class: "base-table-empty-state flex flex-col items-center justify-center py-12"
}, gs = { class: "base-table-empty-icon w-16 h-16 rounded-full flex items-center justify-center text-3xl mb-4 border shadow-inner" }, hs = { class: "base-table-empty-title text-sm font-bold mb-1" }, ys = {
  key: 0,
  class: "base-table-empty-description text-[11px] max-w-xs text-center"
}, ps = ["aria-label"], xs = { class: "sr-only" }, ws = /* @__PURE__ */ re({
  __name: "BaseTable",
  props: {
    columns: {},
    data: {},
    sortField: { default: "" },
    sortDirection: { default: "" },
    loading: { type: Boolean, default: !1 },
    emptyMessage: { default: "No data" },
    emptyDescription: {},
    emptyIcon: { default: "Inbox" },
    loadingLabel: { default: "Loading" },
    rowKey: { type: [String, Function], default: "id" },
    rowAttrs: {},
    rowTransition: { default: "slide" },
    expandable: { type: Boolean, default: !1 },
    expandedRows: {},
    highlightIds: {},
    disableTransition: { type: Boolean, default: !1 },
    minHeight: { default: "" },
    fixedLayout: { type: Boolean, default: !1 },
    rowClass: {},
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" },
    hoverable: { type: Boolean, default: !0 },
    striped: { type: Boolean, default: !1 },
    emptyText: {},
    headerClass: { default: "" }
  },
  emits: ["sort", "update:expandedRows", "row-click", "update:selection"],
  setup(e, { emit: n }) {
    const a = e, t = w(() => a.emptyMessage), r = w(() => a.emptyDescription || ""), o = A(a.disableTransition);
    be(
      () => a.disableTransition,
      (C) => {
        C ? o.value = !0 : setTimeout(() => {
          o.value = !1;
        }, 100);
      },
      { immediate: !0 }
    );
    const c = n, f = A(/* @__PURE__ */ new Set()), u = (C) => (a.expandedRows || f.value).has(C), b = (C) => {
      const D = new Set(a.expandedRows || f.value);
      D.has(C) ? D.delete(C) : D.add(C), a.expandedRows ? c("update:expandedRows", D) : f.value = D;
    }, h = (C, D) => {
      a.expandable && b(D), c("row-click", C, D);
    }, v = w(() => a.columns.filter((C) => C.visible !== !1)), $ = (C) => {
      c("sort", C);
    }, m = (C) => typeof a.selectionKey == "function" ? a.selectionKey(C) : String(C[a.selectionKey] ?? ""), g = (C) => a.selection.has(m(C)), d = (C) => {
      const D = m(C), B = new Set(a.selection);
      B.has(D) ? B.delete(D) : B.add(D), c("update:selection", B);
    }, y = w(() => a.data.length === 0 ? !1 : a.data.every((C) => a.selection.has(m(C)))), x = w(() => {
      if (a.data.length === 0) return !1;
      const C = a.data.filter(
        (D) => a.selection.has(m(D))
      ).length;
      return C > 0 && C < a.data.length;
    }), L = () => {
      const C = new Set(a.selection);
      y.value ? a.data.forEach((D) => C.delete(m(D))) : a.data.forEach((D) => C.add(m(D))), c("update:selection", C);
    }, S = (C, D) => typeof a.rowKey == "function" ? a.rowKey(C) : String(C[a.rowKey] ?? D), T = (C, D) => {
      const B = String(D).split(".");
      let F = C;
      for (const me of B) {
        if (F == null || typeof F != "object") return null;
        F = F[me];
      }
      return F;
    }, j = (C, D) => {
      const B = T(C, D.key);
      return B == null ? "-" : D.formatter ? D.formatter(B, C) : Array.isArray(B) ? B.join(", ") : String(B);
    }, N = (C) => {
      const D = [];
      return C.key === "name" ? D.push("font-medium") : C.key === "id" && D.push("font-mono text-[10px]"), D.join(" ");
    }, z = w(() => o.value || a.rowTransition === "none" ? "" : a.rowTransition === "fade-collapse" ? "base-table-fade-collapse" : "list"), P = (C, D, B) => a.rowAttrs?.(C, D, B) || {}, R = (C, D) => {
      if (a.rowTransition !== "fade-collapse" || o.value || typeof window > "u") {
        D();
        return;
      }
      const B = C, F = B.getBoundingClientRect().height;
      B.style.height = `${F}px`, B.style.overflow = "hidden", B.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        B.style.height = "0px", B.style.opacity = "0";
      }), window.setTimeout(D, 200);
    }, Z = w(() => {
      const C = [];
      return a.data.forEach((D, B) => {
        const F = S(D, B);
        C.push({ type: "main", row: D, index: B, key: F }), a.expandable && u(F) && C.push({ type: "expanded", row: D, index: B, key: `${F}-expanded` });
      }), C;
    });
    return (C, D) => (l(), s("div", {
      class: E([
        "base-table-surface overflow-auto custom-scrollbar border rounded-2xl shadow-sm relative transition-all duration-300",
        { "no-transitions": o.value }
      ]),
      "aria-busy": e.loading,
      style: oe(e.minHeight ? { minHeight: e.minHeight } : {})
    }, [
      i("table", {
        class: E([
          "w-full border-collapse text-left text-xs",
          { "table-fixed": e.fixedLayout }
        ])
      }, [
        i("thead", null, [
          i("tr", {
            class: E(e.headerClass)
          }, [
            e.selectable ? (l(), s("th", rs, [
              i("input", {
                type: "checkbox",
                checked: y.value,
                indeterminate: x.value,
                onChange: L,
                class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
              }, null, 40, ss)
            ])) : k("", !0),
            (l(!0), s(le, null, de(v.value, (B) => (l(), s("th", {
              key: String(B.key),
              class: E([
                "base-table-header-cell px-4 py-3.5 font-bold transition-all duration-200 group sticky top-0 z-10 backdrop-blur-md",
                B.sortable ? "base-table-header-cell--sortable cursor-pointer" : "",
                B.align === "center" ? "text-center" : B.align === "right" ? "text-right" : "text-left"
              ]),
              style: oe(B.width ? { width: B.width } : {}),
              onClick: (F) => B.sortable ? $(B.key) : null
            }, [
              K(C.$slots, `header-${String(B.key)}`, { column: B }, () => [
                i("div", {
                  class: E(["flex items-center gap-1.5", B.align === "center" ? "justify-center" : B.align === "right" ? "justify-end" : ""])
                }, [
                  i("span", null, I(B.label), 1),
                  B.sortable && e.sortField === B.key ? (l(), s("span", is, I(e.sortDirection === "asc" ? "↑" : "↓"), 1)) : B.sortable ? (l(), _(X, {
                    key: 1,
                    name: "ChevronDown",
                    size: 10,
                    class: "opacity-0 group-hover:opacity-30 transition-opacity"
                  })) : k("", !0)
                ], 2)
              ], !0)
            ], 14, os))), 128))
          ], 2)
        ]),
        U(Je, {
          name: z.value,
          css: !o.value && e.rowTransition !== "none",
          tag: "tbody",
          onLeave: R
        }, {
          default: ie(() => [
            (l(!0), s(le, null, de(Z.value, (B) => (l(), s("tr", We({
              key: B.key,
              "data-table-row-kind": B.type,
              "data-table-row-key": B.key
            }, { ref_for: !0 }, P(B.row, B.key, B.type), {
              class: [
                "base-table-row transition-colors duration-200 border-b",
                B.type === "main" ? " hover:bg-primary/5 dark:hover:bg-primary/10 cursor-pointer" + (e.highlightIds?.includes(B.key) ? " animate-highlight" : "") : " whitespace-normal",
                B.type === "main" && e.rowClass ? typeof e.rowClass == "function" ? e.rowClass(B.row) : e.rowClass : ""
              ],
              onClick: (F) => B.type === "main" ? h(B.row, B.key) : null
            }), [
              B.type === "main" ? (l(), s(le, { key: 0 }, [
                e.selectable ? (l(), s("td", {
                  key: 0,
                  class: "base-table-cell px-4 py-3 w-10 text-center",
                  onClick: D[0] || (D[0] = ve(() => {
                  }, ["stop"]))
                }, [
                  i("input", {
                    type: "checkbox",
                    checked: g(B.row),
                    onChange: (F) => d(B.row),
                    class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
                  }, null, 40, ds)
                ])) : k("", !0),
                (l(!0), s(le, null, de(v.value, (F) => (l(), s("td", {
                  key: String(F.key),
                  class: E([
                    "base-table-cell px-4 py-3 min-w-25",
                    F.key === "id" || F.key === "_id" || String(F.key).toLowerCase().includes("id") ? "whitespace-nowrap" : "",
                    F.align === "center" ? "text-center" : F.align === "right" ? "text-right" : "text-left",
                    N(F)
                  ])
                }, [
                  e.expandable && F === v.value[0] ? (l(), s("div", cs, [
                    U(X, {
                      name: "ChevronRight",
                      size: 10,
                      class: E(["base-table-expand-icon transition-transform duration-300", { "rotate-90": u(B.key) }])
                    }, null, 8, ["class"]),
                    K(C.$slots, `cell-${String(F.key)}`, {
                      row: B.row,
                      column: F,
                      value: T(B.row, F.key)
                    }, () => [
                      Be(I(j(B.row, F)), 1)
                    ], !0)
                  ])) : K(C.$slots, `cell-${String(F.key)}`, {
                    row: B.row,
                    column: F,
                    value: T(B.row, F.key)
                  }, () => [
                    Be(I(j(B.row, F)), 1)
                  ], !0, 1)
                ], 2))), 128))
              ], 64)) : (l(), s("td", {
                key: 1,
                colspan: v.value.length + (e.selectable ? 1 : 0),
                class: "base-table-expanded-cell px-4 py-4 border-t"
              }, [
                K(C.$slots, "expanded-row", {
                  row: B.row,
                  index: B.index
                }, void 0, !0)
              ], 8, fs))
            ], 16, us))), 128))
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2),
      e.loading && e.data.length === 0 ? (l(), s("table", ms, [
        i("tbody", null, [
          (l(), s(le, null, de(5, (B) => i("tr", {
            key: `loading-skeleton-${B}`,
            class: "base-table-row border-b"
          }, [
            e.selectable ? (l(), s("td", vs, [...D[1] || (D[1] = [
              i("div", { class: "base-table-skeleton-block mx-auto h-4 w-4 rounded" }, null, -1)
            ])])) : k("", !0),
            (l(!0), s(le, null, de(v.value, (F) => (l(), s("td", {
              key: String(F.key),
              class: "base-table-cell px-4 py-3"
            }, [
              i("div", {
                class: E(["base-table-skeleton-block h-3 rounded", F.align === "right" ? "ml-auto w-2/3" : "w-3/4"])
              }, null, 2)
            ]))), 128))
          ])), 64))
        ])
      ])) : k("", !0),
      e.data.length === 0 && !e.loading ? (l(), s("div", bs, [
        K(C.$slots, "empty", {}, () => [
          i("div", gs, [
            U(X, { name: e.emptyIcon }, null, 8, ["name"])
          ]),
          i("h3", hs, I(t.value), 1),
          r.value ? (l(), s("p", ys, I(r.value), 1)) : k("", !0)
        ], !0)
      ])) : k("", !0),
      U($e, {
        "enter-active-class": "transition-opacity duration-300",
        "leave-active-class": "transition-opacity duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ie(() => [
          e.loading && e.data.length > 0 ? (l(), s("div", {
            key: 0,
            class: "base-table-loading pointer-events-none absolute inset-x-0 top-0 z-20 h-0.5 overflow-hidden",
            role: "status",
            "aria-label": e.loadingLabel
          }, [
            D[2] || (D[2] = i("div", { class: "base-table-loading-progress h-full w-2/5" }, null, -1)),
            K(C.$slots, "loading", {}, () => [
              i("span", xs, I(e.loadingLabel), 1)
            ], !0)
          ], 8, ps)) : k("", !0)
        ]),
        _: 3
      })
    ], 14, ns));
  }
}), Ki = /* @__PURE__ */ ge(ws, [["__scopeId", "data-v-9eb9da19"]]), ks = ["aria-busy"], $s = {
  key: 0,
  class: "base-collection-view-empty flex min-h-48 items-center justify-center"
}, Cs = { class: "base-collection-view-empty-content flex flex-col items-center gap-2 text-center" }, Ls = { class: "base-collection-view-empty-title text-sm font-bold" }, Ss = {
  key: 0,
  class: "base-collection-view-empty-description max-w-xs text-xs"
}, zs = {
  key: 0,
  class: "base-collection-view-loading absolute inset-0 z-10 flex items-center justify-center backdrop-blur-[1px]"
}, Bs = { class: "flex flex-col items-center gap-3" }, Ts = { class: "base-collection-view-loading-label text-[11px] font-bold uppercase tracking-widest animate-pulse" }, Ms = /* @__PURE__ */ re({
  __name: "BaseCollectionView",
  props: {
    items: {},
    itemKey: { type: [String, Function], default: "id" },
    itemTag: { default: "article" },
    itemClass: { type: [String, Function], default: "" },
    itemAttrs: { type: Function, default: void 0 },
    itemState: {},
    layout: { default: "grid" },
    minItemWidth: { default: "14rem" },
    gap: { default: "1rem" },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    emptyMessage: { default: "No items" },
    emptyDescription: { default: "" },
    emptyIcon: { default: "Inbox" },
    minHeight: { default: "" },
    transition: { default: "fade-collapse" },
    clickable: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" }
  },
  emits: ["item-click", "item-dblclick", "update:selection"],
  setup(e, { emit: n }) {
    const a = e, t = n, r = w(() => a.layout === "grid" ? "grid" : "flex flex-col"), o = w(
      () => a.layout === "grid" ? {
        gridTemplateColumns: `repeat(auto-fill, minmax(${a.minItemWidth}, 1fr))`,
        gap: a.gap
      } : { gap: a.gap }
    ), c = w(() => a.transition === "none" ? "" : a.transition === "fade-collapse" ? "base-collection-fade-collapse" : "base-collection-slide"), f = (x, L) => typeof a.itemKey == "function" ? a.itemKey(x, L) : String(x[a.itemKey] ?? L), u = (x, L) => typeof a.selectionKey == "function" ? a.selectionKey(x, L) : String(x[a.selectionKey] ?? f(x, L)), b = (x, L = 0) => a.selection.has(u(x, L)), h = (x, L) => a.itemState?.(x, L, f(x, L)) || {}, v = (x, L) => a.itemAttrs?.(x, L, f(x, L)) || {}, $ = (x, L = 0) => {
      if (!a.selectable || h(x, L).disabled) return;
      const S = new Set(a.selection), T = u(x, L);
      S.has(T) ? S.delete(T) : S.add(T), t("update:selection", S);
    }, m = (x, L) => {
      !a.clickable || h(x, L).disabled || t("item-click", x, f(x, L), L);
    }, g = (x, L, S) => {
      !a.clickable || h(L, S).disabled || x.key !== "Enter" && x.key !== " " || (x.preventDefault(), m(L, S));
    }, d = (x, L) => {
      !a.clickable || h(x, L).disabled || t("item-dblclick", x, f(x, L), L);
    }, y = (x, L) => {
      if (a.transition !== "fade-collapse" || typeof window > "u") {
        L();
        return;
      }
      const S = x;
      S.style.height = `${S.getBoundingClientRect().height}px`, S.style.overflow = "hidden", S.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        S.style.height = "0px", S.style.opacity = "0";
      }), window.setTimeout(L, 200);
    };
    return (x, L) => (l(), s("div", {
      class: "base-collection-view relative",
      style: oe(e.minHeight ? { minHeight: e.minHeight } : void 0),
      "aria-busy": e.loading || void 0
    }, [
      e.items.length === 0 && !e.loading ? (l(), s("div", $s, [
        K(x.$slots, "empty", {}, () => [
          i("div", Cs, [
            U(X, {
              name: e.emptyIcon,
              size: 28
            }, null, 8, ["name"]),
            i("span", Ls, I(e.emptyMessage), 1),
            e.emptyDescription ? (l(), s("span", Ss, I(e.emptyDescription), 1)) : k("", !0)
          ])
        ], !0)
      ])) : e.items.length > 0 ? (l(), _(Je, {
        key: 1,
        name: c.value,
        css: e.transition !== "none",
        tag: "div",
        role: "list",
        class: E(["base-collection-view-items", r.value]),
        style: oe(o.value),
        onLeave: y
      }, {
        default: ie(() => [
          (l(!0), s(le, null, de(e.items, (S, T) => (l(), _(pt(e.itemTag), We({
            key: f(S, T),
            class: ["base-collection-view-item", [
              typeof e.itemClass == "function" ? e.itemClass(S, T) : e.itemClass,
              {
                "base-collection-view-item--pending": h(S, T).pending,
                "base-collection-view-item--disabled": h(S, T).disabled
              }
            ]],
            "data-collection-item-key": f(S, T)
          }, { ref_for: !0 }, v(S, T), {
            role: "listitem",
            "aria-selected": e.selectable ? b(S) : void 0,
            "aria-disabled": h(S, T).disabled || void 0,
            tabindex: e.clickable && !h(S, T).disabled ? 0 : void 0,
            onClick: (j) => m(S, T),
            onDblclick: (j) => d(S, T),
            onKeydown: (j) => g(j, S, T)
          }), {
            default: ie(() => [
              K(x.$slots, "item", {
                item: S,
                index: T,
                keyValue: f(S, T),
                selected: b(S),
                pending: h(S, T).pending,
                disabled: h(S, T).disabled,
                toggleSelection: () => $(S)
              }, void 0, !0)
            ]),
            _: 2
          }, 1040, ["class", "data-collection-item-key", "aria-selected", "aria-disabled", "tabindex", "onClick", "onDblclick", "onKeydown"]))), 128))
        ]),
        _: 3
      }, 8, ["name", "css", "class", "style"])) : k("", !0),
      U($e, {
        "enter-active-class": "transition-opacity duration-200",
        "leave-active-class": "transition-opacity duration-200",
        "enter-from-class": "opacity-0",
        "leave-to-class": "opacity-0"
      }, {
        default: ie(() => [
          e.loading ? (l(), s("div", zs, [
            K(x.$slots, "loading", {}, () => [
              i("div", Bs, [
                L[0] || (L[0] = i("div", { class: "base-collection-view-spinner h-8 w-8 animate-spin rounded-full border-2 border-transparent border-t-current" }, null, -1)),
                i("span", Ts, I(e.loadingLabel), 1)
              ])
            ], !0)
          ])) : k("", !0)
        ]),
        _: 3
      })
    ], 12, ks));
  }
}), Ni = /* @__PURE__ */ ge(Ms, [["__scopeId", "data-v-ae3c38cf"]]), Es = {
  key: 0,
  class: "fixed bottom-8 left-1/2 z-50 -translate-x-1/2"
}, Is = { class: "flex items-center gap-5 rounded-2xl border border-white/10 bg-gray-900/90 px-5 py-2.5 text-white shadow-[0_20px_50px_rgba(0,0,0,0.3)] ring-1 ring-white/5 backdrop-blur-md dark:bg-dark-100/95" }, Vs = { class: "flex items-center gap-3 border-r border-white/10 pr-5" }, Ds = { class: "flex h-7 w-7 items-center justify-center rounded-lg bg-primary/20 text-xs font-bold text-primary-400 shadow-inner ring-1 ring-primary/30" }, Ps = { class: "text-[13px] font-semibold tracking-wide whitespace-nowrap" }, As = { class: "flex items-center gap-2" }, Rs = ["title", "aria-label"], Ui = /* @__PURE__ */ re({
  __name: "BatchActionBar",
  props: {
    selectedCount: {},
    selectedLabel: { default: "Selected" },
    clearLabel: { default: "Clear selection" }
  },
  emits: ["clear"],
  setup(e) {
    return (n, a) => (l(), _($e, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "translate-y-full opacity-0",
      "enter-to-class": "translate-y-0 opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "translate-y-0 opacity-100",
      "leave-to-class": "translate-y-full opacity-0"
    }, {
      default: ie(() => [
        e.selectedCount > 0 ? (l(), s("div", Es, [
          i("div", Is, [
            i("div", Vs, [
              i("div", Ds, I(e.selectedCount), 1),
              i("span", Ps, I(e.selectedLabel), 1)
            ]),
            i("div", As, [
              K(n.$slots, "default", { count: e.selectedCount })
            ]),
            i("button", {
              class: "group ml-1 rounded-xl p-1.5 text-white/40 transition-all duration-200 hover:bg-white/10 hover:text-white",
              title: e.clearLabel,
              "aria-label": e.clearLabel,
              onClick: a[0] || (a[0] = (t) => n.$emit("clear"))
            }, [
              U(X, {
                name: "x",
                size: 16,
                class: "transition-transform duration-300 group-hover:rotate-90"
              })
            ], 8, Rs)
          ])
        ])) : k("", !0)
      ]),
      _: 3
    }));
  }
}), Ve = A([]);
function qi() {
  function e(a) {
    return new Promise((t) => {
      Ve.value = [...Ve.value, { opts: a, resolve: t }];
    });
  }
  function n() {
    const a = Ve.value[0];
    a && (a.resolve(!1), Ve.value = Ve.value.slice(1));
  }
  return { confirm: e, closeDialog: n };
}
const Hs = { class: "flex flex-col items-center text-center p-2 pt-6" }, Ws = { class: "confirmation-message text-sm mb-4 max-w-[90%] mx-auto" }, Os = {
  key: 0,
  class: "text-xs text-red-500 font-bold mb-6 italic"
}, js = {
  key: 0,
  class: "flex flex-col gap-1.5 mb-3"
}, Fs = { class: "confirmation-summary-label transition-colors" }, Ks = { class: "confirmation-summary-value font-bold font-mono tracking-tight" }, Ns = {
  key: 1,
  class: "border-t border-gray-200 dark:border-dark-200 my-2 opacity-50"
}, Us = { class: "flex gap-2 text-left" }, qs = { class: "flex flex-col gap-1.5 w-full" }, Xs = {
  key: 0,
  class: "confirmation-detail-text text-xs wrap-break-word whitespace-pre-wrap"
}, Ys = {
  key: 1,
  class: "confirmation-detail-text text-xs list-none p-0 m-0 space-y-1.5"
}, Zs = { class: "flex items-start gap-1.5 flex-1 leading-relaxed" }, Gs = {
  key: 0,
  class: "confirmation-detail-label font-bold whitespace-nowrap"
}, Js = { class: "wrap-break-word flex-1" }, Qs = {
  key: 2,
  class: "mt-3 pt-2 border-t border-gray-200/60 dark:border-dark-200/60 flex gap-2 text-left"
}, _s = { class: "confirmation-note text-[10px]" }, eo = { class: "grid grid-cols-2 gap-3 w-full mt-2" }, to = /* @__PURE__ */ re({
  __name: "ConfirmationDialog",
  setup(e) {
    const n = {
      title: "確認",
      message: "確定要執行此操作嗎?",
      confirmLabel: "確認",
      cancelLabel: "取消",
      severity: "info",
      showInfoIcon: !1,
      showBulletPoints: !1,
      scrollable: !0,
      maxHeight: "240px"
    }, a = A(!1), t = A(!1), r = A({ ...n });
    be(Ve, async (P) => {
      P.length > 0 && !a.value && (await we(), t.value = !1, r.value = { ...n, ...P[0].opts }, a.value = !0);
    }, { immediate: !0 });
    function o(P) {
      const R = Ve.value[0];
      R && R.resolve(P), Ve.value = Ve.value.slice(1), a.value = !1;
    }
    const c = w(() => {
      if (r.value.icon) return r.value.icon;
      switch (r.value.severity) {
        case "danger":
          return "AlertTriangle";
        case "warning":
          return "AlertCircle";
        case "success":
          return "CheckCircle2";
        default:
          return "Info";
      }
    }), f = w(() => {
      switch (r.value.severity) {
        case "danger":
          return "confirmation-icon--danger";
        case "warning":
          return "confirmation-icon--warning";
        case "success":
          return "confirmation-icon--success";
        default:
          return "confirmation-icon--info";
      }
    }), u = w(() => {
      switch (r.value.severity) {
        case "danger":
          return "confirmation-icon-pulse--danger";
        case "warning":
          return "confirmation-icon-pulse--warning";
        case "success":
          return "confirmation-icon-pulse--success";
        default:
          return "confirmation-icon-pulse--info";
      }
    }), b = w(() => {
      switch (r.value.severity) {
        case "danger":
          return "danger";
        case "warning":
          return "warning";
        case "success":
          return "success";
        default:
          return "primary";
      }
    }), h = w(() => r.value.title), v = w(() => r.value.message), $ = w(() => r.value.warning), m = w(() => r.value.details), g = w(() => r.value.detailsItems), d = w(() => r.value.summary), y = w(() => r.value.note), x = w(() => r.value.confirmLabel || "確認"), L = w(() => r.value.cancelLabel || "取消");
    w(() => r.value.severity || "info");
    const S = w(() => r.value.width || "420px"), T = w(() => r.value.contentClass || ""), j = (P) => {
      const R = P.match(/^([^:：]+[:：])\s*(.*)$/s);
      return R ? { label: R[1], text: R[2] } : { label: "", text: P };
    };
    async function N() {
      if (r.value.onConfirm) {
        t.value = !0;
        try {
          await r.value.onConfirm();
        } finally {
          t.value = !1;
        }
      }
      o(!0);
    }
    function z() {
      r.value.onCancel?.(), o(!1);
    }
    return (P, R) => (l(), _(Mr, {
      visible: a.value,
      "onUpdate:visible": R[0] || (R[0] = (Z) => a.value = Z),
      header: h.value,
      closable: !1,
      width: S.value,
      maxWidth: "sm",
      zIndex: 3e3,
      "content-class": T.value
    }, {
      default: ie(() => [
        i("div", Hs, [
          i("div", {
            class: E(["confirmation-icon relative flex items-center justify-center w-20 h-20 rounded-full mb-5 transition-transform hover:scale-105 duration-300", f.value])
          }, [
            i("div", {
              class: E(["absolute inset-0 rounded-full animate-ping opacity-20", u.value])
            }, null, 2),
            U(X, {
              name: c.value,
              class: "relative z-10",
              size: 40
            }, null, 8, ["name"])
          ], 2),
          i("p", Ws, I(v.value), 1),
          $.value ? (l(), s("p", Os, I($.value), 1)) : k("", !0),
          m.value || d.value || y.value || g.value && g.value.length > 0 ? (l(), s("div", {
            key: 1,
            class: E(["confirmation-details w-full border rounded-xl p-3 mb-6 text-left animate-in fade-in slide-in-from-top-1", { "overflow-y-auto min-h-0": r.value.scrollable }]),
            style: oe(r.value.scrollable ? { maxHeight: r.value.maxHeight || "200px" } : {})
          }, [
            d.value && d.value.length > 0 ? (l(), s("div", js, [
              (l(!0), s(le, null, de(d.value, (Z, C) => (l(), s("div", {
                key: C,
                class: E(["flex justify-between items-center text-xs group", Z.class])
              }, [
                i("span", Fs, I(Z.label), 1),
                i("span", Ks, I(Z.value), 1)
              ], 2))), 128))
            ])) : k("", !0),
            m.value && d.value && d.value.length > 0 ? (l(), s("div", Ns)) : k("", !0),
            i("div", Us, [
              r.value.showInfoIcon ? (l(), _(X, {
                key: 0,
                name: "Info",
                class: "text-gray-400 mt-1 shrink-0",
                size: 10
              })) : k("", !0),
              i("div", qs, [
                m.value ? (l(), s("p", Xs, I(m.value), 1)) : k("", !0),
                g.value && g.value.length > 0 ? (l(), s("ul", Ys, [
                  (l(!0), s(le, null, de(g.value, (Z, C) => (l(), s("li", {
                    key: C,
                    class: "flex gap-2.5 py-0.5 transition-colors"
                  }, [
                    i("div", Zs, [
                      j(Z).label ? (l(), s("span", Gs, I(j(Z).label), 1)) : k("", !0),
                      i("span", Js, I(j(Z).text), 1)
                    ])
                  ]))), 128))
                ])) : k("", !0)
              ])
            ]),
            y.value ? (l(), s("div", Qs, [
              U(X, {
                name: "Lightbulb",
                size: "12",
                class: "text-amber-500 mt-0.5 shrink-0"
              }),
              i("span", _s, I(y.value), 1)
            ])) : k("", !0)
          ], 6)) : k("", !0),
          i("div", eo, [
            U(ze, {
              label: L.value,
              variant: "secondary",
              onClick: z,
              class: "confirmation-cancel w-full font-bold"
            }, null, 8, ["label"]),
            U(ze, {
              label: x.value,
              variant: b.value,
              onClick: N,
              loading: t.value,
              disabled: r.value.confirmDisabled,
              class: "confirmation-confirm w-full shadow-md font-bold transition-all hover:-translate-y-0.5"
            }, null, 8, ["label", "variant", "loading", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header", "width", "content-class"]));
  }
}), Xi = /* @__PURE__ */ ge(to, [["__scopeId", "data-v-37913de4"]]), ao = { key: 0 }, lo = ["title"], no = {
  key: 0,
  class: "text-gray-500"
}, ro = {
  key: 1,
  class: "text-blue-400"
}, so = {
  key: 2,
  class: "text-orange-400"
}, oo = {
  key: 3,
  class: "text-gray-500"
}, io = { key: 1 }, uo = { class: "shrink-0 text-[8px] leading-none text-gray-500 select-none" }, co = { class: "text-gray-400" }, fo = { class: "text-[11px]" }, mo = {
  key: 0,
  class: "text-purple-300"
}, vo = {
  key: 1,
  class: "text-gray-500"
}, bo = {
  key: 2,
  class: "text-gray-600"
}, go = {
  key: 0,
  class: "text-gray-500"
}, ho = { class: "text-gray-400" }, yo = {
  key: 1,
  class: "text-gray-400"
}, po = { class: "ml-4" }, xo = {
  key: 0,
  class: "text-purple-400"
}, wo = {
  key: 1,
  class: "text-gray-600"
}, ko = {
  key: 2,
  class: "text-gray-600"
}, $o = { class: "text-gray-400" }, Mt = 3, Et = 24, Yi = /* @__PURE__ */ re({
  __name: "JsonViewer",
  props: {
    data: {},
    depth: { default: 0 },
    expandDepth: { default: -1 },
    stringTruncateThreshold: { default: 80 }
  },
  setup(e) {
    const n = e, a = A(n.expandDepth === -1 || n.depth < n.expandDepth), t = A(!1), r = w(() => n.data === null ? "null" : Array.isArray(n.data) ? "array" : typeof n.data), o = w(() => r.value === "object" || r.value === "array"), c = w(() => r.value === "array" ? n.data.map((d, y) => [String(y), d]) : r.value === "object" ? Object.entries(n.data) : []), f = w(() => c.value.length), u = w(() => r.value === "array" ? ["[", "]"] : ["{", "}"]), b = w(() => c.value.slice(0, Mt)), h = w(() => f.value > Mt);
    function v(d) {
      return d === null ? "null" : Array.isArray(d) ? `Array(${d.length})` : typeof d == "object" ? "{...}" : typeof d == "string" ? `'${d.length > Et ? `${d.slice(0, Et)}...` : d}'` : String(d);
    }
    function $(d) {
      return d === null || d !== null && typeof d == "object" ? "other" : typeof d;
    }
    const m = w(() => r.value === "string" && n.data.length > n.stringTruncateThreshold), g = w(() => {
      if (r.value !== "string") return "";
      const d = n.data;
      return !m.value || t.value ? d : d.slice(0, n.stringTruncateThreshold);
    });
    return (d, y) => {
      const x = _t("JsonViewer", !0);
      return o.value ? (l(), s("span", io, [
        i("button", {
          class: "inline-flex items-center gap-1 transition-opacity hover:opacity-70",
          onClick: y[1] || (y[1] = ve((L) => a.value = !a.value, ["stop"]))
        }, [
          i("span", uo, I(a.value ? "▼" : "▶"), 1),
          a.value ? (l(), s("span", yo, I(u.value[0]), 1)) : (l(), s(le, { key: 0 }, [
            i("span", co, I(u.value[0]), 1),
            i("span", fo, [
              (l(!0), s(le, null, de(b.value, ([L, S], T) => (l(), s(le, { key: L }, [
                r.value === "object" ? (l(), s("span", mo, I(L), 1)) : (l(), s("span", vo, I(L), 1)),
                y[2] || (y[2] = i("span", { class: "text-gray-500" }, ": ", -1)),
                i("span", {
                  class: E({
                    "text-emerald-400": $(S) === "string",
                    "text-blue-400": $(S) === "number",
                    "text-orange-400": $(S) === "boolean",
                    "text-gray-500": $(S) === "other"
                  })
                }, I(v(S)), 3),
                T < b.value.length - 1 ? (l(), s("span", bo, ", ")) : k("", !0)
              ], 64))), 128)),
              h.value ? (l(), s("span", go, ", ...")) : k("", !0)
            ]),
            i("span", ho, I(u.value[1]), 1)
          ], 64))
        ]),
        a.value ? (l(), s(le, { key: 0 }, [
          i("div", po, [
            (l(!0), s(le, null, de(c.value, ([L, S], T) => (l(), s("div", {
              key: L,
              class: "leading-relaxed"
            }, [
              r.value === "object" ? (l(), s("span", xo, '"' + I(L) + '"', 1)) : (l(), s("span", wo, I(L), 1)),
              y[3] || (y[3] = i("span", { class: "text-gray-500" }, ": ", -1)),
              U(x, {
                data: S,
                depth: e.depth + 1,
                "expand-depth": e.expandDepth
              }, null, 8, ["data", "depth", "expand-depth"]),
              T < c.value.length - 1 ? (l(), s("span", ko, ",")) : k("", !0)
            ]))), 128))
          ]),
          i("span", $o, I(u.value[1]), 1)
        ], 64)) : k("", !0)
      ])) : (l(), s("span", ao, [
        r.value === "string" ? (l(), s("span", {
          key: 0,
          title: m.value && !t.value ? e.data : void 0,
          class: E(["text-emerald-400", m.value && !t.value ? "cursor-pointer hover:opacity-70" : "whitespace-pre-wrap break-words"]),
          onClick: y[0] || (y[0] = ve((L) => m.value && (t.value = !t.value), ["stop"]))
        }, [
          Be(' "' + I(g.value) + '"', 1),
          m.value && !t.value ? (l(), s("span", no, "...")) : k("", !0)
        ], 10, lo)) : r.value === "number" ? (l(), s("span", ro, I(e.data), 1)) : r.value === "boolean" ? (l(), s("span", so, I(e.data), 1)) : (l(), s("span", oo, "null"))
      ]));
    };
  }
}), Co = {
  key: 0,
  class: "px-2 pt-2 pb-1.5"
}, Lo = { class: "relative" }, So = ["placeholder"], zo = {
  key: 1,
  class: "px-2 pb-1 flex justify-end"
}, Bo = {
  key: 2,
  class: "mb-1"
}, To = { class: "ml-auto font-normal normal-case tracking-normal opacity-60" }, Mo = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], Eo = ["draggable", "onClick", "onDragstart", "onDragover", "onDrop"], Io = { class: "text-sm truncate flex-1" }, Vo = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, Do = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, Po = {
  key: 3,
  class: "px-3 py-6 text-center text-sm text-gray-400 dark:text-gray-500"
}, Ao = ["data-tree-id", "onClick", "onDblclick"], Ro = { class: "py-1.5 text-sm truncate flex-1" }, Ho = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, Wo = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, Oo = ["data-tree-id", "draggable", "onClick", "onDragstart", "onDragover", "onDrop"], jo = ["onClick"], Fo = { class: "text-xs tracking-wide text-gray-700 dark:text-gray-200 flex-1 truncate" }, Ko = {
  key: 0,
  class: "text-[10px] text-gray-400 shrink-0"
}, No = {
  key: 0,
  class: "hidden group-hover:flex shrink-0 items-center gap-0.5 ml-auto pr-1"
}, Uo = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], qo = ["draggable", "onClick", "onDblclick", "onDragstart", "onDragover", "onDrop"], Xo = { class: "py-1.5 text-sm truncate flex-1" }, Yo = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, Zo = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, vt = "__favs__", It = 40, Go = 8, Jo = /* @__PURE__ */ re({
  name: "TreeList",
  __name: "TreeList",
  props: {
    nodes: {},
    selectedId: {},
    defaultCollapsed: { default: () => [] },
    collapseKey: {},
    draggable: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    showFavourites: { type: Boolean, default: !1 },
    favouriteIds: { default: () => [] },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: {},
    flatViewToggle: { type: Boolean, default: !1 },
    filterPredicate: {},
    sortPredicate: {},
    swipeActions: { type: Boolean, default: !1 },
    swipeRevealWidth: { default: 120 },
    bareItems: { type: Boolean, default: !1 },
    canDrag: {},
    canDrop: {},
    enrichDrag: {}
  },
  emits: ["select", "toggle", "reorder", "move", "reorderFavourites", "dblclick"],
  setup(e, { expose: n, emit: a }) {
    const t = e, r = a;
    function o() {
      if (t.collapseKey)
        try {
          const M = localStorage.getItem(t.collapseKey);
          if (M) {
            const V = JSON.parse(M);
            if (Array.isArray(V)) return new Set(V);
          }
        } catch {
        }
      return new Set(t.defaultCollapsed);
    }
    const c = A(o());
    be(c, (M) => {
      if (t.collapseKey)
        try {
          localStorage.setItem(t.collapseKey, JSON.stringify([...M]));
        } catch {
        }
    }, { deep: !0 }), be(() => t.collapseKey, () => {
      c.value = o();
    });
    function f(M) {
      return c.value.has(M);
    }
    function u(M) {
      const V = new Set(c.value);
      V.has(M) ? V.delete(M) : V.add(M), c.value = V, r("toggle", M, !V.has(M));
    }
    function b(M, V, p) {
      for (const O of M)
        p.push({ node: O, depth: V }), O.type === "group" && O.children?.length && !f(O.id) && b(O.children, V + 1, p);
    }
    const h = w(() => {
      const M = [];
      return b(t.nodes, 0, M), M;
    }), v = A(""), $ = A(!1), m = w(() => t.searchable && v.value.trim().length > 0), g = w(() => m.value || $.value);
    function d(M, V) {
      return M.label.toLowerCase().includes(V.toLowerCase());
    }
    const y = w(() => {
      if (!g.value) return [];
      const M = [];
      function V(se) {
        for (const ye of se)
          ye.type === "item" && ye.meta?.kind !== "load-more" && M.push(ye), ye.children?.length && V(ye.children);
      }
      V(t.nodes);
      const p = v.value.trim(), O = t.filterPredicate ?? d, H = p ? M.filter((se) => O(se, p)) : M;
      return t.sortPredicate ? [...H].sort(t.sortPredicate) : H;
    });
    function x(M) {
      function V(p, O) {
        for (const H of p) {
          if (H.id === M) return O;
          if (H.children?.length) {
            const se = V(H.children, [...O, H.id]);
            if (se) return se;
          }
        }
        return null;
      }
      return V(t.nodes, []);
    }
    const L = w(() => {
      if (!t.showFavourites || !t.favouriteIds?.length) return [];
      const M = /* @__PURE__ */ new Map();
      function V(p) {
        for (const O of p)
          O.type === "item" && t.favouriteIds.includes(O.id) && M.set(O.id, O), O.children && V(O.children);
      }
      return V(t.nodes), t.favouriteIds.map((p) => M.get(p)).filter((p) => !!p);
    }), S = w({
      get: () => c.value.has(vt),
      set: (M) => {
        const V = new Set(c.value);
        M ? V.add(vt) : V.delete(vt), c.value = V;
      }
    });
    function T(M) {
      function V(p) {
        for (const O of p) {
          if (O.id === M) return O;
          if (O.children?.length) {
            const H = V(O.children);
            if (H) return H;
          }
        }
        return null;
      }
      return V(t.nodes);
    }
    function j(M) {
      function V(p, O) {
        for (const H of p) {
          if (H.id === M) return O;
          if (H.children?.length) {
            const se = V(H.children, H.type === "group" ? H : O);
            if (se !== void 0) return se;
          }
        }
      }
      return V(t.nodes, null) ?? null;
    }
    function N(M, V) {
      if (M === V) return !0;
      const p = T(V);
      if (!p?.children?.length) return !1;
      function O(H) {
        for (const se of H)
          if (se.id === M || se.children?.length && O(se.children)) return !0;
        return !1;
      }
      return O(p.children);
    }
    const z = A(null), P = A(null), R = A(null), Z = A("before"), C = A(!1), D = w(() => Z.value === "after" ? "after" : "before"), B = w(() => {
      if (!R.value || Z.value !== "into") return /* @__PURE__ */ new Set();
      const M = T(R.value);
      if (!M || M.type !== "group") return /* @__PURE__ */ new Set();
      const V = /* @__PURE__ */ new Set([R.value]);
      function p(O) {
        for (const H of O)
          V.add(H.id), H.type === "group" && H.children?.length && !f(H.id) && p(H.children);
      }
      return M.children?.length && !f(M.id) && p(M.children), V;
    });
    function F() {
      z.value = null, P.value = null, R.value = null, C.value = !1, _e();
    }
    function me(M, V, p = "tree") {
      if (t.draggable) {
        if (t.canDrag && !t.canDrag(V)) {
          M.preventDefault();
          return;
        }
        z.value = V, P.value = p, M.dataTransfer && (M.dataTransfer.effectAllowed = "move"), t.enrichDrag?.(V, M);
      }
    }
    function ue(M, V, p = "tree") {
      if (!t.reorderable || !z.value || z.value === V || P.value !== p || p === "tree" && N(V, z.value)) return;
      const O = M.currentTarget.getBoundingClientRect(), H = M.clientY - O.top, se = O.height, ye = p === "tree" ? T(V) : null, Ue = p === "tree" ? T(z.value) : null;
      let Se = V, Ae;
      if (ye?.type === "group")
        if (Ue?.type === "group")
          Ae = H < se * 0.25 ? "before" : H > se * 0.75 ? "after" : "into";
        else {
          const et = !f(V) && !!ye.children?.length;
          Ae = H > se * 0.75 && et ? "after" : "into";
        }
      else if (Ue?.type === "group" && p === "tree") {
        const et = j(V);
        et && !N(et.id, z.value) ? (Se = et.id, Ae = "into") : (Se = null, Ae = "before");
      } else
        Ae = H < se / 2 ? "before" : "after";
      if (!Se || t.canDrop && !t.canDrop(z.value, Se, Ae)) {
        Se ? (M.preventDefault(), M.dataTransfer && (M.dataTransfer.dropEffect = "none"), R.value = Se, Z.value = Ae, C.value = !0) : (R.value = null, C.value = !1);
        return;
      }
      M.preventDefault(), R.value = Se, Z.value = Ae, C.value = !1, Ke(M);
    }
    function ce() {
      R.value = null, C.value = !1;
    }
    function pe(M, V, p = "tree") {
      if (C.value) {
        F();
        return;
      }
      if (!(!t.reorderable || !z.value || z.value === V)) {
        if (P.value !== p) {
          F();
          return;
        }
        if (p === "tree" && N(V, z.value)) {
          F();
          return;
        }
        if (M.preventDefault(), p === "favs") {
          const O = L.value.map((Se) => Se.id), H = z.value, se = O.filter((Se) => Se !== H), ye = se.indexOf(V);
          if (ye === -1) {
            F();
            return;
          }
          const Ue = Z.value === "before" ? ye : ye + 1;
          se.splice(Ue, 0, H), r("reorderFavourites", se);
        } else {
          const O = Z.value, H = R.value ?? V;
          if (N(H, z.value)) {
            F();
            return;
          }
          const se = O === "into" ? { intoGroup: !0, groupId: H } : {
            ...O === "before" ? { beforeId: H } : { afterId: H },
            parentGroupId: j(H)?.id ?? void 0
          };
          r("move", z.value, se), O !== "into" && r("reorder", z.value, H, O);
        }
        F();
      }
    }
    function q() {
      F();
    }
    let G = null, ee = 0, he = null;
    function Oe(M) {
      let V = M;
      for (; V && V !== document.body; ) {
        const p = getComputedStyle(V);
        if (/(auto|scroll|overlay)/.test(p.overflowY)) return V;
        V = V.parentElement;
      }
      return null;
    }
    function Ke(M) {
      if (he || (he = Oe(xe.value)), !he) return;
      const V = he.getBoundingClientRect();
      if (M.clientY < V.top + It ? ee = -1 : M.clientY > V.bottom - It ? ee = 1 : ee = 0, ee !== 0 && G === null) {
        const p = () => {
          if (ee === 0 || !he) {
            G = null;
            return;
          }
          he.scrollTop += ee * Go, G = requestAnimationFrame(p);
        };
        G = requestAnimationFrame(p);
      }
    }
    function _e() {
      G !== null && (cancelAnimationFrame(G), G = null), ee = 0, he = null;
    }
    const J = A(null), Y = A(0), ae = A(!1);
    let Ce = null, Te = null;
    function W() {
      J.value === null && Y.value === 0 || (ae.value = !0, Y.value = 0, J.value = null, setTimeout(() => {
        ae.value = !1;
      }, 200));
    }
    function Q(M, V) {
      if (!t.swipeActions) return;
      const p = M.touches[0];
      if (!p) return;
      const O = J.value === V ? Y.value : 0;
      J.value && J.value !== V && W(), Ce = { x: p.clientX, y: p.clientY, id: V, baseDx: O }, Te = null, ae.value = !1;
    }
    function ne(M, V) {
      if (!t.swipeActions || !Ce || Ce.id !== V) return;
      const p = M.touches[0];
      if (!p) return;
      const O = p.clientX - Ce.x, H = p.clientY - Ce.y;
      if (Te === null) {
        const se = Math.abs(O), ye = Math.abs(H);
        se > 8 && se > ye ? Te = "h" : ye > 8 && (Te = "v");
      }
      if (Te === "h") {
        M.cancelable && M.preventDefault();
        const se = Ce.baseDx + O;
        Y.value = Math.max(-t.swipeRevealWidth, Math.min(0, se)), J.value = V;
      }
    }
    function fe(M) {
      if (t.swipeActions) {
        if (Te !== "h") {
          Ce = null, Te = null;
          return;
        }
        Ce = null, Te = null, ae.value = !0, Y.value < -t.swipeRevealWidth / 2 ? (Y.value = -t.swipeRevealWidth, J.value = M) : (Y.value = 0, J.value = null), setTimeout(() => {
          ae.value = !1;
        }, 200);
      }
    }
    function ke(M) {
      return J.value === M ? Y.value : 0;
    }
    const xe = A(null);
    async function Me(M, V = { behavior: "smooth", block: "nearest" }) {
      const p = x(M);
      if (p === null) return;
      if (p.length) {
        const se = new Set(c.value);
        let ye = !1;
        for (const Ue of p)
          se.delete(Ue) && (ye = !0);
        ye && (c.value = se);
      }
      await we();
      const O = xe.value;
      if (!O) return;
      const H = O.querySelector(`[data-tree-id="${CSS.escape(M)}"]`);
      H && H.scrollIntoView(V);
    }
    function Ee(M) {
      if (!c.value.has(M)) return;
      const V = new Set(c.value);
      V.delete(M), c.value = V;
    }
    function Ne(M) {
      if (c.value.has(M)) return;
      const V = new Set(c.value);
      V.add(M), c.value = V;
    }
    n({ scrollIntoView: Me, expand: Ee, collapse: Ne, closeSwipe: W });
    function Pe(M) {
      return M > 0 ? { paddingLeft: `${8 + M * 14}px` } : void 0;
    }
    return (M, V) => (l(), s("div", {
      ref_key: "rootRef",
      ref: xe,
      class: E(["tree-list relative flex flex-col select-none", { "gap-1": e.bareItems }])
    }, [
      e.searchable ? (l(), s("div", Co, [
        i("div", Lo, [
          U(X, {
            name: "Search",
            size: 13,
            class: "absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          }),
          xt(i("input", {
            "onUpdate:modelValue": V[0] || (V[0] = (p) => v.value = p),
            type: "text",
            placeholder: e.searchPlaceholder ?? "Search...",
            class: "w-full pl-8 pr-7 py-1.5 text-sm bg-gray-100 dark:bg-dark-200 rounded-md outline-none focus:ring-1 focus:ring-primary/40 text-gray-800 dark:text-gray-200 placeholder-gray-400"
          }, null, 8, So), [
            [Rt, v.value]
          ]),
          v.value ? (l(), s("button", {
            key: 0,
            onClick: V[1] || (V[1] = (p) => v.value = ""),
            class: "absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded transition-colors"
          }, [
            U(X, {
              name: "X",
              size: 11
            })
          ])) : k("", !0)
        ])
      ])) : k("", !0),
      e.flatViewToggle && !m.value ? (l(), s("div", zo, [
        i("button", {
          onClick: V[2] || (V[2] = (p) => $.value = !$.value),
          class: "text-[10px] uppercase tracking-wider text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex items-center gap-1 px-1.5 py-0.5 rounded transition-colors"
        }, [
          U(X, {
            name: $.value ? "List" : "FolderTree",
            size: 11
          }, null, 8, ["name"]),
          Be(" " + I($.value ? "Flat" : "Tree"), 1)
        ])
      ])) : k("", !0),
      e.showFavourites && L.value.length && !m.value ? (l(), s("div", Bo, [
        i("button", {
          class: "w-full flex items-center gap-1.5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors rounded-md",
          onClick: V[3] || (V[3] = (p) => S.value = !S.value)
        }, [
          U(X, {
            name: S.value ? "ChevronRight" : "ChevronDown",
            size: 10,
            class: "shrink-0"
          }, null, 8, ["name"]),
          U(X, {
            name: "Star",
            size: 10,
            class: "shrink-0 text-amber-400"
          }),
          V[4] || (V[4] = i("span", null, "Favourites", -1)),
          i("span", To, I(L.value.length), 1)
        ]),
        S.value ? k("", !0) : (l(), _(Je, {
          key: 0,
          name: "tree-row",
          tag: "div",
          class: "space-y-0.5 mt-0.5"
        }, {
          default: ie(() => [
            (l(!0), s(le, null, de(L.value, (p) => (l(), s("div", {
              key: "fav-" + p.id,
              "data-tree-id": "fav-" + p.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (O) => Q(O, "fav-" + p.id),
              onTouchmove: (O) => ne(O, "fav-" + p.id),
              onTouchend: (O) => fe("fav-" + p.id)
            }, [
              e.swipeActions && M.$slots["swipe-actions"] && J.value === "fav-" + p.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: oe({ width: e.swipeRevealWidth + "px" })
              }, [
                K(M.$slots, "swipe-actions", {
                  node: p,
                  close: W
                }, void 0, !0)
              ], 4)) : k("", !0),
              i("div", {
                class: E(["group/item relative", [
                  e.bareItems ? "block cursor-pointer min-w-0" : "flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors",
                  !e.bareItems && (e.selectedId === p.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  !e.bareItems && (e.draggable ? "cursor-grab active:cursor-grabbing" : "cursor-pointer"),
                  R.value === p.id && P.value === "favs" && D.value === "before" ? "border-t-2 border-primary" : "",
                  R.value === p.id && P.value === "favs" && D.value === "after" ? "border-b-2 border-primary" : ""
                ]]),
                style: oe({
                  transform: e.swipeActions ? `translateX(${ke("fav-" + p.id)}px)` : void 0,
                  transition: e.swipeActions && ae.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (O) => r("select", p.id, !0),
                onDragstart: (O) => me(O, p.id, "favs"),
                onDragover: (O) => ue(O, p.id, "favs"),
                onDragleave: ce,
                onDrop: (O) => pe(O, p.id, "favs"),
                onDragend: q
              }, [
                K(M.$slots, "item", {
                  node: p,
                  selected: e.selectedId === p.id,
                  depth: 0,
                  isFav: !0
                }, () => [
                  p.icon ? (l(), _(X, {
                    key: 0,
                    name: p.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : k("", !0),
                  i("span", Io, I(p.label), 1),
                  p.badge !== void 0 ? (l(), s("span", Vo, I(p.badge), 1)) : k("", !0)
                ], !0),
                M.$slots["item-actions"] ? (l(), s("div", Do, [
                  K(M.$slots, "item-actions", { node: p }, void 0, !0)
                ])) : k("", !0)
              ], 46, Eo)
            ], 42, Mo))), 128))
          ]),
          _: 3
        }))
      ])) : k("", !0),
      (g.value ? y.value.length === 0 : h.value.length === 0) ? (l(), s("div", Po, [
        K(M.$slots, "empty", {
          searching: m.value,
          query: v.value
        }, () => [
          Be(I(m.value ? "No matches" : "No items"), 1)
        ], !0)
      ])) : k("", !0),
      g.value ? (l(!0), s(le, { key: 4 }, de(y.value, (p) => (l(), s("div", {
        key: "flat-" + p.id,
        "data-tree-id": p.id,
        class: E(["group/item relative flex items-center cursor-pointer", [
          e.bareItems ? "" : "gap-2 rounded-md transition-colors px-2",
          !e.bareItems && (e.selectedId === p.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200")
        ]]),
        onClick: (O) => r("select", p.id),
        onDblclick: (O) => r("dblclick", p.id)
      }, [
        K(M.$slots, "item", {
          node: p,
          selected: e.selectedId === p.id,
          depth: 0,
          isFav: !1
        }, () => [
          p.icon ? (l(), _(X, {
            key: 0,
            name: p.icon,
            size: 13,
            class: "shrink-0 text-gray-400"
          }, null, 8, ["name"])) : k("", !0),
          i("span", Ro, I(p.label), 1),
          p.badge !== void 0 ? (l(), s("span", Ho, I(p.badge), 1)) : k("", !0)
        ], !0),
        M.$slots["item-actions"] ? (l(), s("div", Wo, [
          K(M.$slots, "item-actions", { node: p }, void 0, !0)
        ])) : k("", !0)
      ], 42, Ao))), 128)) : (l(), _(Je, {
        key: 5,
        name: "tree-row",
        tag: "div",
        class: E(["flex flex-col min-w-0", { "gap-1": e.bareItems }])
      }, {
        default: ie(() => [
          (l(!0), s(le, null, de(h.value, ({ node: p, depth: O }) => (l(), s(le, {
            key: p.id
          }, [
            p.type === "group" ? (l(), s("div", {
              key: 0,
              "data-tree-id": p.id,
              class: E(["group flex items-center gap-1 rounded-md transition-colors pr-2 shrink-0", [
                O === 0 ? "h-8 pl-2 font-semibold" : "h-7 font-medium",
                "hover:bg-gray-100 dark:hover:bg-dark-200",
                e.draggable && (!e.canDrag || e.canDrag(p.id)) ? "cursor-grab active:cursor-grabbing" : "cursor-pointer",
                P.value === "tree" && R.value === p.id && Z.value === "into" && !C.value ? "ring-2 ring-primary/60 bg-primary/5" : "",
                P.value === "tree" && R.value === p.id && Z.value === "into" && C.value ? "ring-2 ring-red-400/50 bg-red-500/5" : "",
                P.value === "tree" && R.value === p.id && Z.value === "before" && !C.value ? "border-t-2 border-primary" : "",
                P.value === "tree" && R.value === p.id && Z.value === "after" && !C.value ? "border-b-2 border-primary" : "",
                P.value === "tree" && B.value.has(p.id) && R.value !== p.id && !C.value ? "bg-primary/5" : "",
                P.value === "tree" && B.value.has(p.id) && R.value !== p.id && C.value ? "bg-red-500/5" : ""
              ]]),
              style: oe(Pe(O)),
              draggable: e.draggable && (!e.canDrag || e.canDrag(p.id)),
              onClick: (H) => r("select", p.id),
              onDragstart: (H) => me(H, p.id),
              onDragover: (H) => ue(H, p.id),
              onDragleave: ce,
              onDrop: (H) => pe(H, p.id),
              onDragend: q
            }, [
              K(M.$slots, "group-header", {
                node: p,
                collapsed: f(p.id),
                depth: O,
                toggle: () => u(p.id)
              }, () => [
                i("button", {
                  class: "shrink-0 p-0.5 -ml-0.5 rounded hover:bg-black/10 dark:hover:bg-white/10 transition-colors",
                  onClick: ve((H) => u(p.id), ["stop"])
                }, [
                  U(X, {
                    name: f(p.id) ? "ChevronRight" : "ChevronDown",
                    size: O === 0 ? 12 : 10,
                    class: "text-gray-500 dark:text-gray-400 transition-transform duration-150"
                  }, null, 8, ["name", "size"])
                ], 8, jo),
                U(X, {
                  name: p.meta?.loading ? "Loader2" : p.icon ?? (O === 0 ? "Folder" : "FolderOpen"),
                  size: O === 0 ? 12 : 10,
                  class: E(["shrink-0 text-gray-500 dark:text-gray-400", p.meta?.loading ? "animate-spin" : ""])
                }, null, 8, ["name", "size", "class"]),
                i("span", Fo, [
                  K(M.$slots, "group-label", {
                    node: p,
                    depth: O
                  }, () => [
                    Be(I(p.label), 1)
                  ], !0)
                ]),
                p.badge !== void 0 ? (l(), s("span", Ko, I(p.badge), 1)) : k("", !0)
              ], !0),
              M.$slots["group-actions"] ? (l(), s("div", No, [
                K(M.$slots, "group-actions", { node: p }, void 0, !0)
              ])) : k("", !0)
            ], 46, Oo)) : (l(), s("div", {
              key: 1,
              "data-tree-id": p.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (H) => Q(H, p.id),
              onTouchmove: (H) => ne(H, p.id),
              onTouchend: (H) => fe(p.id)
            }, [
              e.swipeActions && M.$slots["swipe-actions"] && J.value === p.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: oe({ width: e.swipeRevealWidth + "px" })
              }, [
                K(M.$slots, "swipe-actions", {
                  node: p,
                  close: W
                }, void 0, !0)
              ], 4)) : k("", !0),
              i("div", {
                class: E(["group/item relative cursor-pointer min-w-0", [
                  e.bareItems ? "block" : "flex items-center gap-2 rounded-md bg-gray-50 dark:bg-dark-50",
                  !e.bareItems && (e.swipeActions ? "" : "transition-colors"),
                  !e.bareItems && (e.selectedId === p.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  P.value === "tree" && R.value === p.id && D.value === "before" && !C.value ? "border-t-2 border-primary" : "",
                  P.value === "tree" && R.value === p.id && D.value === "after" && !C.value ? "border-b-2 border-primary" : "",
                  P.value === "tree" && B.value.has(p.id) && !C.value ? "bg-primary/5" : "",
                  P.value === "tree" && B.value.has(p.id) && C.value ? "bg-red-500/5" : "",
                  e.draggable ? "cursor-grab active:cursor-grabbing" : ""
                ]]),
                style: oe({
                  paddingLeft: e.bareItems ? `${O * 8}px` : `${8 + O * 14}px`,
                  paddingRight: e.bareItems ? void 0 : "8px",
                  transform: e.swipeActions ? `translateX(${ke(p.id)}px)` : void 0,
                  transition: e.swipeActions && ae.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (H) => r("select", p.id),
                onDblclick: (H) => r("dblclick", p.id),
                onDragstart: (H) => me(H, p.id),
                onDragover: (H) => ue(H, p.id),
                onDragleave: ce,
                onDrop: (H) => pe(H, p.id),
                onDragend: q
              }, [
                K(M.$slots, "item", {
                  node: p,
                  selected: e.selectedId === p.id,
                  depth: O,
                  isFav: !1
                }, () => [
                  p.icon ? (l(), _(X, {
                    key: 0,
                    name: p.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : k("", !0),
                  i("span", Xo, I(p.label), 1),
                  p.badge !== void 0 ? (l(), s("span", Yo, I(p.badge), 1)) : k("", !0)
                ], !0),
                M.$slots["item-actions"] ? (l(), s("div", Zo, [
                  K(M.$slots, "item-actions", { node: p }, void 0, !0)
                ])) : k("", !0)
              ], 46, qo)
            ], 42, Uo))
          ], 64))), 128))
        ]),
        _: 3
      }, 8, ["class"])),
      K(M.$slots, "footer", {}, void 0, !0)
    ], 2));
  }
}), Zi = /* @__PURE__ */ ge(Jo, [["__scopeId", "data-v-49d31aac"]]), Qo = {
  light: {
    primary: "#2563eb",
    primaryLight: "#60a5fa",
    primaryHover: "#1d4ed8",
    primary50: "#eff6ff",
    primary100: "#dbeafe",
    primary200: "#bfdbfe",
    primary300: "#93c5fd",
    primary400: "#60a5fa",
    primary500: "#3b82f6",
    primary600: "#2563eb",
    primary700: "#1d4ed8",
    primary800: "#1e40af",
    primary900: "#1e3a8a",
    surface: "#ffffff",
    surfaceMuted: "#f9fafb",
    surfaceElevated: "#ffffff",
    surfaceInverse: "#111827",
    tooltipSurface: "#1f2937",
    tooltipText: "#f9fafb",
    tooltipBorder: "#374151",
    shadow: "rgba(15, 23, 42, 0.18)",
    text: "#111827",
    confirmationTitle: "#111827",
    textMuted: "#6b7280",
    textDim: "#9ca3af",
    border: "#e5e7eb",
    borderStrong: "#d1d5db",
    scrollbarThumb: "#cbd5e1",
    scrollbarThumbHover: "#94a3b8",
    scrollbarTrack: "transparent",
    focus: "#2563eb",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626",
    info: "#2563eb"
  },
  dark: {
    primary: "#60a5fa",
    primaryLight: "#93c5fd",
    primaryHover: "#3b82f6",
    primary500: "#60a5fa",
    surface: "#111827",
    surfaceMuted: "#0f172a",
    surfaceElevated: "#1f2937",
    surfaceInverse: "#ffffff",
    tooltipSurface: "#121f28",
    tooltipText: "#e5edf8",
    tooltipBorder: "#385163",
    shadow: "rgba(0, 0, 0, 0.55)",
    text: "#f9fafb",
    confirmationTitle: "#f3f4f6",
    textMuted: "#d1d5db",
    textDim: "#9ca3af",
    border: "#1f2937",
    borderStrong: "#374151",
    scrollbarThumb: "#475569",
    scrollbarThumbHover: "#64748b",
    scrollbarTrack: "transparent",
    focus: "#93c5fd",
    success: "#4ade80",
    warning: "#fbbf24",
    danger: "#f87171",
    info: "#93c5fd",
    dark50: "#0f172a",
    dark100: "#111827",
    dark200: "#1f2937",
    dark300: "#374151",
    darkText: "#f9fafb",
    darkTextMuted: "#d1d5db",
    darkTextDim: "#9ca3af"
  }
}, Vt = "luna-vue-ui-theme";
function _o(e) {
  return `--color-${e.replace(/[A-Z]/g, (a) => `-${a.toLowerCase()}`).replace(/([a-z])([0-9])/g, "$1-$2")}`;
}
function Dt(e) {
  return e ? Object.entries(e).filter((n) => typeof n[1] == "string" && n[1].length > 0).map(([n, a]) => `  ${_o(n)}: ${a};`).join(`
`) : "";
}
function ei(e = Qo) {
  if (typeof document > "u") return;
  let n = document.getElementById(Vt);
  n || (n = document.createElement("style"), n.id = Vt, n.dataset.vueUiTheme = "true", document.head.appendChild(n));
  const a = Dt(e.light), t = Dt(e.dark);
  n.textContent = [
    a ? `:root {
${a}
}` : "",
    t ? `.dark {
${t}
}` : ""
  ].filter(Boolean).join(`
`);
}
function ti(e = {}) {
  return {
    install(n) {
      n.provide(Wt, Ot(e.icons)), n.directive("base-hover-label", it), n.directive("basehoverlabel", it), n.directive("base-tooltip", it), n.directive("basetooltip", it), e.theme && ei(e.theme);
    }
  };
}
const Gi = ti();
function ai(e) {
  return typeof DOMException < "u" && e instanceof DOMException && e.name === "AbortError";
}
function li() {
  const e = A(!1), n = A(null);
  let a = 0, t = null;
  const r = () => {
    a += 1, t?.abort(), t = null, e.value = !1;
  };
  return { loading: e, error: n, run: async (c) => {
    r();
    const f = a, u = new AbortController();
    t = u, n.value = null, e.value = !0;
    try {
      const b = await c(u.signal);
      return f === a ? b : void 0;
    } catch (b) {
      if (f === a && !u.signal.aborted && !ai(b))
        throw n.value = b, b;
      return;
    } finally {
      f === a && (t = null, e.value = !1);
    }
  }, cancel: r };
}
function Ji(e) {
  const n = ea([]), a = A(0), t = A(Math.max(1, e.page ?? 1)), r = A(Math.max(1, e.pageSize ?? 10)), o = li(), c = w(() => Math.max(1, Math.ceil(a.value / r.value))), f = w(() => t.value > 1), u = w(() => t.value < c.value), b = async (g = {}) => {
    const d = Math.max(1, g.page ?? t.value), y = Math.max(1, g.pageSize ?? r.value);
    t.value = d, r.value = y;
    const x = await o.run((L) => e.fetcher({ page: d, pageSize: y, signal: L }));
    return x && (n.value = x.items, a.value = Math.max(0, x.total)), x;
  }, h = (g) => b({ page: g }), v = (g) => b({ page: 1, pageSize: g }), $ = () => {
    o.cancel(), n.value = [], a.value = 0, t.value = Math.max(1, e.page ?? 1), r.value = Math.max(1, e.pageSize ?? 10);
  }, m = {
    items: n,
    total: a,
    page: t,
    pageSize: r,
    totalPages: c,
    hasPrevious: f,
    hasNext: u,
    loading: o.loading,
    error: o.error,
    request: o,
    load: b,
    setPage: h,
    setPageSize: v,
    reset: $
  };
  return e.immediate !== !1 && b(), m;
}
const Ge = A([]);
function tt(e) {
  Ge.value = Ge.value.filter((n) => n.id !== e);
}
function Qi() {
  function e(c) {
    const f = crypto.randomUUID();
    Ge.value = [...Ge.value, { ...c, id: f, startTime: Date.now() }];
    const u = c.life ?? 3e3;
    u > 0 && setTimeout(() => tt(f), u);
  }
  function n(c, f, u = 3e3) {
    e({ severity: "success", summary: c, detail: f, life: u });
  }
  function a(c, f, u = 5e3) {
    e({ severity: "error", summary: c, detail: f, life: u });
  }
  function t(c, f, u = 4e3) {
    e({ severity: "warning", summary: c, detail: f, life: u });
  }
  function r(c, f, u = 3e3) {
    e({ severity: "info", summary: c, detail: f, life: u });
  }
  function o() {
    Ge.value = [];
  }
  return { add: e, success: n, error: a, warning: t, info: r, clear: o };
}
const ni = ["onClick", "onTouchstart", "onTouchmove", "onTouchend"], ri = { class: "toast-content flex items-start" }, si = { class: "toast-icon shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-xl" }, oi = { class: "flex-1 min-w-0" }, ii = {
  key: 0,
  class: "font-semibold text-sm mb-1 text-inherit leading-tight"
}, ui = {
  key: 1,
  class: "text-sm m-0 text-inherit opacity-90 leading-snug wrap-break-word whitespace-pre-wrap"
}, di = ["onClick"], ci = ["onClick"], bt = 80, Pt = 5, fi = /* @__PURE__ */ re({
  __name: "ToastNotification",
  props: {
    position: { default: "top-right" },
    toastClass: {},
    toastStyle: {}
  },
  setup(e) {
    const n = /* @__PURE__ */ new Map();
    function a(v, $) {
      const m = v.touches[0];
      if (!m) return;
      const g = v.currentTarget;
      g.style.transition = "none", n.set($, { startX: m.clientX, startY: m.clientY, el: g, dir: null, locked: !1 });
    }
    function t(v, $) {
      const m = n.get($);
      if (!m) return;
      const g = v.touches[0];
      if (!g) return;
      const d = g.clientX - m.startX, y = g.clientY - m.startY;
      if (!m.locked) {
        if (Math.abs(d) < Pt && Math.abs(y) < Pt) return;
        m.dir = Math.abs(d) >= Math.abs(y) ? "h" : "v", m.locked = !0;
      }
      if (m.dir === "v" && y > 0) return;
      v.preventDefault();
      let x = 0, L = 0;
      m.dir === "h" ? x = d > 0 ? d : d * 0.15 : L = y < 0 ? y : y * 0.15;
      const S = m.dir === "h" ? Math.max(0, d) : Math.max(0, -y), T = Math.max(0.3, 1 - S / bt * 0.7);
      m.el.style.transform = `translate(${x}px,${L}px)`, m.el.style.opacity = String(T);
    }
    function r(v, $) {
      const m = n.get($);
      if (n.delete($), !m) return;
      const g = v.changedTouches[0];
      if (!g) return;
      const d = g.clientX - m.startX, y = g.clientY - m.startY;
      m.dir === "h" && d > bt || m.dir === "v" && y < -bt ? (m.el.style.transition = "transform 0.2s ease-out, opacity 0.2s ease-out", m.el.style.transform = m.dir === "h" ? "translateX(120%)" : "translateY(-120%)", m.el.style.opacity = "0", setTimeout(() => tt($), 200)) : (m.el.style.transition = "transform 0.3s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease", m.el.style.transform = "", m.el.style.opacity = "");
    }
    const o = e, c = w(() => ({
      "top-right": "top-4 right-4 items-end",
      "top-center": "top-4 left-1/2 -translate-x-1/2 items-center",
      "top-left": "top-4 left-4 items-start",
      "bottom-right": "bottom-4 right-4 items-end",
      "bottom-center": "bottom-4 left-1/2 -translate-x-1/2 items-center",
      "bottom-left": "bottom-4 left-4 items-start"
    })[o.position] + " flex flex-col");
    function f(v) {
      return {
        success: "toast-success",
        error: "toast-error",
        warning: "toast-warning",
        info: "toast-info"
      }[v];
    }
    function u(v) {
      return {
        success: "CheckCircle2",
        error: "XCircle",
        warning: "AlertTriangle",
        info: "Info"
      }[v];
    }
    function b(v) {
      return typeof o.toastClass == "function" ? o.toastClass(v) : o.toastClass;
    }
    function h(v) {
      return { ...typeof o.toastStyle == "function" ? o.toastStyle(v) : o.toastStyle, ...v.style };
    }
    return (v, $) => (l(), _(De, { to: "body" }, [
      i("div", {
        class: E(["fixed z-20000 pointer-events-none sm:mx-0 mx-4", c.value])
      }, [
        U(Je, { name: "toast" }, {
          default: ie(() => [
            (l(!0), s(le, null, de(te(Ge), (m) => (l(), s("div", {
              key: m.id,
              class: E(["toast-shell pointer-events-auto mb-3 overflow-hidden relative transition-all duration-300 ease-out hover:-translate-y-0.5 w-full max-w-sm sm:min-w-75", [f(m.severity), m.class, b(m), m.action ? "" : "cursor-pointer"]]),
              style: oe(h(m)),
              onClick: (g) => !m.action && te(tt)(m.id),
              onTouchstart: (g) => a(g, m.id),
              onTouchmove: (g) => t(g, m.id),
              onTouchend: (g) => r(g, m.id)
            }, [
              i("div", ri, [
                i("div", si, [
                  U(X, {
                    name: u(m.severity),
                    size: 24
                  }, null, 8, ["name"])
                ]),
                i("div", oi, [
                  m.summary ? (l(), s("h4", ii, I(m.summary), 1)) : k("", !0),
                  m.detail ? (l(), s("p", ui, I(m.detail), 1)) : k("", !0),
                  m.action ? (l(), s("button", {
                    key: 2,
                    class: "toast-action mt-3 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors cursor-pointer",
                    onClick: ve((g) => {
                      te(tt)(m.id), m.action.onClick();
                    }, ["stop"])
                  }, I(m.action.label) + " → ", 9, di)) : k("", !0)
                ]),
                i("button", {
                  class: "toast-dismiss shrink-0 bg-transparent border-none cursor-pointer p-1 opacity-70 hover:opacity-100 transition-opacity",
                  onClick: ve((g) => te(tt)(m.id), ["stop"])
                }, [
                  U(X, {
                    name: "X",
                    size: 14
                  })
                ], 8, ci)
              ]),
              m.life ? (l(), s("div", {
                key: 0,
                class: "toast-progress h-0.75 absolute bottom-0 left-0 progress-bar",
                style: oe({ animationDuration: `${m.life}ms` })
              }, null, 4)) : k("", !0)
            ], 46, ni))), 128))
          ]),
          _: 1
        })
      ], 2)
    ]));
  }
}), _i = /* @__PURE__ */ ge(fi, [["__scopeId", "data-v-4fd11d07"]]);
export {
  Si as BaseAccordion,
  hi as BaseAlert,
  Hi as BaseAudioPlayer,
  Ri as BaseAutocomplete,
  zi as BaseBreadcrumb,
  ze as BaseButton,
  Ni as BaseCollectionView,
  Ai as BaseContextMenu,
  Mr as BaseDialog,
  ji as BaseDrawer,
  Fi as BaseEditableTable,
  wi as BaseHoverLabel,
  X as BaseIcon,
  je as BaseInput,
  yi as BaseNumberInput,
  Bi as BasePagination,
  Ti as BasePasswordInput,
  kt as BasePopover,
  sl as BasePopoverButton,
  ki as BaseProgressBar,
  $i as BasePullToRefresh,
  Ci as BasePullToRefreshTrigger,
  ht as BaseSelect,
  Mi as BaseSplitButton,
  Li as BaseSwitch,
  Ii as BaseTab,
  Vi as BaseTabList,
  Pi as BaseTabPanel,
  Di as BaseTabPanels,
  Ki as BaseTable,
  Ei as BaseTabs,
  pi as BaseTag,
  xi as BaseTooltip,
  Ui as BatchActionBar,
  Xi as ConfirmationDialog,
  Qo as DEFAULT_VUE_UI_THEME,
  Yi as JsonViewer,
  _i as ToastNotification,
  Zi as TreeList,
  Gi as VueUiPlugin,
  ei as applyVueUiTheme,
  it as baseHoverLabel,
  gi as clearIconRegistry,
  Ve as confirmQueue,
  Ot as createIconRegistry,
  ti as createVueUi,
  Wi as disableCloseWatcherPath,
  Oi as getMobileCloseStack,
  Wt as iconRegistryKey,
  dt as normalizeIconName,
  Da as registerIcon,
  Pa as registerIcons,
  tt as removeToast,
  Aa as resolveIcon,
  Ge as toasts,
  qi as useConfirmDialog,
  Ra as useIconRegistry,
  Ft as useIsMobile,
  li as useLatestRequest,
  br as useMobileHistoryEntry,
  Ji as usePaginatedQuery,
  Rl as usePullToRefresh,
  Ol as usePullToRefreshTrigger,
  Qi as useToast
};
